export const CDP_CORPORATE_INTRO_FIELD_NAMES = {
  CORPORATE_INTRO_Q1_VALUE: 'corporateIntroQ1_value',
  CORPORATE_INTRO_Q2_VALUE: 'corporateIntroQ2_value',
  CORPORATE_INTRO_Q3_VALUE: 'corporateIntroQ3_value',
  CORPORATE_INTRO_Q3_1_VALUE: 'corporateIntroQ3_1_value',
  CORPORATE_INTRO_Q3_2_VALUE: 'corporateIntroQ3_2_value',
  CORPORATE_INTRO_Q3_3_VALUE: 'corporateIntroQ3_3_value',
  CORPORATE_INTRO_Q3_4_VALUE: 'corporateIntroQ3_4_value',
  CORPORATE_INTRO_Q4_VALUE: 'corporateIntroQ4_value',
  CORPORATE_INTRO_Q4_1_VALUE: 'corporateIntroQ4_1_value',
  CORPORATE_INTRO_Q4_2_VALUE: 'corporateIntroQ4_2_value',
  CORPORATE_INTRO_Q4_3_VALUE: 'corporateIntroQ4_3_value',
  CORPORATE_INTRO_Q4_4_VALUE: 'corporateIntroQ4_4_value',
  CORPORATE_INTRO_Q4_5_VALUE: 'corporateIntroQ4_5_value',
  CORPORATE_INTRO_Q4_6_VALUE: 'corporateIntroQ4_6_value',
  CORPORATE_INTRO_Q5_VALUE: 'corporateIntroQ5_value',
  CORPORATE_INTRO_Q6_VALUE: 'corporateIntroQ6_value',
  CORPORATE_INTRO_Q6_1_VALUE: 'corporateIntroQ6_1_value',
  CORPORATE_INTRO_Q6_2_VALUE: 'corporateIntroQ6_2_value',
  CORPORATE_INTRO_Q7_VALUE: 'corporateIntroQ7_value',
  CORPORATE_INTRO_Q7_1_VALUE: 'corporateIntroQ7_1_value',
  CORPORATE_INTRO_Q7_2_VALUE: 'corporateIntroQ7_2_value',
  CORPORATE_INTRO_Q7_3_VALUE: 'corporateIntroQ7_3_value',
  CORPORATE_INTRO_Q8_VALUE: 'corporateIntroQ8_value',
  CORPORATE_INTRO_Q9_VALUE: 'corporateIntroQ9_value',
  CORPORATE_INTRO_Q9_1_VALUE: 'corporateIntroQ9_1_value',
  CORPORATE_INTRO_Q9_2_VALUE: 'corporateIntroQ9_2_value',
  CORPORATE_INTRO_Q10_VALUE: 'corporateIntroQ10_value',
  CORPORATE_INTRO_Q10_1_VALUE: 'corporateIntroQ10_1_value',
  CORPORATE_INTRO_Q10_2_VALUE: 'corporateIntroQ10_2_value',
  CORPORATE_INTRO_Q10_3_VALUE: 'corporateIntroQ10_3_value',
  CORPORATE_INTRO_Q10_4_VALUE: 'corporateIntroQ10_4_value',
  CORPORATE_INTRO_Q11_VALUE: 'corporateIntroQ11_value',
  CORPORATE_INTRO_Q12_VALUE: 'corporateIntroQ12_value',
  CORPORATE_INTRO_Q12_1_VALUE: 'corporateIntroQ12_1_value',
  CORPORATE_INTRO_Q12_2_VALUE: 'corporateIntroQ12_2_value',
  CORPORATE_INTRO_Q12_3_VALUE: 'corporateIntroQ12_3_value',
  CORPORATE_INTRO_Q12_4_VALUE: 'corporateIntroQ12_4_value',
  CORPORATE_INTRO_Q12_5_VALUE: 'corporateIntroQ12_5_value',
  CORPORATE_INTRO_Q12_6_VALUE: 'corporateIntroQ12_6_value',
  CORPORATE_INTRO_Q12_7_VALUE: 'corporateIntroQ12_7_value',
  CORPORATE_INTRO_Q12_8_VALUE: 'corporateIntroQ12_8_value',
  CORPORATE_INTRO_Q13_VALUE: 'corporateIntroQ13_value',
  CORPORATE_INTRO_Q13_1_VALUE: 'corporateIntroQ13_1_value',
  CORPORATE_INTRO_Q13_2_VALUE: 'corporateIntroQ13_2_value',
  CORPORATE_INTRO_Q13_3_VALUE: 'corporateIntroQ13_3_value',
  CORPORATE_INTRO_Q14_VALUE: 'corporateIntroQ14_value',
  CORPORATE_INTRO_Q15_VALUE: 'corporateIntroQ15_value',
  CORPORATE_INTRO_Q16_VALUE: 'corporateIntroQ16_value',
  CORPORATE_INTRO_Q17_VALUE: 'corporateIntroQ17_value',
  CORPORATE_INTRO_Q18_VALUE: 'corporateIntroQ18_value',
  CORPORATE_INTRO_Q19_VALUE: 'corporateIntroQ19_value',
  CORPORATE_INTRO_Q19_1_VALUE: 'corporateIntroQ19_1_value',
  CORPORATE_INTRO_Q19_2_VALUE: 'corporateIntroQ19_2_value',
  CORPORATE_INTRO_Q19_3_VALUE: 'corporateIntroQ19_3_value',
  CORPORATE_INTRO_Q19_4_VALUE: 'corporateIntroQ19_4_value',
  CORPORATE_INTRO_Q19_5_VALUE: 'corporateIntroQ19_5_value',
  CORPORATE_INTRO_Q19_6_VALUE: 'corporateIntroQ19_6_value',
  CORPORATE_INTRO_Q20_VALUE: 'corporateIntroQ20_value',
  CORPORATE_INTRO_Q21_VALUE: 'corporateIntroQ21_value',
  CORPORATE_INTRO_Q21_1_VALUE: 'corporateIntroQ21_1_value',
  CORPORATE_INTRO_Q21_2_VALUE: 'corporateIntroQ21_2_value',
  CORPORATE_INTRO_Q21_3_VALUE: 'corporateIntroQ21_3_value',
  CORPORATE_INTRO_Q21_4_VALUE: 'corporateIntroQ21_4_value',
  CORPORATE_INTRO_Q21_5_VALUE: 'corporateIntroQ21_5_value',
  CORPORATE_INTRO_Q21_6_VALUE: 'corporateIntroQ21_6_value',
  CORPORATE_INTRO_Q21_7_VALUE: 'corporateIntroQ21_7_value',
  CORPORATE_INTRO_Q21_8_VALUE: 'corporateIntroQ21_8_value',
  CORPORATE_INTRO_Q21_9_VALUE: 'corporateIntroQ21_9_value',
  CORPORATE_INTRO_Q21_10_VALUE: 'corporateIntroQ21_10_value',
  CORPORATE_INTRO_Q21_11_VALUE: 'corporateIntroQ21_11_value',
  CORPORATE_INTRO_Q21_12_VALUE: 'corporateIntroQ21_12_value',

  CORPORATE_INTRO_Q22_VALUE: 'corporateIntroQ22_value',

  CORPORATE_INTRO_Q23_VALUE: 'corporateIntroQ23_value',

  CORPORATE_INTRO_Q24_VALUE: 'corporateIntroQ24_value',

  CORPORATE_INTRO_Q25_VALUE: 'corporateIntroQ25_value',
  CORPORATE_INTRO_Q25_1_VALUE: 'corporateIntroQ25_1_value',
  CORPORATE_INTRO_Q25_2_VALUE: 'corporateIntroQ25_2_value',
  CORPORATE_INTRO_Q25_3_VALUE: 'corporateIntroQ25_3_value',
  CORPORATE_INTRO_Q25_4_VALUE: 'corporateIntroQ25_4_value',
  CORPORATE_INTRO_Q25_5_VALUE: 'corporateIntroQ25_5_value',
  CORPORATE_INTRO_Q25_6_VALUE: 'corporateIntroQ25_6_value',
  CORPORATE_INTRO_Q25_7_VALUE: 'corporateIntroQ25_7_value',
  CORPORATE_INTRO_Q25_8_VALUE: 'corporateIntroQ25_8_value',
  CORPORATE_INTRO_Q25_9_VALUE: 'corporateIntroQ25_9_value',
  CORPORATE_INTRO_Q25_10_VALUE: 'corporateIntroQ25_10_value',
  CORPORATE_INTRO_Q25_11_VALUE: 'corporateIntroQ25_11_value',
  CORPORATE_INTRO_Q25_12_VALUE: 'corporateIntroQ25_12_value',
  CORPORATE_INTRO_Q25_13_VALUE: 'corporateIntroQ25_13_value',
  CORPORATE_INTRO_Q25_14_VALUE: 'corporateIntroQ25_14_value',
  CORPORATE_INTRO_Q25_15_VALUE: 'corporateIntroQ25_15_value',
  CORPORATE_INTRO_Q25_16_VALUE: 'corporateIntroQ25_16_value',
  CORPORATE_INTRO_Q25_17_VALUE: 'corporateIntroQ25_17_value',
  CORPORATE_INTRO_Q25_18_VALUE: 'corporateIntroQ25_18_value',
  CORPORATE_INTRO_Q25_19_VALUE: 'corporateIntroQ25_19_value',
  CORPORATE_INTRO_Q25_20_VALUE: 'corporateIntroQ25_20_value',

  CORPORATE_INTRO_Q26_VALUE: 'corporateIntroQ26_value',
  CORPORATE_INTRO_Q26_1_VALUE: 'corporateIntroQ26_1_value',
  CORPORATE_INTRO_Q26_2_VALUE: 'corporateIntroQ26_2_value',
  CORPORATE_INTRO_Q26_3_VALUE: 'corporateIntroQ26_3_value',
  CORPORATE_INTRO_Q26_4_VALUE: 'corporateIntroQ26_4_value',
  CORPORATE_INTRO_Q26_5_VALUE: 'corporateIntroQ26_5_value',

  CORPORATE_INTRO_Q27_VALUE: 'corporateIntroQ27_value',
  CORPORATE_INTRO_Q27_1_VALUE: 'corporateIntroQ27_1_value',
  CORPORATE_INTRO_Q27_2_VALUE: 'corporateIntroQ27_2_value',
  CORPORATE_INTRO_Q27_3_VALUE: 'corporateIntroQ27_3_value',
  CORPORATE_INTRO_Q27_4_VALUE: 'corporateIntroQ27_4_value',
  CORPORATE_INTRO_Q27_5_VALUE: 'corporateIntroQ27_5_value',
  CORPORATE_INTRO_Q27_6_VALUE: 'corporateIntroQ27_6_value',
  CORPORATE_INTRO_Q27_7_VALUE: 'corporateIntroQ27_7_value',
  CORPORATE_INTRO_Q27_8_VALUE: 'corporateIntroQ27_8_value',
  CORPORATE_INTRO_Q27_9_VALUE: 'corporateIntroQ27_9_value',

  CORPORATE_INTRO_Q28_VALUE: 'corporateIntroQ28_value',
  CORPORATE_INTRO_Q28_1_VALUE: 'corporateIntroQ28_1_value',
  CORPORATE_INTRO_Q28_2_VALUE: 'corporateIntroQ28_2_value',
  CORPORATE_INTRO_Q28_3_VALUE: 'corporateIntroQ28_3_value',
  CORPORATE_INTRO_Q28_4_VALUE: 'corporateIntroQ28_4_value',
  CORPORATE_INTRO_Q28_5_VALUE: 'corporateIntroQ28_5_value',
  CORPORATE_INTRO_Q28_6_VALUE: 'corporateIntroQ28_6_value',

  CORPORATE_INTRO_Q29_VALUE: 'corporateIntroQ29_value',
  CORPORATE_INTRO_Q29_1_VALUE: 'corporateIntroQ29_1_value',
  CORPORATE_INTRO_Q29_2_VALUE: 'corporateIntroQ29_2_value',
  CORPORATE_INTRO_Q29_3_VALUE: 'corporateIntroQ29_3_value',
  CORPORATE_INTRO_Q29_4_VALUE: 'corporateIntroQ29_4_value',
  CORPORATE_INTRO_Q29_5_VALUE: 'corporateIntroQ29_5_value',
  CORPORATE_INTRO_Q29_6_VALUE: 'corporateIntroQ29_6_value',
  CORPORATE_INTRO_Q29_7_VALUE: 'corporateIntroQ29_7_value',
  CORPORATE_INTRO_Q29_8_VALUE: 'corporateIntroQ29_8_value',

  CORPORATE_INTRO_Q12_2_VALUE_1: 'corporateIntroQ12_2_value_1'
} as const;

export const CDP_CORPORATE_MANAGEMENT_FIELD_NAMES = {
  CORPORATE_MANAGEMENT_Q1_VALUE: 'corporateManagementQ1_value',
  CORPORATE_MANAGEMENT_Q1_1_VALUE: 'corporateManagementQ1_1_value',
  CORPORATE_MANAGEMENT_Q1_2_VALUE: 'corporateManagementQ1_2_value',
  CORPORATE_MANAGEMENT_Q1_3_VALUE: 'corporateManagementQ1_3_value',
  CORPORATE_MANAGEMENT_Q1_4_VALUE: 'corporateManagementQ1_4_value',
  CORPORATE_MANAGEMENT_Q1_5_VALUE: 'corporateManagementQ1_5_value',

  CORPORATE_MANAGEMENT_Q2_VALUE: 'corporateManagementQ2_value',
  CORPORATE_MANAGEMENT_Q2_1_VALUE: 'corporateManagementQ2_1_value',
  CORPORATE_MANAGEMENT_Q2_2_VALUE: 'corporateManagementQ2_2_value',
  CORPORATE_MANAGEMENT_Q2_3_VALUE: 'corporateManagementQ2_3_value',
  CORPORATE_MANAGEMENT_Q2_4_VALUE: 'corporateManagementQ2_4_value',
  CORPORATE_MANAGEMENT_Q2_5_VALUE: 'corporateManagementQ2_5_value',

  CORPORATE_MANAGEMENT_Q3_VALUE: 'corporateManagementQ3_value',
  CORPORATE_MANAGEMENT_Q3_1_VALUE: 'corporateManagementQ3_1_value',
  CORPORATE_MANAGEMENT_Q3_2_VALUE: 'corporateManagementQ3_2_value',
  CORPORATE_MANAGEMENT_Q3_3_VALUE: 'corporateManagementQ3_3_value',
  CORPORATE_MANAGEMENT_Q3_4_VALUE: 'corporateManagementQ3_4_value',
  CORPORATE_MANAGEMENT_Q3_5_VALUE: 'corporateManagementQ3_5_value',
  CORPORATE_MANAGEMENT_Q3_6_VALUE: 'corporateManagementQ3_6_value',

  CORPORATE_MANAGEMENT_Q4_VALUE: 'corporateManagementQ4_value',
  CORPORATE_MANAGEMENT_Q4_1_VALUE: 'corporateManagementQ4_1_value',
  CORPORATE_MANAGEMENT_Q4_2_VALUE: 'corporateManagementQ4_2_value',
  CORPORATE_MANAGEMENT_Q4_3_VALUE: 'corporateManagementQ4_3_value',
  CORPORATE_MANAGEMENT_Q4_4_VALUE: 'corporateManagementQ4_4_value',
  CORPORATE_MANAGEMENT_Q4_5_VALUE: 'corporateManagementQ4_5_value',
  CORPORATE_MANAGEMENT_Q4_6_VALUE: 'corporateManagementQ4_6_value',
  CORPORATE_MANAGEMENT_Q4_7_VALUE: 'corporateManagementQ4_7_value',
  CORPORATE_MANAGEMENT_Q4_8_VALUE: 'corporateManagementQ4_8_value',
  CORPORATE_MANAGEMENT_Q4_9_VALUE: 'corporateManagementQ4_9_value',
  CORPORATE_MANAGEMENT_Q4_10_VALUE: 'corporateManagementQ4_10_value',
  CORPORATE_MANAGEMENT_Q4_11_VALUE: 'corporateManagementQ4_11_value',
  CORPORATE_MANAGEMENT_Q4_12_VALUE: 'corporateManagementQ4_12_value',
  CORPORATE_MANAGEMENT_Q4_13_VALUE: 'corporateManagementQ4_13_value',
  CORPORATE_MANAGEMENT_Q4_14_VALUE: 'corporateManagementQ4_14_value',
  CORPORATE_MANAGEMENT_Q4_15_VALUE: 'corporateManagementQ4_15_value',
  CORPORATE_MANAGEMENT_Q4_16_VALUE: 'corporateManagementQ4_16_value',

  CORPORATE_MANAGEMENT_Q5_VALUE: 'corporateManagementQ5_value',
  CORPORATE_MANAGEMENT_Q5_1_VALUE: 'corporateManagementQ5_1_value',
  CORPORATE_MANAGEMENT_Q5_2_VALUE: 'corporateManagementQ5_2_value',
  CORPORATE_MANAGEMENT_Q5_3_VALUE: 'corporateManagementQ5_3_value',
  CORPORATE_MANAGEMENT_Q5_4_VALUE: 'corporateManagementQ5_4_value',
  CORPORATE_MANAGEMENT_Q5_5_VALUE: 'corporateManagementQ5_5_value',
  CORPORATE_MANAGEMENT_Q5_6_VALUE: 'corporateManagementQ5_6_value',
  CORPORATE_MANAGEMENT_Q5_7_VALUE: 'corporateManagementQ5_7_value',
  CORPORATE_MANAGEMENT_Q5_8_VALUE: 'corporateManagementQ5_8_value',

  CORPORATE_MANAGEMENT_Q6_VALUE: 'corporateManagementQ6_value',
  CORPORATE_MANAGEMENT_Q6_1_VALUE: 'corporateManagementQ6_1_value',
  CORPORATE_MANAGEMENT_Q6_2_VALUE: 'corporateManagementQ6_2_value',
  CORPORATE_MANAGEMENT_Q6_3_VALUE: 'corporateManagementQ6_3_value',
  CORPORATE_MANAGEMENT_Q6_4_VALUE: 'corporateManagementQ6_4_value',
  CORPORATE_MANAGEMENT_Q6_5_VALUE: 'corporateManagementQ6_5_value',

  CORPORATE_MANAGEMENT_Q7_VALUE: 'corporateManagementQ7_value',
  CORPORATE_MANAGEMENT_Q7_1_VALUE: 'corporateManagementQ7_1_value',
  CORPORATE_MANAGEMENT_Q7_2_VALUE: 'corporateManagementQ7_2_value',
  CORPORATE_MANAGEMENT_Q7_3_VALUE: 'corporateManagementQ7_3_value',
  CORPORATE_MANAGEMENT_Q7_4_VALUE: 'corporateManagementQ7_4_value',
  CORPORATE_MANAGEMENT_Q7_5_VALUE: 'corporateManagementQ7_5_value',
  CORPORATE_MANAGEMENT_Q7_6_VALUE: 'corporateManagementQ7_6_value',
  CORPORATE_MANAGEMENT_Q7_7_VALUE: 'corporateManagementQ7_7_value',

  CORPORATE_MANAGEMENT_Q8_VALUE: 'corporateManagementQ8_value',
  CORPORATE_MANAGEMENT_Q8_1_VALUE: 'corporateManagementQ8_1_value',
  CORPORATE_MANAGEMENT_Q8_2_VALUE: 'corporateManagementQ8_2_value',
  CORPORATE_MANAGEMENT_Q8_3_VALUE: 'corporateManagementQ8_3_value',
  CORPORATE_MANAGEMENT_Q8_4_VALUE: 'corporateManagementQ8_4_value',
  CORPORATE_MANAGEMENT_Q8_5_VALUE: 'corporateManagementQ8_5_value',
  CORPORATE_MANAGEMENT_Q8_6_VALUE: 'corporateManagementQ8_6_value',
  CORPORATE_MANAGEMENT_Q8_7_VALUE: 'corporateManagementQ8_7_value',
  CORPORATE_MANAGEMENT_Q8_8_VALUE: 'corporateManagementQ8_8_value',
  CORPORATE_MANAGEMENT_Q8_9_VALUE: 'corporateManagementQ8_9_value',
  CORPORATE_MANAGEMENT_Q8_10_VALUE: 'corporateManagementQ8_10_value',
  CORPORATE_MANAGEMENT_Q8_11_VALUE: 'corporateManagementQ8_11_value',
  CORPORATE_MANAGEMENT_Q8_12_VALUE: 'corporateManagementQ8_12_value',
  CORPORATE_MANAGEMENT_Q8_13_VALUE: 'corporateManagementQ8_13_value',
  CORPORATE_MANAGEMENT_Q8_14_VALUE: 'corporateManagementQ8_14_value',

  CORPORATE_MANAGEMENT_Q9_VALUE: 'corporateManagementQ9_value',
  CORPORATE_MANAGEMENT_Q9_1_VALUE: 'corporateManagementQ9_1_value',
  CORPORATE_MANAGEMENT_Q9_2_VALUE: 'corporateManagementQ9_2_value',
  CORPORATE_MANAGEMENT_Q9_3_VALUE: 'corporateManagementQ9_3_value',
  CORPORATE_MANAGEMENT_Q9_4_VALUE: 'corporateManagementQ9_4_value',

  CORPORATE_MANAGEMENT_Q10_VALUE: 'corporateManagementQ10_value',
  CORPORATE_MANAGEMENT_Q10_1_VALUE: 'corporateManagementQ10_1_value',
  CORPORATE_MANAGEMENT_Q10_2_VALUE: 'corporateManagementQ10_2_value',
  CORPORATE_MANAGEMENT_Q10_3_VALUE: 'corporateManagementQ10_3_value',

  CORPORATE_MANAGEMENT_Q11_VALUE: 'corporateManagementQ11_value',
  CORPORATE_MANAGEMENT_Q11_1_VALUE: 'corporateManagementQ11_1_value',
  CORPORATE_MANAGEMENT_Q11_2_VALUE: 'corporateManagementQ11_2_value',
  CORPORATE_MANAGEMENT_Q11_3_VALUE: 'corporateManagementQ11_3_value',
  CORPORATE_MANAGEMENT_Q11_4_VALUE: 'corporateManagementQ11_4_value',
  CORPORATE_MANAGEMENT_Q11_5_VALUE: 'corporateManagementQ11_5_value',
  CORPORATE_MANAGEMENT_Q11_6_VALUE: 'corporateManagementQ11_6_value',
  CORPORATE_MANAGEMENT_Q11_7_VALUE: 'corporateManagementQ11_7_value',

  CORPORATE_MANAGEMENT_Q12_VALUE: 'corporateManagementQ12_value',
  CORPORATE_MANAGEMENT_Q12_1_VALUE: 'corporateManagementQ12_1_value',
  CORPORATE_MANAGEMENT_Q12_2_VALUE: 'corporateManagementQ12_2_value',
  CORPORATE_MANAGEMENT_Q12_3_VALUE: 'corporateManagementQ12_3_value',
  CORPORATE_MANAGEMENT_Q12_4_VALUE: 'corporateManagementQ12_4_value',
  CORPORATE_MANAGEMENT_Q12_5_VALUE: 'corporateManagementQ12_5_value',
  CORPORATE_MANAGEMENT_Q12_6_VALUE: 'corporateManagementQ12_6_value',
  CORPORATE_MANAGEMENT_Q12_7_VALUE: 'corporateManagementQ12_7_value',
  CORPORATE_MANAGEMENT_Q12_8_VALUE: 'corporateManagementQ12_8_value',

  CORPORATE_MANAGEMENT_Q13_VALUE: 'corporateManagementQ13_value',
  CORPORATE_MANAGEMENT_Q13_1_VALUE: 'corporateManagementQ13_1_value',
  CORPORATE_MANAGEMENT_Q13_2_VALUE: 'corporateManagementQ13_2_value',
  CORPORATE_MANAGEMENT_Q13_3_VALUE: 'corporateManagementQ13_3_value',
  CORPORATE_MANAGEMENT_Q13_4_VALUE: 'corporateManagementQ13_4_value',
  CORPORATE_MANAGEMENT_Q13_5_VALUE: 'corporateManagementQ13_5_value',
  CORPORATE_MANAGEMENT_Q13_6_VALUE: 'corporateManagementQ13_6_value',
  CORPORATE_MANAGEMENT_Q13_7_VALUE: 'corporateManagementQ13_7_value',
  CORPORATE_MANAGEMENT_Q13_8_VALUE: 'corporateManagementQ13_8_value',

  CORPORATE_MANAGEMENT_Q14_VALUE: 'corporateManagementQ14_value',
  CORPORATE_MANAGEMENT_Q14_1_VALUE: 'corporateManagementQ14_1_value',
  CORPORATE_MANAGEMENT_Q14_2_VALUE: 'corporateManagementQ14_2_value',
  CORPORATE_MANAGEMENT_Q14_3_VALUE: 'corporateManagementQ14_3_value',

  CORPORATE_MANAGEMENT_Q15_VALUE: 'corporateManagementQ15_value',
  CORPORATE_MANAGEMENT_Q15_1_VALUE: 'corporateManagementQ15_1_value',
  CORPORATE_MANAGEMENT_Q15_2_VALUE: 'corporateManagementQ15_2_value',
  CORPORATE_MANAGEMENT_Q15_3_VALUE: 'corporateManagementQ15_3_value',
  CORPORATE_MANAGEMENT_Q15_4_VALUE: 'corporateManagementQ15_4_value',
  CORPORATE_MANAGEMENT_Q15_5_VALUE: 'corporateManagementQ15_5_value',

  CORPORATE_MANAGEMENT_Q16_VALUE: 'corporateManagementQ16_value',
  CORPORATE_MANAGEMENT_Q16_1_VALUE: 'corporateManagementQ16_1_value',
  CORPORATE_MANAGEMENT_Q16_2_VALUE: 'corporateManagementQ16_2_value',
  CORPORATE_MANAGEMENT_Q16_3_VALUE: 'corporateManagementQ16_3_value',
  CORPORATE_MANAGEMENT_Q16_4_VALUE: 'corporateManagementQ16_4_value',

  CORPORATE_MANAGEMENT_Q17_VALUE: 'corporateManagementQ17_value',
  CORPORATE_MANAGEMENT_Q17_1_VALUE: 'corporateManagementQ17_1_value',
  CORPORATE_MANAGEMENT_Q17_2_VALUE: 'corporateManagementQ17_2_value',
  CORPORATE_MANAGEMENT_Q17_3_VALUE: 'corporateManagementQ17_3_value',
  CORPORATE_MANAGEMENT_Q17_4_VALUE: 'corporateManagementQ17_4_value',

  CORPORATE_MANAGEMENT_Q18_VALUE: 'corporateManagementQ18_value',
  CORPORATE_MANAGEMENT_Q18_1_VALUE: 'corporateManagementQ18_1_value',
  CORPORATE_MANAGEMENT_Q18_2_VALUE: 'corporateManagementQ18_2_value',
  CORPORATE_MANAGEMENT_Q18_3_VALUE: 'corporateManagementQ18_3_value',
  CORPORATE_MANAGEMENT_Q18_4_VALUE: 'corporateManagementQ18_4_value',
  CORPORATE_MANAGEMENT_Q18_5_VALUE: 'corporateManagementQ18_5_value',
  CORPORATE_MANAGEMENT_Q18_6_VALUE: 'corporateManagementQ18_6_value',
  CORPORATE_MANAGEMENT_Q18_7_VALUE: 'corporateManagementQ18_7_value',
  CORPORATE_MANAGEMENT_Q18_8_VALUE: 'corporateManagementQ18_8_value',
  CORPORATE_MANAGEMENT_Q18_9_VALUE: 'corporateManagementQ18_9_value',
  CORPORATE_MANAGEMENT_Q18_10_VALUE: 'corporateManagementQ18_10_value',

  CORPORATE_MANAGEMENT_Q19_VALUE: 'corporateManagementQ19_value',
  CORPORATE_MANAGEMENT_Q19_1_VALUE: 'corporateManagementQ19_1_value',
  CORPORATE_MANAGEMENT_Q19_2_VALUE: 'corporateManagementQ19_2_value',
  CORPORATE_MANAGEMENT_Q19_3_VALUE: 'corporateManagementQ19_3_value'
} as const;

export const CORPORATE_DISCLOSURE_FIELD_NAMES = {
  CORPORATE_DISCLOSURE_Q1_VALUE: 'corporateDisclosureQ1_value',
  CORPORATE_DISCLOSURE_Q1_1_VALUE: 'corporateDisclosureQ1_1_value',
  CORPORATE_DISCLOSURE_Q1_2_VALUE: 'corporateDisclosureQ1_2_value',
  CORPORATE_DISCLOSURE_Q1_3_VALUE: 'corporateDisclosureQ1_3_value',
  CORPORATE_DISCLOSURE_Q1_4_VALUE: 'corporateDisclosureQ1_4_value',

  CORPORATE_DISCLOSURE_Q2_VALUE: 'corporateDisclosureQ2_value',
  CORPORATE_DISCLOSURE_Q2_1_VALUE: 'corporateDisclosureQ2_1_value',
  CORPORATE_DISCLOSURE_Q2_2_VALUE: 'corporateDisclosureQ2_2_value',
  CORPORATE_DISCLOSURE_Q2_3_VALUE: 'corporateDisclosureQ2_3_value',
  CORPORATE_DISCLOSURE_Q2_4_VALUE: 'corporateDisclosureQ2_4_value',
  CORPORATE_DISCLOSURE_Q2_5_VALUE: 'corporateDisclosureQ2_5_value',
  CORPORATE_DISCLOSURE_Q2_6_VALUE: 'corporateDisclosureQ2_6_value',
  CORPORATE_DISCLOSURE_Q2_7_VALUE: 'corporateDisclosureQ2_7_value',
  CORPORATE_DISCLOSURE_Q2_8_VALUE: 'corporateDisclosureQ2_8_value',
  CORPORATE_DISCLOSURE_Q2_9_VALUE: 'corporateDisclosureQ2_9_value',
  CORPORATE_DISCLOSURE_Q2_10_VALUE: 'corporateDisclosureQ2_10_value',
  CORPORATE_DISCLOSURE_Q2_11_VALUE: 'corporateDisclosureQ2_11_value',
  CORPORATE_DISCLOSURE_Q2_12_VALUE: 'corporateDisclosureQ2_12_value',
  CORPORATE_DISCLOSURE_Q2_13_VALUE: 'corporateDisclosureQ2_13_value',
  CORPORATE_DISCLOSURE_Q2_14_VALUE: 'corporateDisclosureQ2_14_value',
  CORPORATE_DISCLOSURE_Q2_15_VALUE: 'corporateDisclosureQ2_15_value',
  CORPORATE_DISCLOSURE_Q2_16_VALUE: 'corporateDisclosureQ2_16_value',
  CORPORATE_DISCLOSURE_Q2_17_VALUE: 'corporateDisclosureQ2_17_value',
  CORPORATE_DISCLOSURE_Q2_18_VALUE: 'corporateDisclosureQ2_18_value',
  CORPORATE_DISCLOSURE_Q2_19_VALUE: 'corporateDisclosureQ2_19_value',
  CORPORATE_DISCLOSURE_Q2_20_VALUE: 'corporateDisclosureQ2_20_value',
  CORPORATE_DISCLOSURE_Q2_21_VALUE: 'corporateDisclosureQ2_21_value',
  CORPORATE_DISCLOSURE_Q2_22_VALUE: 'corporateDisclosureQ2_22_value',
  CORPORATE_DISCLOSURE_Q2_23_VALUE: 'corporateDisclosureQ2_23_value',
  CORPORATE_DISCLOSURE_Q2_24_VALUE: 'corporateDisclosureQ2_24_value',
  CORPORATE_DISCLOSURE_Q2_25_VALUE: 'corporateDisclosureQ2_25_value',
  CORPORATE_DISCLOSURE_Q2_26_VALUE: 'corporateDisclosureQ2_26_value',
  CORPORATE_DISCLOSURE_Q2_27_VALUE: 'corporateDisclosureQ2_27_value',
  CORPORATE_DISCLOSURE_Q2_28_VALUE: 'corporateDisclosureQ2_28_value',
  CORPORATE_DISCLOSURE_Q2_29_VALUE: 'corporateDisclosureQ2_29_value',
  CORPORATE_DISCLOSURE_Q2_30_VALUE: 'corporateDisclosureQ2_30_value',

  CORPORATE_DISCLOSURE_Q3_VALUE: 'corporateDisclosureQ3_value',
  CORPORATE_DISCLOSURE_Q3_1_VALUE: 'corporateDisclosureQ3_1_value',
  CORPORATE_DISCLOSURE_Q3_2_VALUE: 'corporateDisclosureQ3_2_value',
  CORPORATE_DISCLOSURE_Q3_3_VALUE: 'corporateDisclosureQ3_3_value',
  CORPORATE_DISCLOSURE_Q3_4_VALUE: 'corporateDisclosureQ3_4_value',
  CORPORATE_DISCLOSURE_Q3_5_VALUE: 'corporateDisclosureQ3_5_value',
  CORPORATE_DISCLOSURE_Q3_6_VALUE: 'corporateDisclosureQ3_6_value',
  CORPORATE_DISCLOSURE_Q3_7_VALUE: 'corporateDisclosureQ3_7_value',
  CORPORATE_DISCLOSURE_Q3_8_VALUE: 'corporateDisclosureQ3_8_value',

  CORPORATE_DISCLOSURE_Q4_VALUE: 'corporateDisclosureQ4_value',
  CORPORATE_DISCLOSURE_Q4_1_VALUE: 'corporateDisclosureQ4_1_value',
  CORPORATE_DISCLOSURE_Q4_2_VALUE: 'corporateDisclosureQ4_2_value',
  CORPORATE_DISCLOSURE_Q4_3_VALUE: 'corporateDisclosureQ4_3_value',
  CORPORATE_DISCLOSURE_Q4_4_VALUE: 'corporateDisclosureQ4_4_value',
  CORPORATE_DISCLOSURE_Q4_5_VALUE: 'corporateDisclosureQ4_5_value',
  CORPORATE_DISCLOSURE_Q4_6_VALUE: 'corporateDisclosureQ4_6_value',
  CORPORATE_DISCLOSURE_Q4_7_VALUE: 'corporateDisclosureQ4_7_value',
  CORPORATE_DISCLOSURE_Q4_8_VALUE: 'corporateDisclosureQ4_8_value',
  CORPORATE_DISCLOSURE_Q4_9_VALUE: 'corporateDisclosureQ4_9_value',
  CORPORATE_DISCLOSURE_Q4_10_VALUE: 'corporateDisclosureQ4_10_value',
  CORPORATE_DISCLOSURE_Q4_11_VALUE: 'corporateDisclosureQ4_11_value',

  CORPORATE_DISCLOSURE_Q5_VALUE: 'corporateDisclosureQ5_value',
  CORPORATE_DISCLOSURE_Q5_1_VALUE: 'corporateDisclosureQ5_1_value',
  CORPORATE_DISCLOSURE_Q5_2_VALUE: 'corporateDisclosureQ5_2_value',
  CORPORATE_DISCLOSURE_Q5_3_VALUE: 'corporateDisclosureQ5_3_value',

  CORPORATE_DISCLOSURE_Q6_VALUE: 'corporateDisclosureQ6_value',
  CORPORATE_DISCLOSURE_Q6_1_VALUE: 'corporateDisclosureQ6_1_value',
  CORPORATE_DISCLOSURE_Q6_2_VALUE: 'corporateDisclosureQ6_2_value',
  CORPORATE_DISCLOSURE_Q6_3_VALUE: 'corporateDisclosureQ6_3_value',
  CORPORATE_DISCLOSURE_Q6_4_VALUE: 'corporateDisclosureQ6_4_value',
  CORPORATE_DISCLOSURE_Q6_5_VALUE: 'corporateDisclosureQ6_5_value',

  CORPORATE_DISCLOSURE_Q7_VALUE: 'corporateDisclosureQ7_value',
  CORPORATE_DISCLOSURE_Q7_1_VALUE: 'corporateDisclosureQ7_1_value',
  CORPORATE_DISCLOSURE_Q7_2_VALUE: 'corporateDisclosureQ7_2_value',
  CORPORATE_DISCLOSURE_Q7_3_VALUE: 'corporateDisclosureQ7_3_value',
  CORPORATE_DISCLOSURE_Q7_4_VALUE: 'corporateDisclosureQ7_4_value',
  CORPORATE_DISCLOSURE_Q7_5_VALUE: 'corporateDisclosureQ7_5_value',

  CORPORATE_DISCLOSURE_Q8_VALUE: 'corporateDisclosureQ8_value',
  CORPORATE_DISCLOSURE_Q8_1_VALUE: 'corporateDisclosureQ8_1_value',
  CORPORATE_DISCLOSURE_Q8_2_VALUE: 'corporateDisclosureQ8_2_value',

  CORPORATE_DISCLOSURE_Q9_VALUE: 'corporateDisclosureQ9_value',
  CORPORATE_DISCLOSURE_Q9_1_VALUE: 'corporateDisclosureQ9_1_value',
  CORPORATE_DISCLOSURE_Q9_2_VALUE: 'corporateDisclosureQ9_2_value',
  CORPORATE_DISCLOSURE_Q9_3_VALUE: 'corporateDisclosureQ9_3_value',
  CORPORATE_DISCLOSURE_Q9_4_VALUE: 'corporateDisclosureQ9_4_value',
  CORPORATE_DISCLOSURE_Q9_5_VALUE: 'corporateDisclosureQ9_5_value',

  CORPORATE_DISCLOSURE_Q10_VALUE: 'corporateDisclosureQ10_value',

  CORPORATE_DISCLOSURE_Q11_VALUE: 'corporateDisclosureQ11_value',
  CORPORATE_DISCLOSURE_Q11_1_VALUE: 'corporateDisclosureQ11_1_value',

  CORPORATE_DISCLOSURE_Q12_VALUE: 'corporateDisclosureQ12_value',
  CORPORATE_DISCLOSURE_Q12_1_VALUE: 'corporateDisclosureQ12_1_value',
  CORPORATE_DISCLOSURE_Q12_2_VALUE: 'corporateDisclosureQ12_2_value',
  CORPORATE_DISCLOSURE_Q12_3_VALUE: 'corporateDisclosureQ12_3_value',
  CORPORATE_DISCLOSURE_Q12_4_VALUE: 'corporateDisclosureQ12_4_value',
  CORPORATE_DISCLOSURE_Q12_5_VALUE: 'corporateDisclosureQ12_5_value',
  CORPORATE_DISCLOSURE_Q12_6_VALUE: 'corporateDisclosureQ12_6_value',
  CORPORATE_DISCLOSURE_Q12_7_VALUE: 'corporateDisclosureQ12_7_value',
  CORPORATE_DISCLOSURE_Q12_8_VALUE: 'corporateDisclosureQ12_8_value',
  CORPORATE_DISCLOSURE_Q12_9_VALUE: 'corporateDisclosureQ12_9_value',
  CORPORATE_DISCLOSURE_Q12_10_VALUE: 'corporateDisclosureQ12_10_value',
  CORPORATE_DISCLOSURE_Q12_11_VALUE: 'corporateDisclosureQ12_11_value',

  CORPORATE_DISCLOSURE_Q13_VALUE: 'corporateDisclosureQ13_value',
  CORPORATE_DISCLOSURE_Q13_1_VALUE: 'corporateDisclosureQ13_1_value',
  CORPORATE_DISCLOSURE_Q13_2_VALUE: 'corporateDisclosureQ13_2_value',
  CORPORATE_DISCLOSURE_Q13_3_VALUE: 'corporateDisclosureQ13_3_value',
  CORPORATE_DISCLOSURE_Q13_4_VALUE: 'corporateDisclosureQ13_4_value',
  CORPORATE_DISCLOSURE_Q13_5_VALUE: 'corporateDisclosureQ13_5_value',
  CORPORATE_DISCLOSURE_Q13_6_VALUE: 'corporateDisclosureQ13_6_value',

  CORPORATE_DISCLOSURE_Q14_VALUE: 'corporateDisclosureQ14_value',

  CORPORATE_DISCLOSURE_Q15_VALUE: 'corporateDisclosureQ15_value',
  CORPORATE_DISCLOSURE_Q15_1_VALUE: 'corporateDisclosureQ15_1_value',
  CORPORATE_DISCLOSURE_Q15_2_VALUE: 'corporateDisclosureQ15_2_value',
  CORPORATE_DISCLOSURE_Q15_3_VALUE: 'corporateDisclosureQ15_3_value',
  CORPORATE_DISCLOSURE_Q15_4_VALUE: 'corporateDisclosureQ15_4_value',

  CORPORATE_DISCLOSURE_Q16_VALUE: 'corporateDisclosureQ16_value',
  CORPORATE_DISCLOSURE_Q16_1_VALUE: 'corporateDisclosureQ16_1_value',
  CORPORATE_DISCLOSURE_Q16_2_VALUE: 'corporateDisclosureQ16_2_value',
  CORPORATE_DISCLOSURE_Q16_3_VALUE: 'corporateDisclosureQ16_3_value',
  CORPORATE_DISCLOSURE_Q16_4_VALUE: 'corporateDisclosureQ16_4_value',
  CORPORATE_DISCLOSURE_Q16_5_VALUE: 'corporateDisclosureQ16_5_value',
  CORPORATE_DISCLOSURE_Q16_6_VALUE: 'corporateDisclosureQ16_6_value',
  CORPORATE_DISCLOSURE_Q16_7_VALUE: 'corporateDisclosureQ16_7_value',
  CORPORATE_DISCLOSURE_Q16_8_VALUE: 'corporateDisclosureQ16_8_value',
  CORPORATE_DISCLOSURE_Q16_9_VALUE: 'corporateDisclosureQ16_9_value',
  CORPORATE_DISCLOSURE_Q16_10_VALUE: 'corporateDisclosureQ16_10_value',
  CORPORATE_DISCLOSURE_Q16_11_VALUE: 'corporateDisclosureQ16_11_value',
  CORPORATE_DISCLOSURE_Q16_12_VALUE: 'corporateDisclosureQ16_12_value',
  CORPORATE_DISCLOSURE_Q16_13_VALUE: 'corporateDisclosureQ16_13_value',
  CORPORATE_DISCLOSURE_Q16_14_VALUE: 'corporateDisclosureQ16_14_value',
  CORPORATE_DISCLOSURE_Q16_15_VALUE: 'corporateDisclosureQ16_15_value',
  CORPORATE_DISCLOSURE_Q16_16_VALUE: 'corporateDisclosureQ16_16_value',
  CORPORATE_DISCLOSURE_Q16_17_VALUE: 'corporateDisclosureQ16_17_value',
  CORPORATE_DISCLOSURE_Q16_18_VALUE: 'corporateDisclosureQ16_18_value',
  CORPORATE_DISCLOSURE_Q16_19_VALUE: 'corporateDisclosureQ16_19_value',
  CORPORATE_DISCLOSURE_Q16_20_VALUE: 'corporateDisclosureQ16_20_value',
  CORPORATE_DISCLOSURE_Q16_21_VALUE: 'corporateDisclosureQ16_21_value',
  CORPORATE_DISCLOSURE_Q16_22_VALUE: 'corporateDisclosureQ16_22_value',
  CORPORATE_DISCLOSURE_Q16_23_VALUE: 'corporateDisclosureQ16_23_value',
  CORPORATE_DISCLOSURE_Q16_24_VALUE: 'corporateDisclosureQ16_24_value',
  CORPORATE_DISCLOSURE_Q16_25_VALUE: 'corporateDisclosureQ16_25_value',
  CORPORATE_DISCLOSURE_Q16_26_VALUE: 'corporateDisclosureQ16_26_value',
  CORPORATE_DISCLOSURE_Q16_27_VALUE: 'corporateDisclosureQ16_27_value',

  CORPORATE_DISCLOSURE_Q17_VALUE: 'corporateDisclosureQ17_value',
  CORPORATE_DISCLOSURE_Q17_1_VALUE: 'corporateDisclosureQ17_1_value',
  CORPORATE_DISCLOSURE_Q17_2_VALUE: 'corporateDisclosureQ17_2_value',
  CORPORATE_DISCLOSURE_Q17_3_VALUE: 'corporateDisclosureQ17_3_value',
  CORPORATE_DISCLOSURE_Q17_4_VALUE: 'corporateDisclosureQ17_4_value',
  CORPORATE_DISCLOSURE_Q17_5_VALUE: 'corporateDisclosureQ17_5_value'
} as const;

export const CDP_CORPORATE_GOVERNANCE_FIELD_NAMES = {
  CORPORATE_GOVERNANCE_Q1_VALUE: 'corporateGovernanceQ1_value',
  CORPORATE_GOVERNANCE_Q1_1_VALUE: 'corporateGovernanceQ1_1_value',
  CORPORATE_GOVERNANCE_Q1_2_VALUE: 'corporateGovernanceQ1_2_value',
  CORPORATE_GOVERNANCE_Q1_3_VALUE: 'corporateGovernanceQ1_3_value',
  CORPORATE_GOVERNANCE_Q1_4_VALUE: 'corporateGovernanceQ1_4_value',
  CORPORATE_GOVERNANCE_Q1_5_VALUE: 'corporateGovernanceQ1_5_value',
  CORPORATE_GOVERNANCE_Q1_6_VALUE: 'corporateGovernanceQ1_6_value',

  CORPORATE_GOVERNANCE_Q2_VALUE: 'corporateGovernanceQ2_value',
  CORPORATE_GOVERNANCE_Q2_1_VALUE: 'corporateGovernanceQ2_1_value',
  CORPORATE_GOVERNANCE_Q2_2_VALUE: 'corporateGovernanceQ2_2_value',
  CORPORATE_GOVERNANCE_Q2_3_VALUE: 'corporateGovernanceQ2_3_value',
  CORPORATE_GOVERNANCE_Q2_4_VALUE: 'corporateGovernanceQ2_4_value',

  CORPORATE_GOVERNANCE_Q3_VALUE: 'corporateGovernanceQ3_value',
  CORPORATE_GOVERNANCE_Q3_1_VALUE: 'corporateGovernanceQ3_1_value',
  CORPORATE_GOVERNANCE_Q3_2_VALUE: 'corporateGovernanceQ3_2_value',
  CORPORATE_GOVERNANCE_Q3_3_VALUE: 'corporateGovernanceQ3_3_value',
  CORPORATE_GOVERNANCE_Q3_4_VALUE: 'corporateGovernanceQ3_4_value',
  CORPORATE_GOVERNANCE_Q3_5_VALUE: 'corporateGovernanceQ3_5_value',
  CORPORATE_GOVERNANCE_Q3_6_VALUE: 'corporateGovernanceQ3_6_value',
  CORPORATE_GOVERNANCE_Q3_7_VALUE: 'corporateGovernanceQ3_7_value',
  CORPORATE_GOVERNANCE_Q3_8_VALUE: 'corporateGovernanceQ3_8_value',

  CORPORATE_GOVERNANCE_Q4_VALUE: 'corporateGovernanceQ4_value',
  CORPORATE_GOVERNANCE_Q4_1_VALUE: 'corporateGovernanceQ4_1_value',
  CORPORATE_GOVERNANCE_Q4_2_VALUE: 'corporateGovernanceQ4_2_value',
  CORPORATE_GOVERNANCE_Q4_3_VALUE: 'corporateGovernanceQ4_3_value',
  CORPORATE_GOVERNANCE_Q4_4_VALUE: 'corporateGovernanceQ4_4_value',
  CORPORATE_GOVERNANCE_Q4_5_VALUE: 'corporateGovernanceQ4_5_value',
  CORPORATE_GOVERNANCE_Q4_6_VALUE: 'corporateGovernanceQ4_6_value',

  CORPORATE_GOVERNANCE_Q5_VALUE: 'corporateGovernanceQ5_value',
  CORPORATE_GOVERNANCE_Q5_1_VALUE: 'corporateGovernanceQ5_1_value',
  CORPORATE_GOVERNANCE_Q5_2_VALUE: 'corporateGovernanceQ5_2_value',
  CORPORATE_GOVERNANCE_Q5_3_VALUE: 'corporateGovernanceQ5_3_value',
  CORPORATE_GOVERNANCE_Q5_4_VALUE: 'corporateGovernanceQ5_4_value',

  CORPORATE_GOVERNANCE_Q6_VALUE: 'corporateGovernanceQ6_value',
  CORPORATE_GOVERNANCE_Q6_1_VALUE: 'corporateGovernanceQ6_1_value',
  CORPORATE_GOVERNANCE_Q6_2_VALUE: 'corporateGovernanceQ6_2_value',
  CORPORATE_GOVERNANCE_Q6_3_VALUE: 'corporateGovernanceQ6_3_value',
  CORPORATE_GOVERNANCE_Q6_4_VALUE: 'corporateGovernanceQ6_4_value',
  CORPORATE_GOVERNANCE_Q6_5_VALUE: 'corporateGovernanceQ6_5_value',
  CORPORATE_GOVERNANCE_Q6_6_VALUE: 'corporateGovernanceQ6_6_value',
  CORPORATE_GOVERNANCE_Q6_7_VALUE: 'corporateGovernanceQ6_7_value',

  CORPORATE_GOVERNANCE_Q7_VALUE: 'corporateGovernanceQ7_value',
  CORPORATE_GOVERNANCE_Q7_1_VALUE: 'corporateGovernanceQ7_1_value',
  CORPORATE_GOVERNANCE_Q7_2_VALUE: 'corporateGovernanceQ7_2_value',
  CORPORATE_GOVERNANCE_Q7_3_VALUE: 'corporateGovernanceQ7_3_value',
  CORPORATE_GOVERNANCE_Q7_4_VALUE: 'corporateGovernanceQ7_4_value',
  CORPORATE_GOVERNANCE_Q7_5_VALUE: 'corporateGovernanceQ7_5_value',
  CORPORATE_GOVERNANCE_Q7_6_VALUE: 'corporateGovernanceQ7_6_value',

  CORPORATE_GOVERNANCE_Q8_VALUE: 'corporateGovernanceQ8_value',
  CORPORATE_GOVERNANCE_Q8_1_VALUE: 'corporateGovernanceQ8_1_value',
  CORPORATE_GOVERNANCE_Q8_2_VALUE: 'corporateGovernanceQ8_2_value',
  CORPORATE_GOVERNANCE_Q8_3_VALUE: 'corporateGovernanceQ8_3_value',
  CORPORATE_GOVERNANCE_Q8_4_VALUE: 'corporateGovernanceQ8_4_value',

  CORPORATE_GOVERNANCE_Q9_VALUE: 'corporateGovernanceQ9_value',
  CORPORATE_GOVERNANCE_Q9_1_VALUE: 'corporateGovernanceQ9_1_value',
  CORPORATE_GOVERNANCE_Q9_2_VALUE: 'corporateGovernanceQ9_2_value',
  CORPORATE_GOVERNANCE_Q9_3_VALUE: 'corporateGovernanceQ9_3_value',
  CORPORATE_GOVERNANCE_Q9_4_VALUE: 'corporateGovernanceQ9_4_value',
  CORPORATE_GOVERNANCE_Q9_5_VALUE: 'corporateGovernanceQ9_5_value',
  CORPORATE_GOVERNANCE_Q9_6_VALUE: 'corporateGovernanceQ9_6_value',
  CORPORATE_GOVERNANCE_Q9_7_VALUE: 'corporateGovernanceQ9_7_value',

  CORPORATE_GOVERNANCE_Q10_VALUE: 'corporateGovernanceQ10_value',
  CORPORATE_GOVERNANCE_Q10_1_VALUE: 'corporateGovernanceQ10_1_value',
  CORPORATE_GOVERNANCE_Q10_2_VALUE: 'corporateGovernanceQ10_2_value',
  CORPORATE_GOVERNANCE_Q10_3_VALUE: 'corporateGovernanceQ10_3_value',

  CORPORATE_GOVERNANCE_Q11_VALUE: 'corporateGovernanceQ11_value',
  CORPORATE_GOVERNANCE_Q11_1_VALUE: 'corporateGovernanceQ11_1_value',
  CORPORATE_GOVERNANCE_Q11_2_VALUE: 'corporateGovernanceQ11_2_value',
  CORPORATE_GOVERNANCE_Q11_3_VALUE: 'corporateGovernanceQ11_3_value',
  CORPORATE_GOVERNANCE_Q11_4_VALUE: 'corporateGovernanceQ11_4_value',
  CORPORATE_GOVERNANCE_Q11_5_VALUE: 'corporateGovernanceQ11_5_value',
  CORPORATE_GOVERNANCE_Q11_6_VALUE: 'corporateGovernanceQ11_6_value',
  CORPORATE_GOVERNANCE_Q11_7_VALUE: 'corporateGovernanceQ11_7_value',
  CORPORATE_GOVERNANCE_Q11_8_VALUE: 'corporateGovernanceQ11_8_value',

  CORPORATE_GOVERNANCE_Q12_VALUE: 'corporateGovernanceQ12_value',
  CORPORATE_GOVERNANCE_Q12_1_VALUE: 'corporateGovernanceQ12_1_value',
  CORPORATE_GOVERNANCE_Q12_2_VALUE: 'corporateGovernanceQ12_2_value',
  CORPORATE_GOVERNANCE_Q12_3_VALUE: 'corporateGovernanceQ12_3_value',
  CORPORATE_GOVERNANCE_Q12_4_VALUE: 'corporateGovernanceQ12_4_value',

  CORPORATE_GOVERNANCE_Q13_VALUE: 'corporateGovernanceQ13_value',
  CORPORATE_GOVERNANCE_Q13_1_VALUE: 'corporateGovernanceQ13_1_value',
  CORPORATE_GOVERNANCE_Q13_2_VALUE: 'corporateGovernanceQ13_2_value',
  CORPORATE_GOVERNANCE_Q13_3_VALUE: 'corporateGovernanceQ13_3_value',
  CORPORATE_GOVERNANCE_Q13_4_VALUE: 'corporateGovernanceQ13_4_value',
  CORPORATE_GOVERNANCE_Q13_5_VALUE: 'corporateGovernanceQ13_5_value',
  CORPORATE_GOVERNANCE_Q13_6_VALUE: 'corporateGovernanceQ13_6_value',
  CORPORATE_GOVERNANCE_Q13_7_VALUE: 'corporateGovernanceQ13_7_value',
  CORPORATE_GOVERNANCE_Q13_8_VALUE: 'corporateGovernanceQ13_8_value',
  CORPORATE_GOVERNANCE_Q13_9_VALUE: 'corporateGovernanceQ13_9_value',
  CORPORATE_GOVERNANCE_Q13_10_VALUE: 'corporateGovernanceQ13_10_value',
  CORPORATE_GOVERNANCE_Q13_11_VALUE: 'corporateGovernanceQ13_11_value',
  CORPORATE_GOVERNANCE_Q13_12_VALUE: 'corporateGovernanceQ13_12_value',
  CORPORATE_GOVERNANCE_Q13_13_VALUE: 'corporateGovernanceQ13_13_value',
  CORPORATE_GOVERNANCE_Q13_14_VALUE: 'corporateGovernanceQ13_14_value',
  CORPORATE_GOVERNANCE_Q13_15_VALUE: 'corporateGovernanceQ13_15_value',
  CORPORATE_GOVERNANCE_Q13_16_VALUE: 'corporateGovernanceQ13_16_value',
  CORPORATE_GOVERNANCE_Q13_17_VALUE: 'corporateGovernanceQ13_17_value',
  CORPORATE_GOVERNANCE_Q13_18_VALUE: 'corporateGovernanceQ13_18_value',

  CORPORATE_GOVERNANCE_Q14_VALUE: 'corporateGovernanceQ14_value',
  CORPORATE_GOVERNANCE_Q14_1_VALUE: 'corporateGovernanceQ14_1_value',
  CORPORATE_GOVERNANCE_Q14_2_VALUE: 'corporateGovernanceQ14_2_value',
  CORPORATE_GOVERNANCE_Q14_3_VALUE: 'corporateGovernanceQ14_3_value',
  CORPORATE_GOVERNANCE_Q14_4_VALUE: 'corporateGovernanceQ14_4_value',
  CORPORATE_GOVERNANCE_Q14_5_VALUE: 'corporateGovernanceQ14_5_value',
  CORPORATE_GOVERNANCE_Q14_6_VALUE: 'corporateGovernanceQ14_6_value',
  CORPORATE_GOVERNANCE_Q14_7_VALUE: 'corporateGovernanceQ14_7_value',
  CORPORATE_GOVERNANCE_Q14_8_VALUE: 'corporateGovernanceQ14_8_value',

  CORPORATE_GOVERNANCE_Q15_VALUE: 'corporateGovernanceQ15_value',
  CORPORATE_GOVERNANCE_Q15_1_VALUE: 'corporateGovernanceQ15_1_value',
  CORPORATE_GOVERNANCE_Q15_2_VALUE: 'corporateGovernanceQ15_2_value',
  CORPORATE_GOVERNANCE_Q15_3_VALUE: 'corporateGovernanceQ15_3_value',

  CORPORATE_GOVERNANCE_Q16_VALUE: 'corporateGovernanceQ16_value',
  CORPORATE_GOVERNANCE_Q16_1_VALUE: 'corporateGovernanceQ16_1_value',
  CORPORATE_GOVERNANCE_Q16_2_VALUE: 'corporateGovernanceQ16_2_value',
  CORPORATE_GOVERNANCE_Q16_3_VALUE: 'corporateGovernanceQ16_3_value',
  CORPORATE_GOVERNANCE_Q16_4_VALUE: 'corporateGovernanceQ16_4_value',
  CORPORATE_GOVERNANCE_Q16_5_VALUE: 'corporateGovernanceQ16_5_value',
  CORPORATE_GOVERNANCE_Q16_6_VALUE: 'corporateGovernanceQ16_6_value',
  CORPORATE_GOVERNANCE_Q16_7_VALUE: 'corporateGovernanceQ16_7_value',

  CORPORATE_GOVERNANCE_Q17_VALUE: 'corporateGovernanceQ17_value',
  CORPORATE_GOVERNANCE_Q17_1_VALUE: 'corporateGovernanceQ17_1_value',
  CORPORATE_GOVERNANCE_Q17_2_VALUE: 'corporateGovernanceQ17_2_value',
  CORPORATE_GOVERNANCE_Q17_3_VALUE: 'corporateGovernanceQ17_3_value',
  CORPORATE_GOVERNANCE_Q17_4_VALUE: 'corporateGovernanceQ17_4_value',

  CORPORATE_GOVERNANCE_Q18_VALUE: 'corporateGovernanceQ18_value',
  CORPORATE_GOVERNANCE_Q18_1_VALUE: 'corporateGovernanceQ18_1_value',
  CORPORATE_GOVERNANCE_Q18_2_VALUE: 'corporateGovernanceQ18_2_value',
  CORPORATE_GOVERNANCE_Q18_3_VALUE: 'corporateGovernanceQ18_3_value',

  CORPORATE_GOVERNANCE_Q19_VALUE: 'corporateGovernanceQ19_value',
  CORPORATE_GOVERNANCE_Q19_1_VALUE: 'corporateGovernanceQ19_1_value',
  CORPORATE_GOVERNANCE_Q19_2_VALUE: 'corporateGovernanceQ19_2_value',
  CORPORATE_GOVERNANCE_Q19_3_VALUE: 'corporateGovernanceQ19_3_value',
  CORPORATE_GOVERNANCE_Q19_4_VALUE: 'corporateGovernanceQ19_4_value',
  CORPORATE_GOVERNANCE_Q19_5_VALUE: 'corporateGovernanceQ19_5_value',
  CORPORATE_GOVERNANCE_Q19_6_VALUE: 'corporateGovernanceQ19_6_value',
  CORPORATE_GOVERNANCE_Q19_7_VALUE: 'corporateGovernanceQ19_7_value',
  CORPORATE_GOVERNANCE_Q19_8_VALUE: 'corporateGovernanceQ19_8_value',
  CORPORATE_GOVERNANCE_Q19_9_VALUE: 'corporateGovernanceQ19_9_value',
  CORPORATE_GOVERNANCE_Q19_10_VALUE: 'corporateGovernanceQ19_10_value',

  CORPORATE_GOVERNANCE_Q20_VALUE: 'corporateGovernanceQ20_value',
  CORPORATE_GOVERNANCE_Q20_1_VALUE: 'corporateGovernanceQ20_1_value',
  CORPORATE_GOVERNANCE_Q20_2_VALUE: 'corporateGovernanceQ20_2_value',
  CORPORATE_GOVERNANCE_Q20_3_VALUE: 'corporateGovernanceQ20_3_value',
  CORPORATE_GOVERNANCE_Q20_4_VALUE: 'corporateGovernanceQ20_4_value',
  CORPORATE_GOVERNANCE_Q20_5_VALUE: 'corporateGovernanceQ20_5_value',
  CORPORATE_GOVERNANCE_Q20_6_VALUE: 'corporateGovernanceQ20_6_value',
  CORPORATE_GOVERNANCE_Q20_7_VALUE: 'corporateGovernanceQ20_7_value',
  CORPORATE_GOVERNANCE_Q20_8_VALUE: 'corporateGovernanceQ20_8_value',
  CORPORATE_GOVERNANCE_Q20_9_VALUE: 'corporateGovernanceQ20_9_value',
  CORPORATE_GOVERNANCE_Q20_10_VALUE: 'corporateGovernanceQ20_10_value',
  CORPORATE_GOVERNANCE_Q20_11_VALUE: 'corporateGovernanceQ20_11_value',
  CORPORATE_GOVERNANCE_Q20_12_VALUE: 'corporateGovernanceQ20_12_value',

  CORPORATE_GOVERNANCE_Q21_VALUE: 'corporateGovernanceQ21_value',
  CORPORATE_GOVERNANCE_Q21_1_VALUE: 'corporateGovernanceQ21_1_value',
  CORPORATE_GOVERNANCE_Q21_2_VALUE: 'corporateGovernanceQ21_2_value',
  CORPORATE_GOVERNANCE_Q21_3_VALUE: 'corporateGovernanceQ21_3_value',
  CORPORATE_GOVERNANCE_Q21_4_VALUE: 'corporateGovernanceQ21_4_value',
  CORPORATE_GOVERNANCE_Q21_5_VALUE: 'corporateGovernanceQ21_5_value',
  CORPORATE_GOVERNANCE_Q21_6_VALUE: 'corporateGovernanceQ21_6_value',
  CORPORATE_GOVERNANCE_Q21_7_VALUE: 'corporateGovernanceQ21_7_value',
  CORPORATE_GOVERNANCE_Q21_8_VALUE: 'corporateGovernanceQ21_8_value',
  CORPORATE_GOVERNANCE_Q21_9_VALUE: 'corporateGovernanceQ21_9_value',
  CORPORATE_GOVERNANCE_Q21_10_VALUE: 'corporateGovernanceQ21_10_value',
  CORPORATE_GOVERNANCE_Q21_11_VALUE: 'corporateGovernanceQ21_11_value',
  CORPORATE_GOVERNANCE_Q21_12_VALUE: 'corporateGovernanceQ21_12_value',

  CORPORATE_GOVERNANCE_Q22_VALUE: 'corporateGovernanceQ22_value',
  CORPORATE_GOVERNANCE_Q22_1_VALUE: 'corporateGovernanceQ22_1_value',

  CORPORATE_GOVERNANCE_Q23_VALUE: 'corporateGovernanceQ23_value',
  CORPORATE_GOVERNANCE_Q23_1_VALUE: 'corporateGovernanceQ23_1_value',
  CORPORATE_GOVERNANCE_Q23_2_VALUE: 'corporateGovernanceQ23_2_value',
  CORPORATE_GOVERNANCE_Q23_3_VALUE: 'corporateGovernanceQ23_3_value',
  CORPORATE_GOVERNANCE_Q23_4_VALUE: 'corporateGovernanceQ23_4_value',
  CORPORATE_GOVERNANCE_Q23_5_VALUE: 'corporateGovernanceQ23_5_value',
  CORPORATE_GOVERNANCE_Q23_6_VALUE: 'corporateGovernanceQ23_6_value',
  CORPORATE_GOVERNANCE_Q23_7_VALUE: 'corporateGovernanceQ23_7_value',
  CORPORATE_GOVERNANCE_Q23_8_VALUE: 'corporateGovernanceQ23_8_value'
} as const;

export const CDP_CORPORATE_STRATEGY_FIELD_NAMES = {
  CORPORATE_STRATEGY_Q1_VALUE: 'corporateStrategyQ1_value',
  CORPORATE_STRATEGY_Q1_1_VALUE: 'corporateStrategyQ1_1_value',
  CORPORATE_STRATEGY_Q1_2_VALUE: 'corporateStrategyQ1_2_value',
  CORPORATE_STRATEGY_Q1_3_VALUE: 'corporateStrategyQ1_3_value',
  CORPORATE_STRATEGY_Q1_4_VALUE: 'corporateStrategyQ1_4_value',
  CORPORATE_STRATEGY_Q1_5_VALUE: 'corporateStrategyQ1_5_value',

  CORPORATE_STRATEGY_Q2_VALUE: 'corporateStrategyQ2_value',
  CORPORATE_STRATEGY_Q2_1_VALUE: 'corporateStrategyQ2_1_value',
  CORPORATE_STRATEGY_Q2_2_VALUE: 'corporateStrategyQ2_2_value',
  CORPORATE_STRATEGY_Q2_3_VALUE: 'corporateStrategyQ2_3_value',
  CORPORATE_STRATEGY_Q2_4_VALUE: 'corporateStrategyQ2_4_value',
  CORPORATE_STRATEGY_Q2_5_VALUE: 'corporateStrategyQ2_5_value',
  CORPORATE_STRATEGY_Q2_6_VALUE: 'corporateStrategyQ2_6_value',
  CORPORATE_STRATEGY_Q2_7_VALUE: 'corporateStrategyQ2_7_value',
  CORPORATE_STRATEGY_Q2_8_VALUE: 'corporateStrategyQ2_8_value',
  CORPORATE_STRATEGY_Q2_9_VALUE: 'corporateStrategyQ2_9_value',
  CORPORATE_STRATEGY_Q2_10_VALUE: 'corporateStrategyQ2_10_value',
  CORPORATE_STRATEGY_Q2_11_VALUE: 'corporateStrategyQ2_11_value',
  CORPORATE_STRATEGY_Q2_12_VALUE: 'corporateStrategyQ2_12_value',

  CORPORATE_STRATEGY_Q3_VALUE: 'corporateStrategyQ3_value',
  CORPORATE_STRATEGY_Q3_1_VALUE: 'corporateStrategyQ3_1_value',
  CORPORATE_STRATEGY_Q3_2_VALUE: 'corporateStrategyQ3_2_value',
  CORPORATE_STRATEGY_Q3_3_VALUE: 'corporateStrategyQ3_3_value',
  CORPORATE_STRATEGY_Q3_4_VALUE: 'corporateStrategyQ3_4_value',

  CORPORATE_STRATEGY_Q4_VALUE: 'corporateStrategyQ4_value',
  CORPORATE_STRATEGY_Q4_1_VALUE: 'corporateStrategyQ4_1_value',
  CORPORATE_STRATEGY_Q4_2_VALUE: 'corporateStrategyQ4_2_value',
  CORPORATE_STRATEGY_Q4_3_VALUE: 'corporateStrategyQ4_3_value',
  CORPORATE_STRATEGY_Q4_4_VALUE: 'corporateStrategyQ4_4_value',
  CORPORATE_STRATEGY_Q4_5_VALUE: 'corporateStrategyQ4_5_value',
  CORPORATE_STRATEGY_Q4_6_VALUE: 'corporateStrategyQ4_6_value',
  CORPORATE_STRATEGY_Q4_7_VALUE: 'corporateStrategyQ4_7_value',
  CORPORATE_STRATEGY_Q4_8_VALUE: 'corporateStrategyQ4_8_value',
  CORPORATE_STRATEGY_Q4_9_VALUE: 'corporateStrategyQ4_9_value',
  CORPORATE_STRATEGY_Q4_10_VALUE: 'corporateStrategyQ4_10_value',
  CORPORATE_STRATEGY_Q4_11_VALUE: 'corporateStrategyQ4_11_value',
  CORPORATE_STRATEGY_Q4_12_VALUE: 'corporateStrategyQ4_12_value',
  CORPORATE_STRATEGY_Q4_13_VALUE: 'corporateStrategyQ4_13_value',
  CORPORATE_STRATEGY_Q4_14_VALUE: 'corporateStrategyQ4_14_value',
  CORPORATE_STRATEGY_Q4_15_VALUE: 'corporateStrategyQ4_15_value',
  CORPORATE_STRATEGY_Q4_16_VALUE: 'corporateStrategyQ4_16_value',

  CORPORATE_STRATEGY_Q5_VALUE: 'corporateStrategyQ5_value',
  CORPORATE_STRATEGY_Q5_1_VALUE: 'corporateStrategyQ5_1_value',
  CORPORATE_STRATEGY_Q5_2_VALUE: 'corporateStrategyQ5_2_value',
  CORPORATE_STRATEGY_Q5_3_VALUE: 'corporateStrategyQ5_3_value',
  CORPORATE_STRATEGY_Q5_4_VALUE: 'corporateStrategyQ5_4_value',

  CORPORATE_STRATEGY_Q6_VALUE: 'corporateStrategyQ6_value',
  CORPORATE_STRATEGY_Q6_1_VALUE: 'corporateStrategyQ6_1_value',
  CORPORATE_STRATEGY_Q6_2_VALUE: 'corporateStrategyQ6_2_value',
  CORPORATE_STRATEGY_Q6_3_VALUE: 'corporateStrategyQ6_3_value',
  CORPORATE_STRATEGY_Q6_4_VALUE: 'corporateStrategyQ6_4_value',

  CORPORATE_STRATEGY_Q7_VALUE: 'corporateStrategyQ7_value',
  CORPORATE_STRATEGY_Q7_1_VALUE: 'corporateStrategyQ7_1_value',
  CORPORATE_STRATEGY_Q7_2_VALUE: 'corporateStrategyQ7_2_value',
  CORPORATE_STRATEGY_Q7_3_VALUE: 'corporateStrategyQ7_3_value',
  CORPORATE_STRATEGY_Q7_4_VALUE: 'corporateStrategyQ7_4_value',

  CORPORATE_STRATEGY_Q8_VALUE: 'corporateStrategyQ8_value',
  CORPORATE_STRATEGY_Q8_1_VALUE: 'corporateStrategyQ8_1_value',
  CORPORATE_STRATEGY_Q8_2_VALUE: 'corporateStrategyQ8_2_value',
  CORPORATE_STRATEGY_Q8_3_VALUE: 'corporateStrategyQ8_3_value',

  CORPORATE_STRATEGY_Q9_VALUE: 'corporateStrategyQ9_value',
  CORPORATE_STRATEGY_Q9_1_VALUE: 'corporateStrategyQ9_1_value',
  CORPORATE_STRATEGY_Q9_2_VALUE: 'corporateStrategyQ9_2_value',
  CORPORATE_STRATEGY_Q9_3_VALUE: 'corporateStrategyQ9_3_value',
  CORPORATE_STRATEGY_Q9_4_VALUE: 'corporateStrategyQ9_4_value',
  CORPORATE_STRATEGY_Q9_5_VALUE: 'corporateStrategyQ9_5_value',
  CORPORATE_STRATEGY_Q9_6_VALUE: 'corporateStrategyQ9_6_value',
  CORPORATE_STRATEGY_Q9_7_VALUE: 'corporateStrategyQ9_7_value',
  CORPORATE_STRATEGY_Q9_8_VALUE: 'corporateStrategyQ9_8_value',
  CORPORATE_STRATEGY_Q9_9_VALUE: 'corporateStrategyQ9_9_value',
  CORPORATE_STRATEGY_Q9_10_VALUE: 'corporateStrategyQ9_10_value',
  CORPORATE_STRATEGY_Q9_11_VALUE: 'corporateStrategyQ9_11_value',
  CORPORATE_STRATEGY_Q9_12_VALUE: 'corporateStrategyQ9_12_value',

  CORPORATE_STRATEGY_Q10_VALUE: 'corporateStrategyQ10_value',
  CORPORATE_STRATEGY_Q10_1_VALUE: 'corporateStrategyQ10_1_value',
  CORPORATE_STRATEGY_Q10_2_VALUE: 'corporateStrategyQ10_2_value',
  CORPORATE_STRATEGY_Q10_3_VALUE: 'corporateStrategyQ10_3_value',
  CORPORATE_STRATEGY_Q10_4_VALUE: 'corporateStrategyQ10_4_value',
  CORPORATE_STRATEGY_Q10_5_VALUE: 'corporateStrategyQ10_5_value',
  CORPORATE_STRATEGY_Q10_6_VALUE: 'corporateStrategyQ10_6_value',
  CORPORATE_STRATEGY_Q10_7_VALUE: 'corporateStrategyQ10_7_value',
  CORPORATE_STRATEGY_Q10_8_VALUE: 'corporateStrategyQ10_8_value',
  CORPORATE_STRATEGY_Q10_9_VALUE: 'corporateStrategyQ10_9_value',
  CORPORATE_STRATEGY_Q10_10_VALUE: 'corporateStrategyQ10_10_value',
  CORPORATE_STRATEGY_Q10_11_VALUE: 'corporateStrategyQ10_11_value',
  CORPORATE_STRATEGY_Q10_12_VALUE: 'corporateStrategyQ10_12_value',
  CORPORATE_STRATEGY_Q10_13_VALUE: 'corporateStrategyQ10_13_value',
  CORPORATE_STRATEGY_Q10_14_VALUE: 'corporateStrategyQ10_14_value',
  CORPORATE_STRATEGY_Q10_15_VALUE: 'corporateStrategyQ10_15_value',
  CORPORATE_STRATEGY_Q10_16_VALUE: 'corporateStrategyQ10_16_value',
  CORPORATE_STRATEGY_Q10_17_VALUE: 'corporateStrategyQ10_17_value',
  CORPORATE_STRATEGY_Q10_18_VALUE: 'corporateStrategyQ10_18_value',
  CORPORATE_STRATEGY_Q10_19_VALUE: 'corporateStrategyQ10_19_value',
  CORPORATE_STRATEGY_Q10_20_VALUE: 'corporateStrategyQ10_20_value',
  CORPORATE_STRATEGY_Q10_21_VALUE: 'corporateStrategyQ10_21_value',
  CORPORATE_STRATEGY_Q10_22_VALUE: 'corporateStrategyQ10_22_value',
  CORPORATE_STRATEGY_Q10_23_VALUE: 'corporateStrategyQ10_23_value',
  CORPORATE_STRATEGY_Q10_24_VALUE: 'corporateStrategyQ10_24_value',
  CORPORATE_STRATEGY_Q10_25_VALUE: 'corporateStrategyQ10_25_value',
  CORPORATE_STRATEGY_Q10_26_VALUE: 'corporateStrategyQ10_26_value',
  CORPORATE_STRATEGY_Q10_27_VALUE: 'corporateStrategyQ10_27_value',
  CORPORATE_STRATEGY_Q10_28_VALUE: 'corporateStrategyQ10_28_value',
  CORPORATE_STRATEGY_Q10_29_VALUE: 'corporateStrategyQ10_29_value',
  CORPORATE_STRATEGY_Q10_30_VALUE: 'corporateStrategyQ10_30_value',
  CORPORATE_STRATEGY_Q10_31_VALUE: 'corporateStrategyQ10_31_value',
  CORPORATE_STRATEGY_Q10_32_VALUE: 'corporateStrategyQ10_32_value',
  CORPORATE_STRATEGY_Q10_33_VALUE: 'corporateStrategyQ10_33_value',

  CORPORATE_STRATEGY_Q11_VALUE: 'corporateStrategyQ11_value',
  CORPORATE_STRATEGY_Q11_1_VALUE: 'corporateStrategyQ11_1_value',
  CORPORATE_STRATEGY_Q11_2_VALUE: 'corporateStrategyQ11_2_value',
  CORPORATE_STRATEGY_Q11_3_VALUE: 'corporateStrategyQ11_3_value',
  CORPORATE_STRATEGY_Q11_4_VALUE: 'corporateStrategyQ11_4_value',

  CORPORATE_STRATEGY_Q12_VALUE: 'corporateStrategyQ12_value',
  CORPORATE_STRATEGY_Q12_1_VALUE: 'corporateStrategyQ12_1_value',
  CORPORATE_STRATEGY_Q12_2_VALUE: 'corporateStrategyQ12_2_value',

  CORPORATE_STRATEGY_Q13_VALUE: 'corporateStrategyQ13_value',

  CORPORATE_STRATEGY_Q14_VALUE: 'corporateStrategyQ14_value',

  CORPORATE_STRATEGY_Q15_VALUE: 'corporateStrategyQ15_value',

  CORPORATE_STRATEGY_Q16_VALUE: 'corporateStrategyQ16_value',

  CORPORATE_STRATEGY_Q17_VALUE: 'corporateStrategyQ17_value',

  CORPORATE_STRATEGY_Q18_VALUE: 'corporateStrategyQ18_value',

  CORPORATE_STRATEGY_Q19_VALUE: 'corporateStrategyQ19_value',
  CORPORATE_STRATEGY_Q19_1_VALUE: 'corporateStrategyQ19_1_value',
  CORPORATE_STRATEGY_Q19_2_VALUE: 'corporateStrategyQ19_2_value',
  CORPORATE_STRATEGY_Q19_3_VALUE: 'corporateStrategyQ19_3_value',
  CORPORATE_STRATEGY_Q19_4_VALUE: 'corporateStrategyQ19_4_value',
  CORPORATE_STRATEGY_Q19_5_VALUE: 'corporateStrategyQ19_5_value',
  CORPORATE_STRATEGY_Q19_6_VALUE: 'corporateStrategyQ19_6_value',

  CORPORATE_STRATEGY_Q20_VALUE: 'corporateStrategyQ20_value',
  CORPORATE_STRATEGY_Q20_1_VALUE: 'corporateStrategyQ20_1_value',
  CORPORATE_STRATEGY_Q20_2_VALUE: 'corporateStrategyQ20_2_value',
  CORPORATE_STRATEGY_Q20_3_VALUE: 'corporateStrategyQ20_3_value',
  CORPORATE_STRATEGY_Q20_4_VALUE: 'corporateStrategyQ20_4_value',
  CORPORATE_STRATEGY_Q20_5_VALUE: 'corporateStrategyQ20_5_value',
  CORPORATE_STRATEGY_Q20_6_VALUE: 'corporateStrategyQ20_6_value',
  CORPORATE_STRATEGY_Q20_7_VALUE: 'corporateStrategyQ20_7_value',

  CORPORATE_STRATEGY_Q21_VALUE: 'corporateStrategyQ21_value',
  CORPORATE_STRATEGY_Q21_1_VALUE: 'corporateStrategyQ21_1_value',
  CORPORATE_STRATEGY_Q21_2_VALUE: 'corporateStrategyQ21_2_value',
  CORPORATE_STRATEGY_Q21_3_VALUE: 'corporateStrategyQ21_3_value',
  CORPORATE_STRATEGY_Q21_4_VALUE: 'corporateStrategyQ21_4_value',
  CORPORATE_STRATEGY_Q21_5_VALUE: 'corporateStrategyQ21_5_value',

  CORPORATE_STRATEGY_Q22_VALUE: 'corporateStrategyQ22_value',
  CORPORATE_STRATEGY_Q22_1_VALUE: 'corporateStrategyQ22_1_value',
  CORPORATE_STRATEGY_Q22_2_VALUE: 'corporateStrategyQ22_2_value',
  CORPORATE_STRATEGY_Q22_3_VALUE: 'corporateStrategyQ22_3_value',
  CORPORATE_STRATEGY_Q22_4_VALUE: 'corporateStrategyQ22_4_value',
  CORPORATE_STRATEGY_Q22_5_VALUE: 'corporateStrategyQ22_5_value',
  CORPORATE_STRATEGY_Q22_6_VALUE: 'corporateStrategyQ22_6_value',

  CORPORATE_STRATEGY_Q23_VALUE: 'corporateStrategyQ23_value',
  CORPORATE_STRATEGY_Q23_1_VALUE: 'corporateStrategyQ23_1_value',
  CORPORATE_STRATEGY_Q23_2_VALUE: 'corporateStrategyQ23_2_value',
  CORPORATE_STRATEGY_Q23_3_VALUE: 'corporateStrategyQ23_3_value',
  CORPORATE_STRATEGY_Q23_4_VALUE: 'corporateStrategyQ23_4_value',
  CORPORATE_STRATEGY_Q23_5_VALUE: 'corporateStrategyQ23_5_value',

  CORPORATE_STRATEGY_Q24_VALUE: 'corporateStrategyQ24_value',
  CORPORATE_STRATEGY_Q24_1_VALUE: 'corporateStrategyQ24_1_value',
  CORPORATE_STRATEGY_Q24_2_VALUE: 'corporateStrategyQ24_2_value',
  CORPORATE_STRATEGY_Q24_3_VALUE: 'corporateStrategyQ24_3_value',
  CORPORATE_STRATEGY_Q24_4_VALUE: 'corporateStrategyQ24_4_value',
  CORPORATE_STRATEGY_Q24_5_VALUE: 'corporateStrategyQ24_5_value',

  CORPORATE_STRATEGY_Q25_VALUE: 'corporateStrategyQ25_value',
  CORPORATE_STRATEGY_Q25_1_VALUE: 'corporateStrategyQ25_1_value',
  CORPORATE_STRATEGY_Q25_2_VALUE: 'corporateStrategyQ25_2_value',
  CORPORATE_STRATEGY_Q25_3_VALUE: 'corporateStrategyQ25_3_value',
  CORPORATE_STRATEGY_Q25_4_VALUE: 'corporateStrategyQ25_4_value',
  CORPORATE_STRATEGY_Q25_5_VALUE: 'corporateStrategyQ25_5_value',
  CORPORATE_STRATEGY_Q25_6_VALUE: 'corporateStrategyQ25_6_value',

  CORPORATE_STRATEGY_Q26_VALUE: 'corporateStrategyQ26_value',
  CORPORATE_STRATEGY_Q26_1_VALUE: 'corporateStrategyQ26_1_value',
  CORPORATE_STRATEGY_Q26_2_VALUE: 'corporateStrategyQ26_2_value',
  CORPORATE_STRATEGY_Q26_3_VALUE: 'corporateStrategyQ26_3_value',
  CORPORATE_STRATEGY_Q26_4_VALUE: 'corporateStrategyQ26_4_value',
  CORPORATE_STRATEGY_Q26_5_VALUE: 'corporateStrategyQ26_5_value',
  CORPORATE_STRATEGY_Q26_6_VALUE: 'corporateStrategyQ26_6_value',
  CORPORATE_STRATEGY_Q26_7_VALUE: 'corporateStrategyQ26_7_value',
  CORPORATE_STRATEGY_Q26_8_VALUE: 'corporateStrategyQ26_8_value',
  CORPORATE_STRATEGY_Q26_9_VALUE: 'corporateStrategyQ26_9_value',
  CORPORATE_STRATEGY_Q26_10_VALUE: 'corporateStrategyQ26_10_value',
  CORPORATE_STRATEGY_Q26_11_VALUE: 'corporateStrategyQ26_11_value',
  CORPORATE_STRATEGY_Q26_12_VALUE: 'corporateStrategyQ26_12_value',
  CORPORATE_STRATEGY_Q26_13_VALUE: 'corporateStrategyQ26_13_value',
  CORPORATE_STRATEGY_Q26_14_VALUE: 'corporateStrategyQ26_14_value',
  CORPORATE_STRATEGY_Q26_15_VALUE: 'corporateStrategyQ26_15_value',
  CORPORATE_STRATEGY_Q26_16_VALUE: 'corporateStrategyQ26_16_value',

  CORPORATE_STRATEGY_Q27_VALUE: 'corporateStrategyQ27_value',
  CORPORATE_STRATEGY_Q27_1_VALUE: 'corporateStrategyQ27_1_value',
  CORPORATE_STRATEGY_Q27_2_VALUE: 'corporateStrategyQ27_2_value',
  CORPORATE_STRATEGY_Q27_3_VALUE: 'corporateStrategyQ27_3_value',
  CORPORATE_STRATEGY_Q27_4_VALUE: 'corporateStrategyQ27_4_value',
  CORPORATE_STRATEGY_Q27_5_VALUE: 'corporateStrategyQ27_5_value',
  CORPORATE_STRATEGY_Q27_6_VALUE: 'corporateStrategyQ27_6_value',
  CORPORATE_STRATEGY_Q27_7_VALUE: 'corporateStrategyQ27_7_value',
  CORPORATE_STRATEGY_Q27_8_VALUE: 'corporateStrategyQ27_8_value',
  CORPORATE_STRATEGY_Q27_9_VALUE: 'corporateStrategyQ27_9_value',
  CORPORATE_STRATEGY_Q27_10_VALUE: 'corporateStrategyQ27_10_value',
  CORPORATE_STRATEGY_Q27_11_VALUE: 'corporateStrategyQ27_11_value',
  CORPORATE_STRATEGY_Q27_12_VALUE: 'corporateStrategyQ27_12_value',
  CORPORATE_STRATEGY_Q27_13_VALUE: 'corporateStrategyQ27_13_value',
  CORPORATE_STRATEGY_Q27_14_VALUE: 'corporateStrategyQ27_14_value',
  CORPORATE_STRATEGY_Q27_15_VALUE: 'corporateStrategyQ27_15_value',
  CORPORATE_STRATEGY_Q27_16_VALUE: 'corporateStrategyQ27_16_value',

  CORPORATE_STRATEGY_Q28_VALUE: 'corporateStrategyQ28_value',
  CORPORATE_STRATEGY_Q28_1_VALUE: 'corporateStrategyQ28_1_value',
  CORPORATE_STRATEGY_Q28_2_VALUE: 'corporateStrategyQ28_2_value',
  CORPORATE_STRATEGY_Q28_3_VALUE: 'corporateStrategyQ28_3_value',
  CORPORATE_STRATEGY_Q28_4_VALUE: 'corporateStrategyQ28_4_value',
  CORPORATE_STRATEGY_Q28_5_VALUE: 'corporateStrategyQ28_5_value',

  CORPORATE_STRATEGY_Q29_VALUE: 'corporateStrategyQ29_value',
  CORPORATE_STRATEGY_Q29_1_VALUE: 'corporateStrategyQ29_1_value',
  CORPORATE_STRATEGY_Q29_2_VALUE: 'corporateStrategyQ29_2_value',
  CORPORATE_STRATEGY_Q29_3_VALUE: 'corporateStrategyQ29_3_value',
  CORPORATE_STRATEGY_Q29_4_VALUE: 'corporateStrategyQ29_4_value',
  CORPORATE_STRATEGY_Q29_5_VALUE: 'corporateStrategyQ29_5_value',
  CORPORATE_STRATEGY_Q29_6_VALUE: 'corporateStrategyQ29_6_value',
  CORPORATE_STRATEGY_Q29_7_VALUE: 'corporateStrategyQ29_7_value',

  CORPORATE_STRATEGY_Q30_VALUE: 'corporateStrategyQ30_value',
  CORPORATE_STRATEGY_Q30_1_VALUE: 'corporateStrategyQ30_1_value',
  CORPORATE_STRATEGY_Q30_2_VALUE: 'corporateStrategyQ30_2_value',
  CORPORATE_STRATEGY_Q30_3_VALUE: 'corporateStrategyQ30_3_value',
  CORPORATE_STRATEGY_Q30_4_VALUE: 'corporateStrategyQ30_4_value',
  CORPORATE_STRATEGY_Q30_5_VALUE: 'corporateStrategyQ30_5_value',

  CORPORATE_STRATEGY_Q31_VALUE: 'corporateStrategyQ31_value',
  CORPORATE_STRATEGY_Q31_1_VALUE: 'corporateStrategyQ31_1_value',
  CORPORATE_STRATEGY_Q31_2_VALUE: 'corporateStrategyQ31_2_value',
  CORPORATE_STRATEGY_Q31_3_VALUE: 'corporateStrategyQ31_3_value',
  CORPORATE_STRATEGY_Q31_4_VALUE: 'corporateStrategyQ31_4_value',
  CORPORATE_STRATEGY_Q31_5_VALUE: 'corporateStrategyQ31_5_value',
  CORPORATE_STRATEGY_Q31_6_VALUE: 'corporateStrategyQ31_6_value',
  CORPORATE_STRATEGY_Q31_7_VALUE: 'corporateStrategyQ31_7_value',
  CORPORATE_STRATEGY_Q31_8_VALUE: 'corporateStrategyQ31_8_value',
  CORPORATE_STRATEGY_Q31_9_VALUE: 'corporateStrategyQ31_9_value',
  CORPORATE_STRATEGY_Q31_10_VALUE: 'corporateStrategyQ31_10_value',
  CORPORATE_STRATEGY_Q31_11_VALUE: 'corporateStrategyQ31_11_value',
  CORPORATE_STRATEGY_Q31_12_VALUE: 'corporateStrategyQ31_12_value',
  CORPORATE_STRATEGY_Q31_13_VALUE: 'corporateStrategyQ31_13_value',

  CORPORATE_STRATEGY_Q32_VALUE: 'corporateStrategyQ32_value',
  CORPORATE_STRATEGY_Q32_1_VALUE: 'corporateStrategyQ32_1_value',
  CORPORATE_STRATEGY_Q32_2_VALUE: 'corporateStrategyQ32_2_value',
  CORPORATE_STRATEGY_Q32_3_VALUE: 'corporateStrategyQ32_3_value',
  CORPORATE_STRATEGY_Q32_4_VALUE: 'corporateStrategyQ32_4_value',
  CORPORATE_STRATEGY_Q32_5_VALUE: 'corporateStrategyQ32_5_value',
  CORPORATE_STRATEGY_Q32_6_VALUE: 'corporateStrategyQ32_6_value',
  CORPORATE_STRATEGY_Q32_7_VALUE: 'corporateStrategyQ32_7_value',
  CORPORATE_STRATEGY_Q32_8_VALUE: 'corporateStrategyQ32_8_value',
  CORPORATE_STRATEGY_Q32_9_VALUE: 'corporateStrategyQ32_9_value',
  CORPORATE_STRATEGY_Q32_10_VALUE: 'corporateStrategyQ32_10_value',
  CORPORATE_STRATEGY_Q32_11_VALUE: 'corporateStrategyQ32_11_value',
  CORPORATE_STRATEGY_Q32_12_VALUE: 'corporateStrategyQ32_12_value',
  CORPORATE_STRATEGY_Q32_13_VALUE: 'corporateStrategyQ32_13_value',

  CORPORATE_STRATEGY_Q33_VALUE: 'corporateStrategyQ33_value',
  CORPORATE_STRATEGY_Q33_1_VALUE: 'corporateStrategyQ33_1_value',
  CORPORATE_STRATEGY_Q33_2_VALUE: 'corporateStrategyQ33_2_value',
  CORPORATE_STRATEGY_Q33_3_VALUE: 'corporateStrategyQ33_3_value',
  CORPORATE_STRATEGY_Q33_4_VALUE: 'corporateStrategyQ33_4_value',

  CORPORATE_STRATEGY_Q34_VALUE: 'corporateStrategyQ34_value',
  CORPORATE_STRATEGY_Q34_1_VALUE: 'corporateStrategyQ34_1_value',
  CORPORATE_STRATEGY_Q34_2_VALUE: 'corporateStrategyQ34_2_value',
  CORPORATE_STRATEGY_Q34_3_VALUE: 'corporateStrategyQ34_3_value',
  CORPORATE_STRATEGY_Q34_4_VALUE: 'corporateStrategyQ34_4_value',
  CORPORATE_STRATEGY_Q34_5_VALUE: 'corporateStrategyQ34_5_value',
  CORPORATE_STRATEGY_Q34_6_VALUE: 'corporateStrategyQ34_6_value',
  CORPORATE_STRATEGY_Q34_7_VALUE: 'corporateStrategyQ34_7_value',
  CORPORATE_STRATEGY_Q34_8_VALUE: 'corporateStrategyQ34_8_value',
  CORPORATE_STRATEGY_Q34_9_VALUE: 'corporateStrategyQ34_9_value',
  CORPORATE_STRATEGY_Q34_10_VALUE: 'corporateStrategyQ34_10_value',
  CORPORATE_STRATEGY_Q34_11_VALUE: 'corporateStrategyQ34_11_value',
  CORPORATE_STRATEGY_Q34_12_VALUE: 'corporateStrategyQ34_12_value',

  CORPORATE_STRATEGY_Q35_VALUE: 'corporateStrategyQ35_value',
  CORPORATE_STRATEGY_Q35_1_VALUE: 'corporateStrategyQ35_1_value',
  CORPORATE_STRATEGY_Q35_2_VALUE: 'corporateStrategyQ35_2_value',
  CORPORATE_STRATEGY_Q35_3_VALUE: 'corporateStrategyQ35_3_value',
  CORPORATE_STRATEGY_Q35_4_VALUE: 'corporateStrategyQ35_4_value',
  CORPORATE_STRATEGY_Q35_5_VALUE: 'corporateStrategyQ35_5_value',
  CORPORATE_STRATEGY_Q35_6_VALUE: 'corporateStrategyQ35_6_value',
  CORPORATE_STRATEGY_Q35_7_VALUE: 'corporateStrategyQ35_7_value',
  CORPORATE_STRATEGY_Q35_8_VALUE: 'corporateStrategyQ35_8_value',
  CORPORATE_STRATEGY_Q35_9_VALUE: 'corporateStrategyQ35_9_value',
  CORPORATE_STRATEGY_Q35_10_VALUE: 'corporateStrategyQ35_10_value',
  CORPORATE_STRATEGY_Q35_11_VALUE: 'corporateStrategyQ35_11_value',
  CORPORATE_STRATEGY_Q35_12_VALUE: 'corporateStrategyQ35_12_value',

  CORPORATE_STRATEGY_Q36_VALUE: 'corporateStrategyQ36_value',
  CORPORATE_STRATEGY_Q36_1_VALUE: 'corporateStrategyQ36_1_value',
  CORPORATE_STRATEGY_Q36_2_VALUE: 'corporateStrategyQ36_2_value',
  CORPORATE_STRATEGY_Q36_3_VALUE: 'corporateStrategyQ36_3_value',
  CORPORATE_STRATEGY_Q36_4_VALUE: 'corporateStrategyQ36_4_value',

  CORPORATE_STRATEGY_Q37_VALUE: 'corporateStrategyQ37_value',
  CORPORATE_STRATEGY_Q37_1_VALUE: 'corporateStrategyQ37_1_value',
  CORPORATE_STRATEGY_Q37_2_VALUE: 'corporateStrategyQ37_2_value',
  CORPORATE_STRATEGY_Q37_3_VALUE: 'corporateStrategyQ37_3_value',
  CORPORATE_STRATEGY_Q37_4_VALUE: 'corporateStrategyQ37_4_value',
  CORPORATE_STRATEGY_Q37_5_VALUE: 'corporateStrategyQ37_5_value',
  CORPORATE_STRATEGY_Q37_6_VALUE: 'corporateStrategyQ37_6_value',
  CORPORATE_STRATEGY_Q37_7_VALUE: 'corporateStrategyQ37_7_value',

  CORPORATE_STRATEGY_Q38_VALUE: 'corporateStrategyQ38_value',
  CORPORATE_STRATEGY_Q38_1_VALUE: 'corporateStrategyQ38_1_value',
  CORPORATE_STRATEGY_Q38_2_VALUE: 'corporateStrategyQ38_2_value',
  CORPORATE_STRATEGY_Q38_3_VALUE: 'corporateStrategyQ38_3_value',
  CORPORATE_STRATEGY_Q38_4_VALUE: 'corporateStrategyQ38_4_value',
  CORPORATE_STRATEGY_Q38_5_VALUE: 'corporateStrategyQ38_5_value',
  CORPORATE_STRATEGY_Q38_6_VALUE: 'corporateStrategyQ38_6_value',
  CORPORATE_STRATEGY_Q38_7_VALUE: 'corporateStrategyQ38_7_value',
  CORPORATE_STRATEGY_Q38_8_VALUE: 'corporateStrategyQ38_8_value',
  CORPORATE_STRATEGY_Q38_9_VALUE: 'corporateStrategyQ38_9_value',
  CORPORATE_STRATEGY_Q38_10_VALUE: 'corporateStrategyQ38_10_value',
  CORPORATE_STRATEGY_Q38_11_VALUE: 'corporateStrategyQ38_11_value',

  CORPORATE_STRATEGY_Q39_VALUE: 'corporateStrategyQ39_value',
  CORPORATE_STRATEGY_Q39_1_VALUE: 'corporateStrategyQ39_1_value',
  CORPORATE_STRATEGY_Q39_2_VALUE: 'corporateStrategyQ39_2_value',
  CORPORATE_STRATEGY_Q39_3_VALUE: 'corporateStrategyQ39_3_value',

  CORPORATE_STRATEGY_Q40_VALUE: 'corporateStrategyQ40_value',
  CORPORATE_STRATEGY_Q40_1_VALUE: 'corporateStrategyQ40_1_value',
  CORPORATE_STRATEGY_Q40_2_VALUE: 'corporateStrategyQ40_2_value',
  CORPORATE_STRATEGY_Q40_3_VALUE: 'corporateStrategyQ40_3_value',
  CORPORATE_STRATEGY_Q40_4_VALUE: 'corporateStrategyQ40_4_value',
  CORPORATE_STRATEGY_Q40_5_VALUE: 'corporateStrategyQ40_5_value',
  CORPORATE_STRATEGY_Q40_6_VALUE: 'corporateStrategyQ40_6_value',
  CORPORATE_STRATEGY_Q40_7_VALUE: 'corporateStrategyQ40_7_value',
  CORPORATE_STRATEGY_Q40_8_VALUE: 'corporateStrategyQ40_8_value',
  CORPORATE_STRATEGY_Q40_9_VALUE: 'corporateStrategyQ40_9_value',
  CORPORATE_STRATEGY_Q40_10_VALUE: 'corporateStrategyQ40_10_value',
  CORPORATE_STRATEGY_Q40_11_VALUE: 'corporateStrategyQ40_11_value',
  CORPORATE_STRATEGY_Q40_12_VALUE: 'corporateStrategyQ40_12_value',

  CORPORATE_STRATEGY_Q41_VALUE: 'corporateStrategyQ41_value',
  CORPORATE_STRATEGY_Q41_1_VALUE: 'corporateStrategyQ41_1_value',
  CORPORATE_STRATEGY_Q41_2_VALUE: 'corporateStrategyQ41_2_value',
  CORPORATE_STRATEGY_Q41_3_VALUE: 'corporateStrategyQ41_3_value',
  CORPORATE_STRATEGY_Q41_4_VALUE: 'corporateStrategyQ41_4_value',

  CORPORATE_STRATEGY_Q42_VALUE: 'corporateStrategyQ42_value',
  CORPORATE_STRATEGY_Q42_1_VALUE: 'corporateStrategyQ42_1_value',
  CORPORATE_STRATEGY_Q42_2_VALUE: 'corporateStrategyQ42_2_value',
  CORPORATE_STRATEGY_Q42_3_VALUE: 'corporateStrategyQ42_3_value',
  CORPORATE_STRATEGY_Q42_4_VALUE: 'corporateStrategyQ42_4_value',
  CORPORATE_STRATEGY_Q42_5_VALUE: 'corporateStrategyQ42_5_value',
  CORPORATE_STRATEGY_Q42_6_VALUE: 'corporateStrategyQ42_6_value',

  CORPORATE_STRATEGY_Q43_VALUE: 'corporateStrategyQ43_value',
  CORPORATE_STRATEGY_Q43_1_VALUE: 'corporateStrategyQ43_1_value',
  CORPORATE_STRATEGY_Q43_2_VALUE: 'corporateStrategyQ43_2_value',
  CORPORATE_STRATEGY_Q43_3_VALUE: 'corporateStrategyQ43_3_value',

  CORPORATE_STRATEGY_Q44_VALUE: 'corporateStrategyQ44_value',
  CORPORATE_STRATEGY_Q44_1_VALUE: 'corporateStrategyQ44_1_value',
  CORPORATE_STRATEGY_Q44_2_VALUE: 'corporateStrategyQ44_2_value',
  CORPORATE_STRATEGY_Q44_3_VALUE: 'corporateStrategyQ44_3_value',
  CORPORATE_STRATEGY_Q44_4_VALUE: 'corporateStrategyQ44_4_value',
  CORPORATE_STRATEGY_Q44_5_VALUE: 'corporateStrategyQ44_5_value',
  CORPORATE_STRATEGY_Q44_6_VALUE: 'corporateStrategyQ44_6_value',
  CORPORATE_STRATEGY_Q44_7_VALUE: 'corporateStrategyQ44_7_value'
} as const;

export const CDP_CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH_FIELD_NAMES = {
  CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH_Q1_VALUE:
    'corporatePerformanceConsolidationApproachQ1_value',
  CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH_Q1_1_VALUE:
    'corporatePerformanceConsolidationApproachQ1_1_value',
  CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH_Q1_2_VALUE:
    'corporatePerformanceConsolidationApproachQ1_2_value',
  CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH_Q1_3_VALUE:
    'corporatePerformanceConsolidationApproachQ1_3_value'
} as const;

export const CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES = {
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q1_VALUE:
    'corporatePerformanceClimateChangeQ1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q1_1_VALUE:
    'corporatePerformanceClimateChangeQ1_1_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_VALUE:
    'corporatePerformanceClimateChangeQ2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_1_VALUE:
    'corporatePerformanceClimateChangeQ2_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_2_VALUE:
    'corporatePerformanceClimateChangeQ2_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_3_VALUE:
    'corporatePerformanceClimateChangeQ2_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q3_VALUE:
    'corporatePerformanceClimateChangeQ3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q3_1_VALUE:
    'corporatePerformanceClimateChangeQ3_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q3_2_VALUE:
    'corporatePerformanceClimateChangeQ3_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_VALUE:
    'corporatePerformanceClimateChangeQ4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_1_VALUE:
    'corporatePerformanceClimateChangeQ4_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_2_VALUE:
    'corporatePerformanceClimateChangeQ4_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_3_VALUE:
    'corporatePerformanceClimateChangeQ4_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_4_VALUE:
    'corporatePerformanceClimateChangeQ4_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE:
    'corporatePerformanceClimateChangeQ5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_1_VALUE:
    'corporatePerformanceClimateChangeQ5_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_2_VALUE:
    'corporatePerformanceClimateChangeQ5_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_3_VALUE:
    'corporatePerformanceClimateChangeQ5_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_VALUE:
    'corporatePerformanceClimateChangeQ6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_1_VALUE:
    'corporatePerformanceClimateChangeQ6_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_2_VALUE:
    'corporatePerformanceClimateChangeQ6_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_3_VALUE:
    'corporatePerformanceClimateChangeQ6_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_4_VALUE:
    'corporatePerformanceClimateChangeQ6_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_5_VALUE:
    'corporatePerformanceClimateChangeQ6_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_6_VALUE:
    'corporatePerformanceClimateChangeQ6_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_7_VALUE:
    'corporatePerformanceClimateChangeQ6_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_8_VALUE:
    'corporatePerformanceClimateChangeQ6_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_9_VALUE:
    'corporatePerformanceClimateChangeQ6_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_10_VALUE:
    'corporatePerformanceClimateChangeQ6_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_11_VALUE:
    'corporatePerformanceClimateChangeQ6_11_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q7_VALUE:
    'corporatePerformanceClimateChangeQ7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q7_1_VALUE:
    'corporatePerformanceClimateChangeQ7_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q7_2_VALUE:
    'corporatePerformanceClimateChangeQ7_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q7_3_VALUE:
    'corporatePerformanceClimateChangeQ7_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q7_4_VALUE:
    'corporatePerformanceClimateChangeQ7_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q8_VALUE:
    'corporatePerformanceClimateChangeQ8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q8_1_VALUE:
    'corporatePerformanceClimateChangeQ8_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q8_2_VALUE:
    'corporatePerformanceClimateChangeQ8_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q8_3_VALUE:
    'corporatePerformanceClimateChangeQ8_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q9_VALUE:
    'corporatePerformanceClimateChangeQ9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q9_1_VALUE:
    'corporatePerformanceClimateChangeQ9_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q9_2_VALUE:
    'corporatePerformanceClimateChangeQ9_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q9_3_VALUE:
    'corporatePerformanceClimateChangeQ9_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_VALUE:
    'corporatePerformanceClimateChangeQ10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_1_VALUE:
    'corporatePerformanceClimateChangeQ10_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_2_VALUE:
    'corporatePerformanceClimateChangeQ10_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_3_VALUE:
    'corporatePerformanceClimateChangeQ10_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_4_VALUE:
    'corporatePerformanceClimateChangeQ10_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_5_VALUE:
    'corporatePerformanceClimateChangeQ10_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_6_VALUE:
    'corporatePerformanceClimateChangeQ10_6_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q11_VALUE:
    'corporatePerformanceClimateChangeQ11_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q12_VALUE:
    'corporatePerformanceClimateChangeQ12_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_VALUE:
    'corporatePerformanceClimateChangeQ13_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_1_VALUE:
    'corporatePerformanceClimateChangeQ13_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_2_VALUE:
    'corporatePerformanceClimateChangeQ13_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_3_VALUE:
    'corporatePerformanceClimateChangeQ13_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_4_VALUE:
    'corporatePerformanceClimateChangeQ13_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_5_VALUE:
    'corporatePerformanceClimateChangeQ13_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_6_VALUE:
    'corporatePerformanceClimateChangeQ13_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_7_VALUE:
    'corporatePerformanceClimateChangeQ13_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_8_VALUE:
    'corporatePerformanceClimateChangeQ13_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_9_VALUE:
    'corporatePerformanceClimateChangeQ13_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_10_VALUE:
    'corporatePerformanceClimateChangeQ13_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_11_VALUE:
    'corporatePerformanceClimateChangeQ13_11_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_12_VALUE:
    'corporatePerformanceClimateChangeQ13_12_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_13_VALUE:
    'corporatePerformanceClimateChangeQ13_13_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_14_VALUE:
    'corporatePerformanceClimateChangeQ13_14_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_15_VALUE:
    'corporatePerformanceClimateChangeQ13_15_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_16_VALUE:
    'corporatePerformanceClimateChangeQ13_16_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_17_VALUE:
    'corporatePerformanceClimateChangeQ13_17_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_18_VALUE:
    'corporatePerformanceClimateChangeQ13_18_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_19_VALUE:
    'corporatePerformanceClimateChangeQ13_19_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_VALUE:
    'corporatePerformanceClimateChangeQ14_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_1_VALUE:
    'corporatePerformanceClimateChangeQ14_1_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_1_VALUE_SCOPE1:
    'corporatePerformanceClimateChangeQ14_1_value_scope1',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_1_VALUE_SCOPE2:
    'corporatePerformanceClimateChangeQ14_1_value_scope2',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_1_VALUE_SCOPE3:
    'corporatePerformanceClimateChangeQ14_1_value_scope3',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_VALUE:
    'corporatePerformanceClimateChangeQ15_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_1_VALUE:
    'corporatePerformanceClimateChangeQ15_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_2_VALUE:
    'corporatePerformanceClimateChangeQ15_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_3_VALUE:
    'corporatePerformanceClimateChangeQ15_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_4_VALUE:
    'corporatePerformanceClimateChangeQ15_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_5_VALUE:
    'corporatePerformanceClimateChangeQ15_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_6_VALUE:
    'corporatePerformanceClimateChangeQ15_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_7_VALUE:
    'corporatePerformanceClimateChangeQ15_7_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_VALUE:
    'corporatePerformanceClimateChangeQ16_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_1_VALUE:
    'corporatePerformanceClimateChangeQ16_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_2_VALUE:
    'corporatePerformanceClimateChangeQ16_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_3_VALUE:
    'corporatePerformanceClimateChangeQ16_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_4_VALUE:
    'corporatePerformanceClimateChangeQ16_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_5_VALUE:
    'corporatePerformanceClimateChangeQ16_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_6_VALUE:
    'corporatePerformanceClimateChangeQ16_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_7_VALUE:
    'corporatePerformanceClimateChangeQ16_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_8_VALUE:
    'corporatePerformanceClimateChangeQ16_8_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_VALUE:
    'corporatePerformanceClimateChangeQ17_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_1_VALUE:
    'corporatePerformanceClimateChangeQ17_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_2_VALUE:
    'corporatePerformanceClimateChangeQ17_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_3_VALUE:
    'corporatePerformanceClimateChangeQ17_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_4_VALUE:
    'corporatePerformanceClimateChangeQ17_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_5_VALUE:
    'corporatePerformanceClimateChangeQ17_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_6_VALUE:
    'corporatePerformanceClimateChangeQ17_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_7_VALUE:
    'corporatePerformanceClimateChangeQ17_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_8_VALUE:
    'corporatePerformanceClimateChangeQ17_8_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q18_VALUE:
    'corporatePerformanceClimateChangeQ18_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q19_VALUE:
    'corporatePerformanceClimateChangeQ19_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q19_1_VALUE:
    'corporatePerformanceClimateChangeQ19_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q19_2_VALUE:
    'corporatePerformanceClimateChangeQ19_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q19_3_VALUE:
    'corporatePerformanceClimateChangeQ19_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q19_4_VALUE:
    'corporatePerformanceClimateChangeQ19_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q20_VALUE:
    'corporatePerformanceClimateChangeQ20_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q21_VALUE:
    'corporatePerformanceClimateChangeQ21_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q22_VALUE:
    'corporatePerformanceClimateChangeQ22_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q22_1_VALUE:
    'corporatePerformanceClimateChangeQ22_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q22_2_VALUE:
    'corporatePerformanceClimateChangeQ22_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q22_3_VALUE:
    'corporatePerformanceClimateChangeQ22_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q22_4_VALUE:
    'corporatePerformanceClimateChangeQ22_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q22_5_VALUE:
    'corporatePerformanceClimateChangeQ22_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q22_6_VALUE:
    'corporatePerformanceClimateChangeQ22_6_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q23_VALUE:
    'corporatePerformanceClimateChangeQ23_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q24_VALUE:
    'corporatePerformanceClimateChangeQ24_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q24_1_VALUE:
    'corporatePerformanceClimateChangeQ24_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q24_2_VALUE:
    'corporatePerformanceClimateChangeQ24_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q25_VALUE:
    'corporatePerformanceClimateChangeQ25_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q26_VALUE:
    'corporatePerformanceClimateChangeQ26_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q26_1_VALUE:
    'corporatePerformanceClimateChangeQ26_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q26_2_VALUE:
    'corporatePerformanceClimateChangeQ26_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q26_3_VALUE:
    'corporatePerformanceClimateChangeQ26_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_VALUE:
    'corporatePerformanceClimateChangeQ27_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_1_VALUE:
    'corporatePerformanceClimateChangeQ27_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE:
    'corporatePerformanceClimateChangeQ27_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_3_VALUE:
    'corporatePerformanceClimateChangeQ27_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_4_VALUE:
    'corporatePerformanceClimateChangeQ27_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_5_VALUE:
    'corporatePerformanceClimateChangeQ27_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_6_VALUE:
    'corporatePerformanceClimateChangeQ27_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_7_VALUE:
    'corporatePerformanceClimateChangeQ27_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_8_VALUE:
    'corporatePerformanceClimateChangeQ27_8_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE:
    'corporatePerformanceClimateChangeQ28_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q29_VALUE:
    'corporatePerformanceClimateChangeQ29_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q29_1_VALUE:
    'corporatePerformanceClimateChangeQ29_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q29_2_VALUE:
    'corporatePerformanceClimateChangeQ29_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q29_3_VALUE:
    'corporatePerformanceClimateChangeQ29_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q30_VALUE:
    'corporatePerformanceClimateChangeQ30_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q30_1_VALUE:
    'corporatePerformanceClimateChangeQ30_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q30_2_VALUE:
    'corporatePerformanceClimateChangeQ30_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q30_3_VALUE:
    'corporatePerformanceClimateChangeQ30_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q30_4_VALUE:
    'corporatePerformanceClimateChangeQ30_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q31_VALUE:
    'corporatePerformanceClimateChangeQ31_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q31_1_VALUE:
    'corporatePerformanceClimateChangeQ31_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q31_2_VALUE:
    'corporatePerformanceClimateChangeQ31_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q31_3_VALUE:
    'corporatePerformanceClimateChangeQ31_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q31_4_VALUE:
    'corporatePerformanceClimateChangeQ31_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q31_5_VALUE:
    'corporatePerformanceClimateChangeQ31_5_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_VALUE:
    'corporatePerformanceClimateChangeQ32_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_1_VALUE:
    'corporatePerformanceClimateChangeQ32_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_2_VALUE:
    'corporatePerformanceClimateChangeQ32_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_3_VALUE:
    'corporatePerformanceClimateChangeQ32_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_4_VALUE:
    'corporatePerformanceClimateChangeQ32_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_5_VALUE:
    'corporatePerformanceClimateChangeQ32_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_6_VALUE:
    'corporatePerformanceClimateChangeQ32_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_7_VALUE:
    'corporatePerformanceClimateChangeQ32_7_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q33_VALUE:
    'corporatePerformanceClimateChangeQ33_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q33_1_VALUE:
    'corporatePerformanceClimateChangeQ33_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q33_2_VALUE:
    'corporatePerformanceClimateChangeQ33_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q33_3_VALUE:
    'corporatePerformanceClimateChangeQ33_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q33_4_VALUE:
    'corporatePerformanceClimateChangeQ33_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q34_VALUE:
    'corporatePerformanceClimateChangeQ34_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q35_VALUE:
    'corporatePerformanceClimateChangeQ35_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q35_1_VALUE:
    'corporatePerformanceClimateChangeQ35_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q35_2_VALUE:
    'corporatePerformanceClimateChangeQ35_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q36_VALUE:
    'corporatePerformanceClimateChangeQ36_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q36_1_VALUE:
    'corporatePerformanceClimateChangeQ36_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q36_2_VALUE:
    'corporatePerformanceClimateChangeQ36_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q36_3_VALUE:
    'corporatePerformanceClimateChangeQ36_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q36_4_VALUE:
    'corporatePerformanceClimateChangeQ36_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q37_VALUE:
    'corporatePerformanceClimateChangeQ37_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q37_1_VALUE:
    'corporatePerformanceClimateChangeQ37_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q37_2_VALUE:
    'corporatePerformanceClimateChangeQ37_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q38_VALUE:
    'corporatePerformanceClimateChangeQ38_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q39_VALUE:
    'corporatePerformanceClimateChangeQ39_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q40_VALUE:
    'corporatePerformanceClimateChangeQ40_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q40_1_VALUE:
    'corporatePerformanceClimateChangeQ40_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q40_2_VALUE:
    'corporatePerformanceClimateChangeQ40_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q40_3_VALUE:
    'corporatePerformanceClimateChangeQ40_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q40_4_VALUE:
    'corporatePerformanceClimateChangeQ40_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q40_5_VALUE:
    'corporatePerformanceClimateChangeQ40_5_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q41_VALUE:
    'corporatePerformanceClimateChangeQ41_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q41_1_VALUE:
    'corporatePerformanceClimateChangeQ41_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q41_2_VALUE:
    'corporatePerformanceClimateChangeQ41_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q42_VALUE:
    'corporatePerformanceClimateChangeQ42_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q42_1_VALUE:
    'corporatePerformanceClimateChangeQ42_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q42_2_VALUE:
    'corporatePerformanceClimateChangeQ42_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q42_3_VALUE:
    'corporatePerformanceClimateChangeQ42_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q42_4_VALUE:
    'corporatePerformanceClimateChangeQ42_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q43_VALUE:
    'corporatePerformanceClimateChangeQ43_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q44_VALUE:
    'corporatePerformanceClimateChangeQ44_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q44_1_VALUE:
    'corporatePerformanceClimateChangeQ44_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q44_2_VALUE:
    'corporatePerformanceClimateChangeQ44_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q44_3_VALUE:
    'corporatePerformanceClimateChangeQ44_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q45_VALUE:
    'corporatePerformanceClimateChangeQ45_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q45_1_VALUE:
    'corporatePerformanceClimateChangeQ45_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q45_2_VALUE:
    'corporatePerformanceClimateChangeQ45_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q45_3_VALUE:
    'corporatePerformanceClimateChangeQ45_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q46_VALUE:
    'corporatePerformanceClimateChangeQ46_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q46_1_VALUE:
    'corporatePerformanceClimateChangeQ46_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q46_2_VALUE:
    'corporatePerformanceClimateChangeQ46_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q46_3_VALUE:
    'corporatePerformanceClimateChangeQ46_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q47_VALUE:
    'corporatePerformanceClimateChangeQ47_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q47_1_VALUE:
    'corporatePerformanceClimateChangeQ47_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q47_2_VALUE:
    'corporatePerformanceClimateChangeQ47_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q47_3_VALUE:
    'corporatePerformanceClimateChangeQ47_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q48_VALUE:
    'corporatePerformanceClimateChangeQ48_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q48_1_VALUE:
    'corporatePerformanceClimateChangeQ48_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q48_2_VALUE:
    'corporatePerformanceClimateChangeQ48_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q48_3_VALUE:
    'corporatePerformanceClimateChangeQ48_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q48_4_VALUE:
    'corporatePerformanceClimateChangeQ48_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q49_VALUE:
    'corporatePerformanceClimateChangeQ49_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_VALUE:
    'corporatePerformanceClimateChangeQ50_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_1_VALUE:
    'corporatePerformanceClimateChangeQ50_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_2_VALUE:
    'corporatePerformanceClimateChangeQ50_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_3_VALUE:
    'corporatePerformanceClimateChangeQ50_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_4_VALUE:
    'corporatePerformanceClimateChangeQ50_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_5_VALUE:
    'corporatePerformanceClimateChangeQ50_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_6_VALUE:
    'corporatePerformanceClimateChangeQ50_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_7_VALUE:
    'corporatePerformanceClimateChangeQ50_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_8_VALUE:
    'corporatePerformanceClimateChangeQ50_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_9_VALUE:
    'corporatePerformanceClimateChangeQ50_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_10_VALUE:
    'corporatePerformanceClimateChangeQ50_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_11_VALUE:
    'corporatePerformanceClimateChangeQ50_11_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_12_VALUE:
    'corporatePerformanceClimateChangeQ50_12_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_13_VALUE:
    'corporatePerformanceClimateChangeQ50_13_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_14_VALUE:
    'corporatePerformanceClimateChangeQ50_14_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_15_VALUE:
    'corporatePerformanceClimateChangeQ50_15_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q51_VALUE:
    'corporatePerformanceClimateChangeQ51_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q51_1_VALUE:
    'corporatePerformanceClimateChangeQ51_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q51_2_VALUE:
    'corporatePerformanceClimateChangeQ51_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q51_3_VALUE:
    'corporatePerformanceClimateChangeQ51_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q51_4_VALUE:
    'corporatePerformanceClimateChangeQ51_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q51_5_VALUE:
    'corporatePerformanceClimateChangeQ51_5_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q52_VALUE:
    'corporatePerformanceClimateChangeQ52_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q52_1_VALUE:
    'corporatePerformanceClimateChangeQ52_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q52_2_VALUE:
    'corporatePerformanceClimateChangeQ52_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q52_3_VALUE:
    'corporatePerformanceClimateChangeQ52_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q53_VALUE:
    'corporatePerformanceClimateChangeQ53_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q53_1_VALUE:
    'corporatePerformanceClimateChangeQ53_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q53_2_VALUE:
    'corporatePerformanceClimateChangeQ53_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q53_3_VALUE:
    'corporatePerformanceClimateChangeQ53_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_VALUE:
    'corporatePerformanceClimateChangeQ54_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_1_VALUE:
    'corporatePerformanceClimateChangeQ54_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_2_VALUE:
    'corporatePerformanceClimateChangeQ54_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_3_VALUE:
    'corporatePerformanceClimateChangeQ54_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_4_VALUE:
    'corporatePerformanceClimateChangeQ54_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_5_VALUE:
    'corporatePerformanceClimateChangeQ54_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_6_VALUE:
    'corporatePerformanceClimateChangeQ54_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_7_VALUE:
    'corporatePerformanceClimateChangeQ54_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_8_VALUE:
    'corporatePerformanceClimateChangeQ54_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_9_VALUE:
    'corporatePerformanceClimateChangeQ54_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_10_VALUE:
    'corporatePerformanceClimateChangeQ54_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_11_VALUE:
    'corporatePerformanceClimateChangeQ54_11_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_12_VALUE:
    'corporatePerformanceClimateChangeQ54_12_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_13_VALUE:
    'corporatePerformanceClimateChangeQ54_13_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_14_VALUE:
    'corporatePerformanceClimateChangeQ54_14_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q55_VALUE:
    'corporatePerformanceClimateChangeQ55_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q55_1_VALUE:
    'corporatePerformanceClimateChangeQ55_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q55_2_VALUE:
    'corporatePerformanceClimateChangeQ55_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q56_VALUE:
    'corporatePerformanceClimateChangeQ56_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q56_1_VALUE:
    'corporatePerformanceClimateChangeQ56_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q56_2_VALUE:
    'corporatePerformanceClimateChangeQ56_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q56_3_VALUE:
    'corporatePerformanceClimateChangeQ56_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q56_4_VALUE:
    'corporatePerformanceClimateChangeQ56_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q57_VALUE:
    'corporatePerformanceClimateChangeQ57_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE:
    'corporatePerformanceClimateChangeQ58_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_1_VALUE:
    'corporatePerformanceClimateChangeQ58_1_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_1_VALUE_ACTIVITY_1:
    'corporatePerformanceClimateChangeQ58_1_value_activity1',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q59_VALUE:
    'corporatePerformanceClimateChangeQ59_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q59_1_VALUE:
    'corporatePerformanceClimateChangeQ59_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q59_2_VALUE:
    'corporatePerformanceClimateChangeQ59_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q59_3_VALUE:
    'corporatePerformanceClimateChangeQ59_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q59_4_VALUE:
    'corporatePerformanceClimateChangeQ59_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q60_VALUE:
    'corporatePerformanceClimateChangeQ60_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q60_1_VALUE:
    'corporatePerformanceClimateChangeQ60_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q60_2_VALUE:
    'corporatePerformanceClimateChangeQ60_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q61_VALUE:
    'corporatePerformanceClimateChangeQ61_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q61_1_VALUE:
    'corporatePerformanceClimateChangeQ61_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q61_2_VALUE:
    'corporatePerformanceClimateChangeQ61_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q61_3_VALUE:
    'corporatePerformanceClimateChangeQ61_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q61_4_VALUE:
    'corporatePerformanceClimateChangeQ61_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q61_5_VALUE:
    'corporatePerformanceClimateChangeQ61_5_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q62_VALUE:
    'corporatePerformanceClimateChangeQ62_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q62_1_VALUE:
    'corporatePerformanceClimateChangeQ62_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q62_2_VALUE:
    'corporatePerformanceClimateChangeQ62_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_VALUE:
    'corporatePerformanceClimateChangeQ63_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_1_VALUE:
    'corporatePerformanceClimateChangeQ63_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_2_VALUE:
    'corporatePerformanceClimateChangeQ63_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_3_VALUE:
    'corporatePerformanceClimateChangeQ63_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_4_VALUE:
    'corporatePerformanceClimateChangeQ63_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_5_VALUE:
    'corporatePerformanceClimateChangeQ63_5_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q64_VALUE:
    'corporatePerformanceClimateChangeQ64_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q64_1_VALUE:
    'corporatePerformanceClimateChangeQ64_1_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_VALUE:
    'corporatePerformanceClimateChangeQ65_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_1_VALUE:
    'corporatePerformanceClimateChangeQ65_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_2_VALUE:
    'corporatePerformanceClimateChangeQ65_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_3_VALUE:
    'corporatePerformanceClimateChangeQ65_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_4_VALUE:
    'corporatePerformanceClimateChangeQ65_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_5_VALUE:
    'corporatePerformanceClimateChangeQ65_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_6_VALUE:
    'corporatePerformanceClimateChangeQ65_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_7_VALUE:
    'corporatePerformanceClimateChangeQ65_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_8_VALUE:
    'corporatePerformanceClimateChangeQ65_8_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_VALUE:
    'corporatePerformanceClimateChangeQ66_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_1_VALUE:
    'corporatePerformanceClimateChangeQ66_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_2_VALUE:
    'corporatePerformanceClimateChangeQ66_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_3_VALUE:
    'corporatePerformanceClimateChangeQ66_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_4_VALUE:
    'corporatePerformanceClimateChangeQ66_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_5_VALUE:
    'corporatePerformanceClimateChangeQ66_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_6_VALUE:
    'corporatePerformanceClimateChangeQ66_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_7_VALUE:
    'corporatePerformanceClimateChangeQ66_7_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q67_VALUE:
    'corporatePerformanceClimateChangeQ67_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q67_1_VALUE:
    'corporatePerformanceClimateChangeQ67_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q67_2_VALUE:
    'corporatePerformanceClimateChangeQ67_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q67_3_VALUE:
    'corporatePerformanceClimateChangeQ67_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q67_4_VALUE:
    'corporatePerformanceClimateChangeQ67_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q68_VALUE:
    'corporatePerformanceClimateChangeQ68_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q68_1_VALUE:
    'corporatePerformanceClimateChangeQ68_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q68_2_VALUE:
    'corporatePerformanceClimateChangeQ68_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q69_VALUE:
    'corporatePerformanceClimateChangeQ69_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q69_1_VALUE:
    'corporatePerformanceClimateChangeQ69_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q69_2_VALUE:
    'corporatePerformanceClimateChangeQ69_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q69_3_VALUE:
    'corporatePerformanceClimateChangeQ69_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q69_4_VALUE:
    'corporatePerformanceClimateChangeQ69_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q70_VALUE:
    'corporatePerformanceClimateChangeQ70_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q70_1_VALUE:
    'corporatePerformanceClimateChangeQ70_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q70_2_VALUE:
    'corporatePerformanceClimateChangeQ70_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q71_VALUE:
    'corporatePerformanceClimateChangeQ71_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q71_1_VALUE:
    'corporatePerformanceClimateChangeQ71_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q71_2_VALUE:
    'corporatePerformanceClimateChangeQ71_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q71_3_VALUE:
    'corporatePerformanceClimateChangeQ71_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q71_4_VALUE:
    'corporatePerformanceClimateChangeQ71_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_VALUE:
    'corporatePerformanceClimateChangeQ72_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_1_VALUE:
    'corporatePerformanceClimateChangeQ72_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_2_VALUE:
    'corporatePerformanceClimateChangeQ72_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_3_VALUE:
    'corporatePerformanceClimateChangeQ72_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_4_VALUE:
    'corporatePerformanceClimateChangeQ72_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_5_VALUE:
    'corporatePerformanceClimateChangeQ72_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_6_VALUE:
    'corporatePerformanceClimateChangeQ72_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_7_VALUE:
    'corporatePerformanceClimateChangeQ72_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_8_VALUE:
    'corporatePerformanceClimateChangeQ72_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_9_VALUE:
    'corporatePerformanceClimateChangeQ72_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_10_VALUE:
    'corporatePerformanceClimateChangeQ72_10_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q73_VALUE:
    'corporatePerformanceClimateChangeQ73_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q73_1_VALUE:
    'corporatePerformanceClimateChangeQ73_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q73_2_VALUE:
    'corporatePerformanceClimateChangeQ73_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q73_3_VALUE:
    'corporatePerformanceClimateChangeQ73_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q73_4_VALUE:
    'corporatePerformanceClimateChangeQ73_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_VALUE:
    'corporatePerformanceClimateChangeQ74_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_1_VALUE:
    'corporatePerformanceClimateChangeQ74_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_2_VALUE:
    'corporatePerformanceClimateChangeQ74_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_3_VALUE:
    'corporatePerformanceClimateChangeQ74_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_4_VALUE:
    'corporatePerformanceClimateChangeQ74_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_5_VALUE:
    'corporatePerformanceClimateChangeQ74_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_6_VALUE:
    'corporatePerformanceClimateChangeQ74_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_7_VALUE:
    'corporatePerformanceClimateChangeQ74_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_8_VALUE:
    'corporatePerformanceClimateChangeQ74_8_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_VALUE:
    'corporatePerformanceClimateChangeQ75_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_1_VALUE:
    'corporatePerformanceClimateChangeQ75_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_2_VALUE:
    'corporatePerformanceClimateChangeQ75_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_3_VALUE:
    'corporatePerformanceClimateChangeQ75_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_4_VALUE:
    'corporatePerformanceClimateChangeQ75_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_5_VALUE:
    'corporatePerformanceClimateChangeQ75_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_6_VALUE:
    'corporatePerformanceClimateChangeQ75_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_7_VALUE:
    'corporatePerformanceClimateChangeQ75_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_8_VALUE:
    'corporatePerformanceClimateChangeQ75_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_9_VALUE:
    'corporatePerformanceClimateChangeQ75_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_10_VALUE:
    'corporatePerformanceClimateChangeQ75_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_11_VALUE:
    'corporatePerformanceClimateChangeQ75_11_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_12_VALUE:
    'corporatePerformanceClimateChangeQ75_12_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_VALUE:
    'corporatePerformanceClimateChangeQ76_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_1_VALUE:
    'corporatePerformanceClimateChangeQ76_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_2_VALUE:
    'corporatePerformanceClimateChangeQ76_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_3_VALUE:
    'corporatePerformanceClimateChangeQ76_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_4_VALUE:
    'corporatePerformanceClimateChangeQ76_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_5_VALUE:
    'corporatePerformanceClimateChangeQ76_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_6_VALUE:
    'corporatePerformanceClimateChangeQ76_6_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_VALUE:
    'corporatePerformanceClimateChangeQ77_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_1_VALUE:
    'corporatePerformanceClimateChangeQ77_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_2_VALUE:
    'corporatePerformanceClimateChangeQ77_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_3_VALUE:
    'corporatePerformanceClimateChangeQ77_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_4_VALUE:
    'corporatePerformanceClimateChangeQ77_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_5_VALUE:
    'corporatePerformanceClimateChangeQ77_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_6_VALUE:
    'corporatePerformanceClimateChangeQ77_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_7_VALUE:
    'corporatePerformanceClimateChangeQ77_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_8_VALUE:
    'corporatePerformanceClimateChangeQ77_8_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q78_VALUE:
    'corporatePerformanceClimateChangeQ78_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q79_VALUE:
    'corporatePerformanceClimateChangeQ79_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q79_1_VALUE:
    'corporatePerformanceClimateChangeQ79_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q79_2_VALUE:
    'corporatePerformanceClimateChangeQ79_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q80_VALUE:
    'corporatePerformanceClimateChangeQ80_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q80_1_VALUE:
    'corporatePerformanceClimateChangeQ80_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q80_2_VALUE:
    'corporatePerformanceClimateChangeQ80_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q80_3_VALUE:
    'corporatePerformanceClimateChangeQ80_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q81_VALUE:
    'corporatePerformanceClimateChangeQ81_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_VALUE:
    'corporatePerformanceClimateChangeQ82_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_1_VALUE:
    'corporatePerformanceClimateChangeQ82_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_2_VALUE:
    'corporatePerformanceClimateChangeQ82_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_3_VALUE:
    'corporatePerformanceClimateChangeQ82_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_4_VALUE:
    'corporatePerformanceClimateChangeQ82_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_5_VALUE:
    'corporatePerformanceClimateChangeQ82_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_6_VALUE:
    'corporatePerformanceClimateChangeQ82_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_7_VALUE:
    'corporatePerformanceClimateChangeQ82_7_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q83_VALUE:
    'corporatePerformanceClimateChangeQ83_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q83_1_VALUE:
    'corporatePerformanceClimateChangeQ83_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q83_2_VALUE:
    'corporatePerformanceClimateChangeQ83_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_VALUE:
    'corporatePerformanceClimateChangeQ84_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_1_VALUE:
    'corporatePerformanceClimateChangeQ84_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_2_VALUE:
    'corporatePerformanceClimateChangeQ84_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_3_VALUE:
    'corporatePerformanceClimateChangeQ84_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_4_VALUE:
    'corporatePerformanceClimateChangeQ84_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_5_VALUE:
    'corporatePerformanceClimateChangeQ84_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_6_VALUE:
    'corporatePerformanceClimateChangeQ84_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_7_VALUE:
    'corporatePerformanceClimateChangeQ84_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_8_VALUE:
    'corporatePerformanceClimateChangeQ84_8_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q85_VALUE:
    'corporatePerformanceClimateChangeQ85_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_VALUE:
    'corporatePerformanceClimateChangeQ86_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_1_VALUE:
    'corporatePerformanceClimateChangeQ86_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_2_VALUE:
    'corporatePerformanceClimateChangeQ86_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_3_VALUE:
    'corporatePerformanceClimateChangeQ86_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_4_VALUE:
    'corporatePerformanceClimateChangeQ86_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_5_VALUE:
    'corporatePerformanceClimateChangeQ86_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_6_VALUE:
    'corporatePerformanceClimateChangeQ86_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_7_VALUE:
    'corporatePerformanceClimateChangeQ86_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_8_VALUE:
    'corporatePerformanceClimateChangeQ86_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_9_VALUE:
    'corporatePerformanceClimateChangeQ86_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_10_VALUE:
    'corporatePerformanceClimateChangeQ86_10_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q87_VALUE:
    'corporatePerformanceClimateChangeQ87_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q87_1_VALUE:
    'corporatePerformanceClimateChangeQ87_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q87_2_VALUE:
    'corporatePerformanceClimateChangeQ87_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_VALUE:
    'corporatePerformanceClimateChangeQ88_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_1_VALUE:
    'corporatePerformanceClimateChangeQ88_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_2_VALUE:
    'corporatePerformanceClimateChangeQ88_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_3_VALUE:
    'corporatePerformanceClimateChangeQ88_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_4_VALUE:
    'corporatePerformanceClimateChangeQ88_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_5_VALUE:
    'corporatePerformanceClimateChangeQ88_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_6_VALUE:
    'corporatePerformanceClimateChangeQ88_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_7_VALUE:
    'corporatePerformanceClimateChangeQ88_7_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_VALUE:
    'corporatePerformanceClimateChangeQ89_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_1_VALUE:
    'corporatePerformanceClimateChangeQ89_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_2_VALUE:
    'corporatePerformanceClimateChangeQ89_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_3_VALUE:
    'corporatePerformanceClimateChangeQ89_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_4_VALUE:
    'corporatePerformanceClimateChangeQ89_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_5_VALUE:
    'corporatePerformanceClimateChangeQ89_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_6_VALUE:
    'corporatePerformanceClimateChangeQ89_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_7_VALUE:
    'corporatePerformanceClimateChangeQ89_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_8_VALUE:
    'corporatePerformanceClimateChangeQ89_8_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_VALUE:
    'corporatePerformanceClimateChangeQ90_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_1_VALUE:
    'corporatePerformanceClimateChangeQ90_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_2_VALUE:
    'corporatePerformanceClimateChangeQ90_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_3_VALUE:
    'corporatePerformanceClimateChangeQ90_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_4_VALUE:
    'corporatePerformanceClimateChangeQ90_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_5_VALUE:
    'corporatePerformanceClimateChangeQ90_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_6_VALUE:
    'corporatePerformanceClimateChangeQ90_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_7_VALUE:
    'corporatePerformanceClimateChangeQ90_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_8_VALUE:
    'corporatePerformanceClimateChangeQ90_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_9_VALUE:
    'corporatePerformanceClimateChangeQ90_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_10_VALUE:
    'corporatePerformanceClimateChangeQ90_10_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_VALUE:
    'corporatePerformanceClimateChangeQ91_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_1_VALUE:
    'corporatePerformanceClimateChangeQ91_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_2_VALUE:
    'corporatePerformanceClimateChangeQ91_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_3_VALUE:
    'corporatePerformanceClimateChangeQ91_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_4_VALUE:
    'corporatePerformanceClimateChangeQ91_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_5_VALUE:
    'corporatePerformanceClimateChangeQ91_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_6_VALUE:
    'corporatePerformanceClimateChangeQ91_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_7_VALUE:
    'corporatePerformanceClimateChangeQ91_7_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q92_VALUE:
    'corporatePerformanceClimateChangeQ92_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q92_1_VALUE:
    'corporatePerformanceClimateChangeQ92_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q92_2_VALUE:
    'corporatePerformanceClimateChangeQ92_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q92_3_VALUE:
    'corporatePerformanceClimateChangeQ92_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q92_4_VALUE:
    'corporatePerformanceClimateChangeQ92_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q92_5_VALUE:
    'corporatePerformanceClimateChangeQ92_5_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q93_VALUE:
    'corporatePerformanceClimateChangeQ93_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q93_1_VALUE:
    'corporatePerformanceClimateChangeQ93_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q93_2_VALUE:
    'corporatePerformanceClimateChangeQ93_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q94_VALUE:
    'corporatePerformanceClimateChangeQ94_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q95_VALUE:
    'corporatePerformanceClimateChangeQ95_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q95_1_VALUE:
    'corporatePerformanceClimateChangeQ95_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q95_2_VALUE:
    'corporatePerformanceClimateChangeQ95_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q95_3_VALUE:
    'corporatePerformanceClimateChangeQ95_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q95_4_VALUE:
    'corporatePerformanceClimateChangeQ95_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q96_VALUE:
    'corporatePerformanceClimateChangeQ96_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q96_1_VALUE:
    'corporatePerformanceClimateChangeQ96_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q96_2_VALUE:
    'corporatePerformanceClimateChangeQ96_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q96_3_VALUE:
    'corporatePerformanceClimateChangeQ96_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q96_4_VALUE:
    'corporatePerformanceClimateChangeQ96_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_VALUE:
    'corporatePerformanceClimateChangeQ97_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_1_VALUE:
    'corporatePerformanceClimateChangeQ97_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_2_VALUE:
    'corporatePerformanceClimateChangeQ97_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_3_VALUE:
    'corporatePerformanceClimateChangeQ97_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_4_VALUE:
    'corporatePerformanceClimateChangeQ97_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_5_VALUE:
    'corporatePerformanceClimateChangeQ97_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_6_VALUE:
    'corporatePerformanceClimateChangeQ97_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_7_VALUE:
    'corporatePerformanceClimateChangeQ97_7_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_VALUE:
    'corporatePerformanceClimateChangeQ98_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_1_VALUE:
    'corporatePerformanceClimateChangeQ98_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_2_VALUE:
    'corporatePerformanceClimateChangeQ98_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_3_VALUE:
    'corporatePerformanceClimateChangeQ98_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_4_VALUE:
    'corporatePerformanceClimateChangeQ98_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_5_VALUE:
    'corporatePerformanceClimateChangeQ98_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_6_VALUE:
    'corporatePerformanceClimateChangeQ98_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_7_VALUE:
    'corporatePerformanceClimateChangeQ98_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_8_VALUE:
    'corporatePerformanceClimateChangeQ98_8_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q99_VALUE:
    'corporatePerformanceClimateChangeQ99_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q99_1_VALUE:
    'corporatePerformanceClimateChangeQ99_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q99_2_VALUE:
    'corporatePerformanceClimateChangeQ99_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q100_VALUE:
    'corporatePerformanceClimateChangeQ100_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q100_1_VALUE:
    'corporatePerformanceClimateChangeQ100_1_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q101_VALUE:
    'corporatePerformanceClimateChangeQ101_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q101_1_VALUE:
    'corporatePerformanceClimateChangeQ101_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q101_2_VALUE:
    'corporatePerformanceClimateChangeQ101_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q101_3_VALUE:
    'corporatePerformanceClimateChangeQ101_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q101_4_VALUE:
    'corporatePerformanceClimateChangeQ101_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q101_5_VALUE:
    'corporatePerformanceClimateChangeQ101_5_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q102_VALUE:
    'corporatePerformanceClimateChangeQ102_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q102_1_VALUE:
    'corporatePerformanceClimateChangeQ102_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q102_2_VALUE:
    'corporatePerformanceClimateChangeQ102_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q102_3_VALUE:
    'corporatePerformanceClimateChangeQ102_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q102_4_VALUE:
    'corporatePerformanceClimateChangeQ102_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_VALUE:
    'corporatePerformanceClimateChangeQ103_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_1_VALUE:
    'corporatePerformanceClimateChangeQ103_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_2_VALUE:
    'corporatePerformanceClimateChangeQ103_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_3_VALUE:
    'corporatePerformanceClimateChangeQ103_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_4_VALUE:
    'corporatePerformanceClimateChangeQ103_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_5_VALUE:
    'corporatePerformanceClimateChangeQ103_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_6_VALUE:
    'corporatePerformanceClimateChangeQ103_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_7_VALUE:
    'corporatePerformanceClimateChangeQ103_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_8_VALUE:
    'corporatePerformanceClimateChangeQ103_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_9_VALUE:
    'corporatePerformanceClimateChangeQ103_9_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_VALUE:
    'corporatePerformanceClimateChangeQ104_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_1_VALUE:
    'corporatePerformanceClimateChangeQ104_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_2_VALUE:
    'corporatePerformanceClimateChangeQ104_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_3_VALUE:
    'corporatePerformanceClimateChangeQ104_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_4_VALUE:
    'corporatePerformanceClimateChangeQ104_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_5_VALUE:
    'corporatePerformanceClimateChangeQ104_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_6_VALUE:
    'corporatePerformanceClimateChangeQ104_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_7_VALUE:
    'corporatePerformanceClimateChangeQ104_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_8_VALUE:
    'corporatePerformanceClimateChangeQ104_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_9_VALUE:
    'corporatePerformanceClimateChangeQ104_9_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q105_VALUE:
    'corporatePerformanceClimateChangeQ105_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q106_VALUE:
    'corporatePerformanceClimateChangeQ106_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q106_1_VALUE:
    'corporatePerformanceClimateChangeQ106_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q106_2_VALUE:
    'corporatePerformanceClimateChangeQ106_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q107_VALUE:
    'corporatePerformanceClimateChangeQ107_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q108_VALUE:
    'corporatePerformanceClimateChangeQ108_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q108_1_VALUE:
    'corporatePerformanceClimateChangeQ108_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q108_2_VALUE:
    'corporatePerformanceClimateChangeQ108_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q109_VALUE:
    'corporatePerformanceClimateChangeQ109_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q109_1_VALUE:
    'corporatePerformanceClimateChangeQ109_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q109_2_VALUE:
    'corporatePerformanceClimateChangeQ109_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q109_3_VALUE:
    'corporatePerformanceClimateChangeQ109_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q110_VALUE:
    'corporatePerformanceClimateChangeQ110_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_VALUE:
    'corporatePerformanceClimateChangeQ111_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_1_VALUE:
    'corporatePerformanceClimateChangeQ111_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_2_VALUE:
    'corporatePerformanceClimateChangeQ111_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_3_VALUE:
    'corporatePerformanceClimateChangeQ111_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_4_VALUE:
    'corporatePerformanceClimateChangeQ111_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_5_VALUE:
    'corporatePerformanceClimateChangeQ111_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_6_VALUE:
    'corporatePerformanceClimateChangeQ111_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_7_VALUE:
    'corporatePerformanceClimateChangeQ111_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_8_VALUE:
    'corporatePerformanceClimateChangeQ111_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_9_VALUE:
    'corporatePerformanceClimateChangeQ111_9_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q112_VALUE:
    'corporatePerformanceClimateChangeQ112_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q112_1_VALUE:
    'corporatePerformanceClimateChangeQ112_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q112_2_VALUE:
    'corporatePerformanceClimateChangeQ112_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q112_3_VALUE:
    'corporatePerformanceClimateChangeQ112_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q112_4_VALUE:
    'corporatePerformanceClimateChangeQ112_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q112_5_VALUE:
    'corporatePerformanceClimateChangeQ112_5_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q113_VALUE:
    'corporatePerformanceClimateChangeQ113_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q113_1_VALUE:
    'corporatePerformanceClimateChangeQ113_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q113_2_VALUE:
    'corporatePerformanceClimateChangeQ113_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q113_3_VALUE:
    'corporatePerformanceClimateChangeQ113_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q114_VALUE:
    'corporatePerformanceClimateChangeQ114_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q114_1_VALUE:
    'corporatePerformanceClimateChangeQ114_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q114_2_VALUE:
    'corporatePerformanceClimateChangeQ114_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q114_3_VALUE:
    'corporatePerformanceClimateChangeQ114_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q114_4_VALUE:
    'corporatePerformanceClimateChangeQ114_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q114_5_VALUE:
    'corporatePerformanceClimateChangeQ114_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q114_6_VALUE:
    'corporatePerformanceClimateChangeQ114_6_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q115_VALUE:
    'corporatePerformanceClimateChangeQ115_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q115_1_VALUE:
    'corporatePerformanceClimateChangeQ115_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q115_2_VALUE:
    'corporatePerformanceClimateChangeQ115_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q115_3_VALUE:
    'corporatePerformanceClimateChangeQ115_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q115_4_VALUE:
    'corporatePerformanceClimateChangeQ115_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q115_5_VALUE:
    'corporatePerformanceClimateChangeQ115_5_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_VALUE:
    'corporatePerformanceClimateChangeQ116_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_1_VALUE:
    'corporatePerformanceClimateChangeQ116_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_2_VALUE:
    'corporatePerformanceClimateChangeQ116_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_3_VALUE:
    'corporatePerformanceClimateChangeQ116_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_4_VALUE:
    'corporatePerformanceClimateChangeQ116_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_5_VALUE:
    'corporatePerformanceClimateChangeQ116_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_6_VALUE:
    'corporatePerformanceClimateChangeQ116_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_7_VALUE:
    'corporatePerformanceClimateChangeQ116_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_8_VALUE:
    'corporatePerformanceClimateChangeQ116_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_9_VALUE:
    'corporatePerformanceClimateChangeQ116_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_10_VALUE:
    'corporatePerformanceClimateChangeQ116_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_11_VALUE:
    'corporatePerformanceClimateChangeQ116_11_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q117_VALUE:
    'corporatePerformanceClimateChangeQ117_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q117_1_VALUE:
    'corporatePerformanceClimateChangeQ117_1_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_VALUE:
    'corporatePerformanceClimateChangeQ118_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_1_VALUE:
    'corporatePerformanceClimateChangeQ118_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_2_VALUE:
    'corporatePerformanceClimateChangeQ118_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_3_VALUE:
    'corporatePerformanceClimateChangeQ118_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_4_VALUE:
    'corporatePerformanceClimateChangeQ118_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_5_VALUE:
    'corporatePerformanceClimateChangeQ118_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_6_VALUE:
    'corporatePerformanceClimateChangeQ118_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_7_VALUE:
    'corporatePerformanceClimateChangeQ118_7_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q119_VALUE:
    'corporatePerformanceClimateChangeQ119_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_VALUE:
    'corporatePerformanceClimateChangeQ120_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_1_VALUE:
    'corporatePerformanceClimateChangeQ120_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_2_VALUE:
    'corporatePerformanceClimateChangeQ120_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_3_VALUE:
    'corporatePerformanceClimateChangeQ120_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_4_VALUE:
    'corporatePerformanceClimateChangeQ120_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_5_VALUE:
    'corporatePerformanceClimateChangeQ120_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_6_VALUE:
    'corporatePerformanceClimateChangeQ120_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_7_VALUE:
    'corporatePerformanceClimateChangeQ120_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE:
    'corporatePerformanceClimateChangeQ120_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_9_VALUE:
    'corporatePerformanceClimateChangeQ120_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_10_VALUE:
    'corporatePerformanceClimateChangeQ120_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_11_VALUE:
    'corporatePerformanceClimateChangeQ120_11_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_12_VALUE:
    'corporatePerformanceClimateChangeQ120_12_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_13_VALUE:
    'corporatePerformanceClimateChangeQ120_13_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_14_VALUE:
    'corporatePerformanceClimateChangeQ120_14_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_15_VALUE:
    'corporatePerformanceClimateChangeQ120_15_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_16_VALUE:
    'corporatePerformanceClimateChangeQ120_16_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_17_VALUE:
    'corporatePerformanceClimateChangeQ120_17_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_18_VALUE:
    'corporatePerformanceClimateChangeQ120_18_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_19_VALUE:
    'corporatePerformanceClimateChangeQ120_19_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_20_VALUE:
    'corporatePerformanceClimateChangeQ120_20_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_21_VALUE:
    'corporatePerformanceClimateChangeQ120_21_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_22_VALUE:
    'corporatePerformanceClimateChangeQ120_22_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_23_VALUE:
    'corporatePerformanceClimateChangeQ120_23_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_24_VALUE:
    'corporatePerformanceClimateChangeQ120_24_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_25_VALUE:
    'corporatePerformanceClimateChangeQ120_25_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_26_VALUE:
    'corporatePerformanceClimateChangeQ120_26_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_27_VALUE:
    'corporatePerformanceClimateChangeQ120_27_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_28_VALUE:
    'corporatePerformanceClimateChangeQ120_28_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_29_VALUE:
    'corporatePerformanceClimateChangeQ120_29_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_30_VALUE:
    'corporatePerformanceClimateChangeQ120_30_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_31_VALUE:
    'corporatePerformanceClimateChangeQ120_31_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_32_VALUE:
    'corporatePerformanceClimateChangeQ120_32_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_33_VALUE:
    'corporatePerformanceClimateChangeQ120_33_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_34_VALUE:
    'corporatePerformanceClimateChangeQ120_34_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_35_VALUE:
    'corporatePerformanceClimateChangeQ120_35_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_36_VALUE:
    'corporatePerformanceClimateChangeQ120_36_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_37_VALUE:
    'corporatePerformanceClimateChangeQ120_37_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_38_VALUE:
    'corporatePerformanceClimateChangeQ120_38_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_39_VALUE:
    'corporatePerformanceClimateChangeQ120_39_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_40_VALUE:
    'corporatePerformanceClimateChangeQ120_40_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_41_VALUE:
    'corporatePerformanceClimateChangeQ120_41_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_42_VALUE:
    'corporatePerformanceClimateChangeQ120_42_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_43_VALUE:
    'corporatePerformanceClimateChangeQ120_43_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_44_VALUE:
    'corporatePerformanceClimateChangeQ120_44_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_45_VALUE:
    'corporatePerformanceClimateChangeQ120_45_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_46_VALUE:
    'corporatePerformanceClimateChangeQ120_46_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_47_VALUE:
    'corporatePerformanceClimateChangeQ120_47_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_48_VALUE:
    'corporatePerformanceClimateChangeQ120_48_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_49_VALUE:
    'corporatePerformanceClimateChangeQ120_49_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_50_VALUE:
    'corporatePerformanceClimateChangeQ120_50_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_51_VALUE:
    'corporatePerformanceClimateChangeQ120_51_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_52_VALUE:
    'corporatePerformanceClimateChangeQ120_52_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_53_VALUE:
    'corporatePerformanceClimateChangeQ120_53_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_54_VALUE:
    'corporatePerformanceClimateChangeQ120_54_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_55_VALUE:
    'corporatePerformanceClimateChangeQ120_55_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_56_VALUE:
    'corporatePerformanceClimateChangeQ120_56_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_57_VALUE:
    'corporatePerformanceClimateChangeQ120_57_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_58_VALUE:
    'corporatePerformanceClimateChangeQ120_58_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_59_VALUE:
    'corporatePerformanceClimateChangeQ120_59_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_60_VALUE:
    'corporatePerformanceClimateChangeQ120_60_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_61_VALUE:
    'corporatePerformanceClimateChangeQ120_61_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_62_VALUE:
    'corporatePerformanceClimateChangeQ120_62_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_63_VALUE:
    'corporatePerformanceClimateChangeQ120_63_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_64_VALUE:
    'corporatePerformanceClimateChangeQ120_64_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_65_VALUE:
    'corporatePerformanceClimateChangeQ120_65_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_66_VALUE:
    'corporatePerformanceClimateChangeQ120_66_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_67_VALUE:
    'corporatePerformanceClimateChangeQ120_67_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_68_VALUE:
    'corporatePerformanceClimateChangeQ120_68_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_69_VALUE:
    'corporatePerformanceClimateChangeQ120_69_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_70_VALUE:
    'corporatePerformanceClimateChangeQ120_70_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_71_VALUE:
    'corporatePerformanceClimateChangeQ120_71_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_72_VALUE:
    'corporatePerformanceClimateChangeQ120_72_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_73_VALUE:
    'corporatePerformanceClimateChangeQ120_73_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_74_VALUE:
    'corporatePerformanceClimateChangeQ120_74_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_75_VALUE:
    'corporatePerformanceClimateChangeQ120_75_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_76_VALUE:
    'corporatePerformanceClimateChangeQ120_76_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_77_VALUE:
    'corporatePerformanceClimateChangeQ120_77_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_78_VALUE:
    'corporatePerformanceClimateChangeQ120_78_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_79_VALUE:
    'corporatePerformanceClimateChangeQ120_79_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_80_VALUE:
    'corporatePerformanceClimateChangeQ120_80_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_81_VALUE:
    'corporatePerformanceClimateChangeQ120_81_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_82_VALUE:
    'corporatePerformanceClimateChangeQ120_82_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_83_VALUE:
    'corporatePerformanceClimateChangeQ120_83_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_84_VALUE:
    'corporatePerformanceClimateChangeQ120_84_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_85_VALUE:
    'corporatePerformanceClimateChangeQ120_85_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_86_VALUE:
    'corporatePerformanceClimateChangeQ120_86_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_VALUE:
    'corporatePerformanceClimateChangeQ121_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_1_VALUE:
    'corporatePerformanceClimateChangeQ121_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_2_VALUE:
    'corporatePerformanceClimateChangeQ121_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_3_VALUE:
    'corporatePerformanceClimateChangeQ121_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_4_VALUE:
    'corporatePerformanceClimateChangeQ121_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_5_VALUE:
    'corporatePerformanceClimateChangeQ121_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_6_VALUE:
    'corporatePerformanceClimateChangeQ121_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_7_VALUE:
    'corporatePerformanceClimateChangeQ121_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE:
    'corporatePerformanceClimateChangeQ121_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_9_VALUE:
    'corporatePerformanceClimateChangeQ121_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_10_VALUE:
    'corporatePerformanceClimateChangeQ121_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_11_VALUE:
    'corporatePerformanceClimateChangeQ121_11_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_12_VALUE:
    'corporatePerformanceClimateChangeQ121_12_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_13_VALUE:
    'corporatePerformanceClimateChangeQ121_13_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_14_VALUE:
    'corporatePerformanceClimateChangeQ121_14_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_15_VALUE:
    'corporatePerformanceClimateChangeQ121_15_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_16_VALUE:
    'corporatePerformanceClimateChangeQ121_16_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_17_VALUE:
    'corporatePerformanceClimateChangeQ121_17_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_18_VALUE:
    'corporatePerformanceClimateChangeQ121_18_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_19_VALUE:
    'corporatePerformanceClimateChangeQ121_19_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_20_VALUE:
    'corporatePerformanceClimateChangeQ121_20_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_21_VALUE:
    'corporatePerformanceClimateChangeQ121_21_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_22_VALUE:
    'corporatePerformanceClimateChangeQ121_22_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_23_VALUE:
    'corporatePerformanceClimateChangeQ121_23_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_24_VALUE:
    'corporatePerformanceClimateChangeQ121_24_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_25_VALUE:
    'corporatePerformanceClimateChangeQ121_25_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_26_VALUE:
    'corporatePerformanceClimateChangeQ121_26_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_27_VALUE:
    'corporatePerformanceClimateChangeQ121_27_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_28_VALUE:
    'corporatePerformanceClimateChangeQ121_28_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_29_VALUE:
    'corporatePerformanceClimateChangeQ121_29_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_30_VALUE:
    'corporatePerformanceClimateChangeQ121_30_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_31_VALUE:
    'corporatePerformanceClimateChangeQ121_31_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_32_VALUE:
    'corporatePerformanceClimateChangeQ121_32_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_33_VALUE:
    'corporatePerformanceClimateChangeQ121_33_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_34_VALUE:
    'corporatePerformanceClimateChangeQ121_34_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_35_VALUE:
    'corporatePerformanceClimateChangeQ121_35_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_36_VALUE:
    'corporatePerformanceClimateChangeQ121_36_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_37_VALUE:
    'corporatePerformanceClimateChangeQ121_37_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_38_VALUE:
    'corporatePerformanceClimateChangeQ121_38_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_39_VALUE:
    'corporatePerformanceClimateChangeQ121_39_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_40_VALUE:
    'corporatePerformanceClimateChangeQ121_40_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_41_VALUE:
    'corporatePerformanceClimateChangeQ121_41_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_42_VALUE:
    'corporatePerformanceClimateChangeQ121_42_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_43_VALUE:
    'corporatePerformanceClimateChangeQ121_43_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_44_VALUE:
    'corporatePerformanceClimateChangeQ121_44_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_45_VALUE:
    'corporatePerformanceClimateChangeQ121_45_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_46_VALUE:
    'corporatePerformanceClimateChangeQ121_46_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_47_VALUE:
    'corporatePerformanceClimateChangeQ121_47_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_48_VALUE:
    'corporatePerformanceClimateChangeQ121_48_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_49_VALUE:
    'corporatePerformanceClimateChangeQ121_49_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_50_VALUE:
    'corporatePerformanceClimateChangeQ121_50_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_51_VALUE:
    'corporatePerformanceClimateChangeQ121_51_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_52_VALUE:
    'corporatePerformanceClimateChangeQ121_52_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_53_VALUE:
    'corporatePerformanceClimateChangeQ121_53_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_54_VALUE:
    'corporatePerformanceClimateChangeQ121_54_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_55_VALUE:
    'corporatePerformanceClimateChangeQ121_55_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_56_VALUE:
    'corporatePerformanceClimateChangeQ121_56_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_57_VALUE:
    'corporatePerformanceClimateChangeQ121_57_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_58_VALUE:
    'corporatePerformanceClimateChangeQ121_58_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_59_VALUE:
    'corporatePerformanceClimateChangeQ121_59_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_60_VALUE:
    'corporatePerformanceClimateChangeQ121_60_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_61_VALUE:
    'corporatePerformanceClimateChangeQ121_61_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_62_VALUE:
    'corporatePerformanceClimateChangeQ121_62_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_63_VALUE:
    'corporatePerformanceClimateChangeQ121_63_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_64_VALUE:
    'corporatePerformanceClimateChangeQ121_64_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_65_VALUE:
    'corporatePerformanceClimateChangeQ121_65_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_66_VALUE:
    'corporatePerformanceClimateChangeQ121_66_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_67_VALUE:
    'corporatePerformanceClimateChangeQ121_67_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_68_VALUE:
    'corporatePerformanceClimateChangeQ121_68_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_69_VALUE:
    'corporatePerformanceClimateChangeQ121_69_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_70_VALUE:
    'corporatePerformanceClimateChangeQ121_70_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_71_VALUE:
    'corporatePerformanceClimateChangeQ121_71_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_72_VALUE:
    'corporatePerformanceClimateChangeQ121_72_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_73_VALUE:
    'corporatePerformanceClimateChangeQ121_73_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_74_VALUE:
    'corporatePerformanceClimateChangeQ121_74_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_75_VALUE:
    'corporatePerformanceClimateChangeQ121_75_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_76_VALUE:
    'corporatePerformanceClimateChangeQ121_76_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_77_VALUE:
    'corporatePerformanceClimateChangeQ121_77_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_78_VALUE:
    'corporatePerformanceClimateChangeQ121_78_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_79_VALUE:
    'corporatePerformanceClimateChangeQ121_79_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_80_VALUE:
    'corporatePerformanceClimateChangeQ121_80_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_81_VALUE:
    'corporatePerformanceClimateChangeQ121_81_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_82_VALUE:
    'corporatePerformanceClimateChangeQ121_82_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_83_VALUE:
    'corporatePerformanceClimateChangeQ121_83_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_84_VALUE:
    'corporatePerformanceClimateChangeQ121_84_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_85_VALUE:
    'corporatePerformanceClimateChangeQ121_85_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_86_VALUE:
    'corporatePerformanceClimateChangeQ121_86_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_87_VALUE:
    'corporatePerformanceClimateChangeQ121_87_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_88_VALUE:
    'corporatePerformanceClimateChangeQ121_88_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_89_VALUE:
    'corporatePerformanceClimateChangeQ121_89_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q122_VALUE:
    'corporatePerformanceClimateChangeQ122_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q122_1_VALUE:
    'corporatePerformanceClimateChangeQ122_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q122_2_VALUE:
    'corporatePerformanceClimateChangeQ122_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q122_3_VALUE:
    'corporatePerformanceClimateChangeQ122_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_VALUE:
    'corporatePerformanceClimateChangeQ123_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_1_VALUE:
    'corporatePerformanceClimateChangeQ123_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE:
    'corporatePerformanceClimateChangeQ123_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_3_VALUE:
    'corporatePerformanceClimateChangeQ123_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_4_VALUE:
    'corporatePerformanceClimateChangeQ123_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_5_VALUE:
    'corporatePerformanceClimateChangeQ123_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_6_VALUE:
    'corporatePerformanceClimateChangeQ123_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_7_VALUE:
    'corporatePerformanceClimateChangeQ123_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_8_VALUE:
    'corporatePerformanceClimateChangeQ123_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_9_VALUE:
    'corporatePerformanceClimateChangeQ123_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_10_VALUE:
    'corporatePerformanceClimateChangeQ123_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_11_VALUE:
    'corporatePerformanceClimateChangeQ123_11_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_12_VALUE:
    'corporatePerformanceClimateChangeQ123_12_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_13_VALUE:
    'corporatePerformanceClimateChangeQ123_13_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_14_VALUE:
    'corporatePerformanceClimateChangeQ123_14_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_15_VALUE:
    'corporatePerformanceClimateChangeQ123_15_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_16_VALUE:
    'corporatePerformanceClimateChangeQ123_16_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_17_VALUE:
    'corporatePerformanceClimateChangeQ123_17_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_18_VALUE:
    'corporatePerformanceClimateChangeQ123_18_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_19_VALUE:
    'corporatePerformanceClimateChangeQ123_19_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_20_VALUE:
    'corporatePerformanceClimateChangeQ123_20_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_21_VALUE:
    'corporatePerformanceClimateChangeQ123_21_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_22_VALUE:
    'corporatePerformanceClimateChangeQ123_22_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_23_VALUE:
    'corporatePerformanceClimateChangeQ123_23_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_24_VALUE:
    'corporatePerformanceClimateChangeQ123_24_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_25_VALUE:
    'corporatePerformanceClimateChangeQ123_25_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_26_VALUE:
    'corporatePerformanceClimateChangeQ123_26_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_27_VALUE:
    'corporatePerformanceClimateChangeQ123_27_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_28_VALUE:
    'corporatePerformanceClimateChangeQ123_28_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_29_VALUE:
    'corporatePerformanceClimateChangeQ123_29_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_30_VALUE:
    'corporatePerformanceClimateChangeQ123_30_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_31_VALUE:
    'corporatePerformanceClimateChangeQ123_31_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_32_VALUE:
    'corporatePerformanceClimateChangeQ123_32_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_33_VALUE:
    'corporatePerformanceClimateChangeQ123_33_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_34_VALUE:
    'corporatePerformanceClimateChangeQ123_34_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_35_VALUE:
    'corporatePerformanceClimateChangeQ123_35_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_36_VALUE:
    'corporatePerformanceClimateChangeQ123_36_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_37_VALUE:
    'corporatePerformanceClimateChangeQ123_37_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_38_VALUE:
    'corporatePerformanceClimateChangeQ123_38_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q124_VALUE:
    'corporatePerformanceClimateChangeQ124_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_VALUE:
    'corporatePerformanceClimateChangeQ125_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_1_VALUE:
    'corporatePerformanceClimateChangeQ125_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_2_VALUE:
    'corporatePerformanceClimateChangeQ125_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_3_VALUE:
    'corporatePerformanceClimateChangeQ125_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_4_VALUE:
    'corporatePerformanceClimateChangeQ125_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_5_VALUE:
    'corporatePerformanceClimateChangeQ125_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_6_VALUE:
    'corporatePerformanceClimateChangeQ125_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_7_VALUE:
    'corporatePerformanceClimateChangeQ125_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_8_VALUE:
    'corporatePerformanceClimateChangeQ125_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_9_VALUE:
    'corporatePerformanceClimateChangeQ125_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_10_VALUE:
    'corporatePerformanceClimateChangeQ125_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_11_VALUE:
    'corporatePerformanceClimateChangeQ125_11_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_12_VALUE:
    'corporatePerformanceClimateChangeQ125_12_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_13_VALUE:
    'corporatePerformanceClimateChangeQ125_13_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_14_VALUE:
    'corporatePerformanceClimateChangeQ125_14_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_15_VALUE:
    'corporatePerformanceClimateChangeQ125_15_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_16_VALUE:
    'corporatePerformanceClimateChangeQ125_16_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_17_VALUE:
    'corporatePerformanceClimateChangeQ125_17_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_18_VALUE:
    'corporatePerformanceClimateChangeQ125_18_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_19_VALUE:
    'corporatePerformanceClimateChangeQ125_19_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_20_VALUE:
    'corporatePerformanceClimateChangeQ125_20_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_21_VALUE:
    'corporatePerformanceClimateChangeQ125_21_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_22_VALUE:
    'corporatePerformanceClimateChangeQ125_22_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_VALUE:
    'corporatePerformanceClimateChangeQ126_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_1_VALUE:
    'corporatePerformanceClimateChangeQ126_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_2_VALUE:
    'corporatePerformanceClimateChangeQ126_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_3_VALUE:
    'corporatePerformanceClimateChangeQ126_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_4_VALUE:
    'corporatePerformanceClimateChangeQ126_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_5_VALUE:
    'corporatePerformanceClimateChangeQ126_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_6_VALUE:
    'corporatePerformanceClimateChangeQ126_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_7_VALUE:
    'corporatePerformanceClimateChangeQ126_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_8_VALUE:
    'corporatePerformanceClimateChangeQ126_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_9_VALUE:
    'corporatePerformanceClimateChangeQ126_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_10_VALUE:
    'corporatePerformanceClimateChangeQ126_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_11_VALUE:
    'corporatePerformanceClimateChangeQ126_11_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_12_VALUE:
    'corporatePerformanceClimateChangeQ126_12_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_13_VALUE:
    'corporatePerformanceClimateChangeQ126_13_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_14_VALUE:
    'corporatePerformanceClimateChangeQ126_14_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_15_VALUE:
    'corporatePerformanceClimateChangeQ126_15_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_16_VALUE:
    'corporatePerformanceClimateChangeQ126_16_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_17_VALUE:
    'corporatePerformanceClimateChangeQ126_17_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_18_VALUE:
    'corporatePerformanceClimateChangeQ126_18_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_19_VALUE:
    'corporatePerformanceClimateChangeQ126_19_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_20_VALUE:
    'corporatePerformanceClimateChangeQ126_20_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_21_VALUE:
    'corporatePerformanceClimateChangeQ126_21_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_VALUE:
    'corporatePerformanceClimateChangeQ127_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_1_VALUE:
    'corporatePerformanceClimateChangeQ127_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_2_VALUE:
    'corporatePerformanceClimateChangeQ127_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_3_VALUE:
    'corporatePerformanceClimateChangeQ127_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_4_VALUE:
    'corporatePerformanceClimateChangeQ127_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_5_VALUE:
    'corporatePerformanceClimateChangeQ127_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_6_VALUE:
    'corporatePerformanceClimateChangeQ127_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_7_VALUE:
    'corporatePerformanceClimateChangeQ127_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_8_VALUE:
    'corporatePerformanceClimateChangeQ127_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_9_VALUE:
    'corporatePerformanceClimateChangeQ127_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_10_VALUE:
    'corporatePerformanceClimateChangeQ127_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_11_VALUE:
    'corporatePerformanceClimateChangeQ127_11_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_12_VALUE:
    'corporatePerformanceClimateChangeQ127_12_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_13_VALUE:
    'corporatePerformanceClimateChangeQ127_13_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_14_VALUE:
    'corporatePerformanceClimateChangeQ127_14_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_15_VALUE:
    'corporatePerformanceClimateChangeQ127_15_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_16_VALUE:
    'corporatePerformanceClimateChangeQ127_16_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_17_VALUE:
    'corporatePerformanceClimateChangeQ127_17_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_18_VALUE:
    'corporatePerformanceClimateChangeQ127_18_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_19_VALUE:
    'corporatePerformanceClimateChangeQ127_19_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q128_VALUE:
    'corporatePerformanceClimateChangeQ128_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q129_VALUE:
    'corporatePerformanceClimateChangeQ129_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q130_VALUE:
    'corporatePerformanceClimateChangeQ130_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q131_VALUE:
    'corporatePerformanceClimateChangeQ131_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q131_1_VALUE:
    'corporatePerformanceClimateChangeQ131_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q131_2_VALUE:
    'corporatePerformanceClimateChangeQ131_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_VALUE:
    'corporatePerformanceClimateChangeQ132_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_1_VALUE:
    'corporatePerformanceClimateChangeQ132_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_2_VALUE:
    'corporatePerformanceClimateChangeQ132_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_3_VALUE:
    'corporatePerformanceClimateChangeQ132_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_4_VALUE:
    'corporatePerformanceClimateChangeQ132_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_5_VALUE:
    'corporatePerformanceClimateChangeQ132_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_6_VALUE:
    'corporatePerformanceClimateChangeQ132_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_7_VALUE:
    'corporatePerformanceClimateChangeQ132_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_8_VALUE:
    'corporatePerformanceClimateChangeQ132_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_9_VALUE:
    'corporatePerformanceClimateChangeQ132_9_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q133_VALUE:
    'corporatePerformanceClimateChangeQ133_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q133_1_VALUE:
    'corporatePerformanceClimateChangeQ133_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q133_2_VALUE:
    'corporatePerformanceClimateChangeQ133_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q134_VALUE:
    'corporatePerformanceClimateChangeQ134_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_VALUE:
    'corporatePerformanceClimateChangeQ135_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE:
    'corporatePerformanceClimateChangeQ135_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_2_VALUE:
    'corporatePerformanceClimateChangeQ135_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_3_VALUE:
    'corporatePerformanceClimateChangeQ135_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_4_VALUE:
    'corporatePerformanceClimateChangeQ135_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_5_VALUE:
    'corporatePerformanceClimateChangeQ135_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_6_VALUE:
    'corporatePerformanceClimateChangeQ135_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_7_VALUE:
    'corporatePerformanceClimateChangeQ135_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_8_VALUE:
    'corporatePerformanceClimateChangeQ135_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_9_VALUE:
    'corporatePerformanceClimateChangeQ135_9_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q136_VALUE:
    'corporatePerformanceClimateChangeQ136_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q137_VALUE:
    'corporatePerformanceClimateChangeQ137_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q138_VALUE:
    'corporatePerformanceClimateChangeQ138_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q139_VALUE:
    'corporatePerformanceClimateChangeQ139_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q140_VALUE:
    'corporatePerformanceClimateChangeQ140_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q141_VALUE:
    'corporatePerformanceClimateChangeQ141_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q142_VALUE:
    'corporatePerformanceClimateChangeQ142_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q143_VALUE:
    'corporatePerformanceClimateChangeQ143_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q144_VALUE:
    'corporatePerformanceClimateChangeQ144_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q145_VALUE:
    'corporatePerformanceClimateChangeQ145_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q146_VALUE:
    'corporatePerformanceClimateChangeQ146_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q147_VALUE:
    'corporatePerformanceClimateChangeQ147_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q147_1_VALUE:
    'corporatePerformanceClimateChangeQ147_1_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q148_VALUE:
    'corporatePerformanceClimateChangeQ148_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q148_1_VALUE:
    'corporatePerformanceClimateChangeQ148_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q148_2_VALUE:
    'corporatePerformanceClimateChangeQ148_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q148_3_VALUE:
    'corporatePerformanceClimateChangeQ148_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q149_VALUE:
    'corporatePerformanceClimateChangeQ149_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q150_VALUE:
    'corporatePerformanceClimateChangeQ150_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q150_1_VALUE:
    'corporatePerformanceClimateChangeQ150_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q150_2_VALUE:
    'corporatePerformanceClimateChangeQ150_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_VALUE:
    'corporatePerformanceClimateChangeQ151_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_1_VALUE:
    'corporatePerformanceClimateChangeQ151_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_2_VALUE:
    'corporatePerformanceClimateChangeQ151_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_3_VALUE:
    'corporatePerformanceClimateChangeQ151_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_4_VALUE:
    'corporatePerformanceClimateChangeQ151_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_5_VALUE:
    'corporatePerformanceClimateChangeQ151_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_6_VALUE:
    'corporatePerformanceClimateChangeQ151_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_7_VALUE:
    'corporatePerformanceClimateChangeQ151_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_8_VALUE:
    'corporatePerformanceClimateChangeQ151_8_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q152_VALUE:
    'corporatePerformanceClimateChangeQ152_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q153_VALUE:
    'corporatePerformanceClimateChangeQ153_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q154_VALUE:
    'corporatePerformanceClimateChangeQ154_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q154_1_VALUE:
    'corporatePerformanceClimateChangeQ154_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q154_2_VALUE:
    'corporatePerformanceClimateChangeQ154_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q154_3_VALUE:
    'corporatePerformanceClimateChangeQ154_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q154_4_VALUE:
    'corporatePerformanceClimateChangeQ154_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q154_5_VALUE:
    'corporatePerformanceClimateChangeQ154_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q154_6_VALUE:
    'corporatePerformanceClimateChangeQ154_6_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q155_VALUE:
    'corporatePerformanceClimateChangeQ155_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_VALUE:
    'corporatePerformanceClimateChangeQ156_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_1_VALUE:
    'corporatePerformanceClimateChangeQ156_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_2_VALUE:
    'corporatePerformanceClimateChangeQ156_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_3_VALUE:
    'corporatePerformanceClimateChangeQ156_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_4_VALUE:
    'corporatePerformanceClimateChangeQ156_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_5_VALUE:
    'corporatePerformanceClimateChangeQ156_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_6_VALUE:
    'corporatePerformanceClimateChangeQ156_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_7_VALUE:
    'corporatePerformanceClimateChangeQ156_7_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q157_VALUE:
    'corporatePerformanceClimateChangeQ157_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q158_VALUE:
    'corporatePerformanceClimateChangeQ158_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q158_1_VALUE:
    'corporatePerformanceClimateChangeQ158_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q158_2_VALUE:
    'corporatePerformanceClimateChangeQ158_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q159_VALUE:
    'corporatePerformanceClimateChangeQ159_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q160_VALUE:
    'corporatePerformanceClimateChangeQ160_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q160_1_VALUE:
    'corporatePerformanceClimateChangeQ160_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q160_2_VALUE:
    'corporatePerformanceClimateChangeQ160_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q160_3_VALUE:
    'corporatePerformanceClimateChangeQ160_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q160_4_VALUE:
    'corporatePerformanceClimateChangeQ160_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q160_5_VALUE:
    'corporatePerformanceClimateChangeQ160_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q160_6_VALUE:
    'corporatePerformanceClimateChangeQ160_6_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q161_VALUE:
    'corporatePerformanceClimateChangeQ161_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q162_VALUE:
    'corporatePerformanceClimateChangeQ162_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q162_1_VALUE:
    'corporatePerformanceClimateChangeQ162_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q162_2_VALUE:
    'corporatePerformanceClimateChangeQ162_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q162_3_VALUE:
    'corporatePerformanceClimateChangeQ162_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q162_4_VALUE:
    'corporatePerformanceClimateChangeQ162_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q162_5_VALUE:
    'corporatePerformanceClimateChangeQ162_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q162_6_VALUE:
    'corporatePerformanceClimateChangeQ162_6_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q163_VALUE:
    'corporatePerformanceClimateChangeQ163_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q163_1_VALUE:
    'corporatePerformanceClimateChangeQ163_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q163_2_VALUE:
    'corporatePerformanceClimateChangeQ163_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q164_VALUE:
    'corporatePerformanceClimateChangeQ164_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q164_1_VALUE:
    'corporatePerformanceClimateChangeQ164_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q164_2_VALUE:
    'corporatePerformanceClimateChangeQ164_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q164_3_VALUE:
    'corporatePerformanceClimateChangeQ164_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q164_4_VALUE:
    'corporatePerformanceClimateChangeQ164_4_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_VALUE:
    'corporatePerformanceClimateChangeQ165_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_1_VALUE:
    'corporatePerformanceClimateChangeQ165_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_2_VALUE:
    'corporatePerformanceClimateChangeQ165_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q166_VALUE:
    'corporatePerformanceClimateChangeQ166_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q166_1_VALUE:
    'corporatePerformanceClimateChangeQ166_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q166_2_VALUE:
    'corporatePerformanceClimateChangeQ166_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q166_3_VALUE:
    'corporatePerformanceClimateChangeQ166_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q166_4_VALUE:
    'corporatePerformanceClimateChangeQ166_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q166_5_VALUE:
    'corporatePerformanceClimateChangeQ166_5_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q167_VALUE:
    'corporatePerformanceClimateChangeQ167_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q167_1_VALUE:
    'corporatePerformanceClimateChangeQ167_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q167_2_VALUE:
    'corporatePerformanceClimateChangeQ167_2_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_VALUE:
    'corporatePerformanceClimateChangeQ168_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_1_VALUE:
    'corporatePerformanceClimateChangeQ168_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_2_VALUE:
    'corporatePerformanceClimateChangeQ168_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_3_VALUE:
    'corporatePerformanceClimateChangeQ168_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_4_VALUE:
    'corporatePerformanceClimateChangeQ168_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_5_VALUE:
    'corporatePerformanceClimateChangeQ168_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_6_VALUE:
    'corporatePerformanceClimateChangeQ168_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_7_VALUE:
    'corporatePerformanceClimateChangeQ168_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_8_VALUE:
    'corporatePerformanceClimateChangeQ168_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_9_VALUE:
    'corporatePerformanceClimateChangeQ168_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_10_VALUE:
    'corporatePerformanceClimateChangeQ168_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_11_VALUE:
    'corporatePerformanceClimateChangeQ168_11_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q169_VALUE:
    'corporatePerformanceClimateChangeQ169_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q170_VALUE:
    'corporatePerformanceClimateChangeQ170_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_VALUE:
    'corporatePerformanceClimateChangeQ171_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_1_VALUE:
    'corporatePerformanceClimateChangeQ171_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_2_VALUE:
    'corporatePerformanceClimateChangeQ171_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_3_VALUE:
    'corporatePerformanceClimateChangeQ171_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_4_VALUE:
    'corporatePerformanceClimateChangeQ171_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_5_VALUE:
    'corporatePerformanceClimateChangeQ171_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_6_VALUE:
    'corporatePerformanceClimateChangeQ171_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_7_VALUE:
    'corporatePerformanceClimateChangeQ171_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_8_VALUE:
    'corporatePerformanceClimateChangeQ171_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_9_VALUE:
    'corporatePerformanceClimateChangeQ171_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_10_VALUE:
    'corporatePerformanceClimateChangeQ171_10_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_VALUE:
    'corporatePerformanceClimateChangeQ172_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_1_VALUE:
    'corporatePerformanceClimateChangeQ172_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_2_VALUE:
    'corporatePerformanceClimateChangeQ172_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_3_VALUE:
    'corporatePerformanceClimateChangeQ172_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_4_VALUE:
    'corporatePerformanceClimateChangeQ172_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_5_VALUE:
    'corporatePerformanceClimateChangeQ172_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_6_VALUE:
    'corporatePerformanceClimateChangeQ172_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_7_VALUE:
    'corporatePerformanceClimateChangeQ172_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_8_VALUE:
    'corporatePerformanceClimateChangeQ172_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_9_VALUE:
    'corporatePerformanceClimateChangeQ172_9_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q173_VALUE:
    'corporatePerformanceClimateChangeQ173_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q173_1_VALUE:
    'corporatePerformanceClimateChangeQ173_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q173_2_VALUE:
    'corporatePerformanceClimateChangeQ173_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q173_3_VALUE:
    'corporatePerformanceClimateChangeQ173_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q173_4_VALUE:
    'corporatePerformanceClimateChangeQ173_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q173_5_VALUE:
    'corporatePerformanceClimateChangeQ173_5_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q174_VALUE:
    'corporatePerformanceClimateChangeQ174_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q175_VALUE:
    'corporatePerformanceClimateChangeQ175_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q175_1_VALUE:
    'corporatePerformanceClimateChangeQ175_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q175_2_VALUE:
    'corporatePerformanceClimateChangeQ175_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q175_3_VALUE:
    'corporatePerformanceClimateChangeQ175_3_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q176_VALUE:
    'corporatePerformanceClimateChangeQ176_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_VALUE:
    'corporatePerformanceClimateChangeQ177_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_1_VALUE:
    'corporatePerformanceClimateChangeQ177_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_2_VALUE:
    'corporatePerformanceClimateChangeQ177_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_3_VALUE:
    'corporatePerformanceClimateChangeQ177_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_4_VALUE:
    'corporatePerformanceClimateChangeQ177_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE:
    'corporatePerformanceClimateChangeQ177_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_6_VALUE:
    'corporatePerformanceClimateChangeQ177_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_7_VALUE:
    'corporatePerformanceClimateChangeQ177_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_8_VALUE:
    'corporatePerformanceClimateChangeQ177_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_9_VALUE:
    'corporatePerformanceClimateChangeQ177_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_10_VALUE:
    'corporatePerformanceClimateChangeQ177_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_11_VALUE:
    'corporatePerformanceClimateChangeQ177_11_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_12_VALUE:
    'corporatePerformanceClimateChangeQ177_12_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_13_VALUE:
    'corporatePerformanceClimateChangeQ177_13_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q178_VALUE:
    'corporatePerformanceClimateChangeQ178_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q178_1_VALUE:
    'corporatePerformanceClimateChangeQ178_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q178_2_VALUE:
    'corporatePerformanceClimateChangeQ178_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q178_3_VALUE:
    'corporatePerformanceClimateChangeQ178_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q178_4_VALUE:
    'corporatePerformanceClimateChangeQ178_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q178_5_VALUE:
    'corporatePerformanceClimateChangeQ178_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q178_6_VALUE:
    'corporatePerformanceClimateChangeQ178_6_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q179_VALUE:
    'corporatePerformanceClimateChangeQ179_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_VALUE:
    'corporatePerformanceClimateChangeQ180_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_1_VALUE:
    'corporatePerformanceClimateChangeQ180_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_2_VALUE:
    'corporatePerformanceClimateChangeQ180_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_3_VALUE:
    'corporatePerformanceClimateChangeQ180_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_4_VALUE:
    'corporatePerformanceClimateChangeQ180_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_5_VALUE:
    'corporatePerformanceClimateChangeQ180_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_6_VALUE:
    'corporatePerformanceClimateChangeQ180_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_7_VALUE:
    'corporatePerformanceClimateChangeQ180_7_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q181_VALUE:
    'corporatePerformanceClimateChangeQ181_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_VALUE:
    'corporatePerformanceClimateChangeQ182_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_1_VALUE:
    'corporatePerformanceClimateChangeQ182_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_2_VALUE:
    'corporatePerformanceClimateChangeQ182_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_3_VALUE:
    'corporatePerformanceClimateChangeQ182_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_4_VALUE:
    'corporatePerformanceClimateChangeQ182_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_5_VALUE:
    'corporatePerformanceClimateChangeQ182_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_6_VALUE:
    'corporatePerformanceClimateChangeQ182_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_7_VALUE:
    'corporatePerformanceClimateChangeQ182_7_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q183_VALUE:
    'corporatePerformanceClimateChangeQ183_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q184_VALUE:
    'corporatePerformanceClimateChangeQ184_value',

  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_VALUE:
    'corporatePerformanceClimateChangeQ185_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_1_VALUE:
    'corporatePerformanceClimateChangeQ185_1_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_2_VALUE:
    'corporatePerformanceClimateChangeQ185_2_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_3_VALUE:
    'corporatePerformanceClimateChangeQ185_3_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_4_VALUE:
    'corporatePerformanceClimateChangeQ185_4_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_5_VALUE:
    'corporatePerformanceClimateChangeQ185_5_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_6_VALUE:
    'corporatePerformanceClimateChangeQ185_6_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_7_VALUE:
    'corporatePerformanceClimateChangeQ185_7_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_8_VALUE:
    'corporatePerformanceClimateChangeQ185_8_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_9_VALUE:
    'corporatePerformanceClimateChangeQ185_9_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_10_VALUE:
    'corporatePerformanceClimateChangeQ185_10_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_11_VALUE:
    'corporatePerformanceClimateChangeQ185_11_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_12_VALUE:
    'corporatePerformanceClimateChangeQ185_12_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_13_VALUE:
    'corporatePerformanceClimateChangeQ185_13_value',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_14_VALUE:
    'corporatePerformanceClimateChangeQ185_14_value'
} as const;

export const CDP_FORESTS_KEYS = {
  Q1_VALUE: 'cepForestsQ1_value',
  Q1_1_VALUE: 'cepForestsQ1_1_value',
  Q1_2_VALUE: 'cepForestsQ1_1_value',
  Q2_VALUE: 'cepForestsQ2_value',
  Q2_1_VALUE: 'cepForestsQ2_1_value',
  Q2_2_VALUE: 'cepForestsQ2_2_value',
  Q2_3_VALUE: 'cepForestsQ2_3_value',
  Q2_4_VALUE: 'cepForestsQ2_4_value',
  Q2_5_VALUE: 'cepForestsQ2_5_value',
  Q2_6_VALUE: 'cepForestsQ2_6_value',
  Q2_7_VALUE: 'cepForestsQ2_7_value',
  Q2_8_VALUE: 'cepForestsQ2_8_value',
  Q2_9_VALUE: 'cepForestsQ2_9_value',
  Q2_10_VALUE: 'cepForestsQ2_10_value',
  Q2_11_VALUE: 'cepForestsQ2_11_value',

  Q3_VALUE: 'cepForestsQ3_value',
  Q3_1_VALUE: 'cepForestsQ3_1_value',
  Q3_2_VALUE: 'cepForestsQ3_2_value',
  Q3_3_VALUE: 'cepForestsQ3_3_value',
  Q3_4_VALUE: 'cepForestsQ3_4_value',
  Q3_5_VALUE: 'cepForestsQ3_5_value',

  Q4_VALUE: 'cepForestsQ4_value',
  Q4_1_VALUE: 'cepForestsQ4_1_value',
  Q4_2_VALUE: 'cepForestsQ4_2_value',
  Q4_3_VALUE: 'cepForestsQ4_3_value',
  Q4_4_VALUE: 'cepForestsQ4_4_value',
  Q4_5_VALUE: 'cepForestsQ4_5_value',
  Q4_6_VALUE: 'cepForestsQ4_6_value',
  Q4_7_VALUE: 'cepForestsQ4_7_value',
  Q4_8_VALUE: 'cepForestsQ4_8_value',
  Q4_9_VALUE: 'cepForestsQ4_9_value',
  Q4_10_VALUE: 'cepForestsQ4_10_value',
  Q4_11_VALUE: 'cepForestsQ4_11_value',
  Q4_12_VALUE: 'cepForestsQ4_12_value',

  Q5_VALUE: 'cepForestsQ5_value',
  Q5_1_VALUE: 'cepForestsQ5_1_value',
  Q5_2_VALUE: 'cepForestsQ5_2_value',
  Q5_3_VALUE: 'cepForestsQ5_3_value',
  Q5_4_VALUE: 'cepForestsQ5_4_value',
  Q5_5_VALUE: 'cepForestsQ5_5_value',
  Q5_6_VALUE: 'cepForestsQ5_6_value',
  Q5_7_VALUE: 'cepForestsQ5_7_value',
  Q5_8_VALUE: 'cepForestsQ5_8_value',
  Q5_9_VALUE: 'cepForestsQ5_9_value',
  Q5_10_VALUE: 'cepForestsQ5_10_value',
  Q5_11_VALUE: 'cepForestsQ5_11_value',
  Q5_12_VALUE: 'cepForestsQ5_12_value',

  // Q6
  Q6_VALUE: 'cepForestsQ6_value',

  // Q7
  Q7_VALUE: 'cepForestsQ7_value',
  Q7_1_VALUE: 'cepForestsQ7_1_value',
  Q7_2_VALUE: 'cepForestsQ7_2_value',
  Q7_3_VALUE: 'cepForestsQ7_3_value',
  Q7_4_VALUE: 'cepForestsQ7_4_value',
  Q7_5_VALUE: 'cepForestsQ7_5_value',
  Q7_6_VALUE: 'cepForestsQ7_6_value',

  // Q8
  Q8_VALUE: 'cepForestsQ8_value',
  Q8_1_VALUE: 'cepForestsQ8_1_value',
  Q8_2_VALUE: 'cepForestsQ8_2_value',
  Q8_3_VALUE: 'cepForestsQ8_3_value',
  Q8_4_VALUE: 'cepForestsQ8_4_value',
  Q8_5_VALUE: 'cepForestsQ8_5_value',
  Q8_6_VALUE: 'cepForestsQ8_6_value',
  Q8_7_VALUE: 'cepForestsQ8_7_value',
  Q8_8_VALUE: 'cepForestsQ8_8_value',

  // Q9
  Q9_VALUE: 'cepForestsQ9_value',
  Q9_1_VALUE: 'cepForestsQ9_1_value',
  Q9_2_VALUE: 'cepForestsQ9_2_value',
  Q9_3_VALUE: 'cepForestsQ9_3_value',
  Q9_4_VALUE: 'cepForestsQ9_4_value',
  Q9_5_VALUE: 'cepForestsQ9_5_value',
  Q9_6_VALUE: 'cepForestsQ9_6_value',
  Q9_7_VALUE: 'cepForestsQ9_7_value',
  Q9_8_VALUE: 'cepForestsQ9_8_value',

  // Q10
  Q10_VALUE: 'cepForestsQ10_value',
  Q10_1_VALUE: 'cepForestsQ10_1_value',
  Q10_2_VALUE: 'cepForestsQ10_2_value',
  Q10_3_VALUE: 'cepForestsQ10_3_value',
  Q10_4_VALUE: 'cepForestsQ10_4_value',
  Q10_5_VALUE: 'cepForestsQ10_5_value',
  Q10_6_VALUE: 'cepForestsQ10_6_value',
  Q10_7_VALUE: 'cepForestsQ10_7_value',
  Q10_8_VALUE: 'cepForestsQ10_8_value',

  // Q11
  Q11_VALUE: 'cepForestsQ11_value',
  Q11_1_VALUE: 'cepForestsQ11_1_value',
  Q11_2_VALUE: 'cepForestsQ11_2_value',
  Q11_3_VALUE: 'cepForestsQ11_3_value',
  Q11_4_VALUE: 'cepForestsQ11_4_value',
  Q11_5_VALUE: 'cepForestsQ11_5_value',
  Q11_6_VALUE: 'cepForestsQ11_6_value',
  Q11_7_VALUE: 'cepForestsQ11_7_value',
  Q11_8_VALUE: 'cepForestsQ11_8_value',

  // Q12
  Q12_VALUE: 'cepForestsQ12_value',
  Q12_1_VALUE: 'cepForestsQ12_1_value',
  Q12_2_VALUE: 'cepForestsQ12_2_value',
  Q12_3_VALUE: 'cepForestsQ12_3_value',
  Q12_4_VALUE: 'cepForestsQ12_4_value',
  Q12_5_VALUE: 'cepForestsQ12_5_value',
  Q12_6_VALUE: 'cepForestsQ12_6_value',
  Q12_7_VALUE: 'cepForestsQ12_7_value',

  // Q13
  Q13_VALUE: 'cepForestsQ13_value',
  Q13_1_VALUE: 'cepForestsQ13_1_value',
  Q13_2_VALUE: 'cepForestsQ13_2_value',
  Q13_3_VALUE: 'cepForestsQ13_3_value',
  Q13_4_VALUE: 'cepForestsQ13_4_value',
  Q13_5_VALUE: 'cepForestsQ13_5_value',
  Q13_6_VALUE: 'cepForestsQ13_6_value',
  Q13_7_VALUE: 'cepForestsQ13_7_value',
  Q13_8_VALUE: 'cepForestsQ13_8_value',
  Q13_9_VALUE: 'cepForestsQ13_9_value',
  Q13_10_VALUE: 'cepForestsQ13_10_value',
  Q13_11_VALUE: 'cepForestsQ13_11_value',
  Q13_12_VALUE: 'cepForestsQ13_12_value',
  Q13_13_VALUE: 'cepForestsQ13_13_value',
  Q13_14_VALUE: 'cepForestsQ13_14_value',
  Q13_15_VALUE: 'cepForestsQ13_15_value',
  Q13_16_VALUE: 'cepForestsQ13_16_value',
  Q13_17_VALUE: 'cepForestsQ13_17_value',
  Q13_18_VALUE: 'cepForestsQ13_18_value',
  Q13_19_VALUE: 'cepForestsQ13_19_value',
  Q13_20_VALUE: 'cepForestsQ13_20_value',
  Q13_21_VALUE: 'cepForestsQ13_21_value',

  // Q14
  Q14_VALUE: 'cepForestsQ14_value',
  Q14_1_VALUE: 'cepForestsQ14_1_value',
  Q14_2_VALUE: 'cepForestsQ14_2_value',
  Q14_3_VALUE: 'cepForestsQ14_3_value',
  Q14_4_VALUE: 'cepForestsQ14_4_value',
  Q14_5_VALUE: 'cepForestsQ14_5_value',
  Q14_6_VALUE: 'cepForestsQ14_6_value',

  // Q15
  Q15_VALUE: 'cepForestsQ15_value',
  Q15_1_VALUE: 'cepForestsQ15_1_value',
  Q15_2_VALUE: 'cepForestsQ15_2_value',
  Q15_3_VALUE: 'cepForestsQ15_3_value',
  Q15_4_VALUE: 'cepForestsQ15_4_value',
  Q15_5_VALUE: 'cepForestsQ15_5_value',
  Q15_6_VALUE: 'cepForestsQ15_6_value',
  Q15_7_VALUE: 'cepForestsQ15_7_value',

  // Q16
  Q16_VALUE: 'cepForestsQ16_value',
  Q16_1_VALUE: 'cepForestsQ16_1_value',
  Q16_2_VALUE: 'cepForestsQ16_2_value',
  Q16_3_VALUE: 'cepForestsQ16_3_value',
  Q16_4_VALUE: 'cepForestsQ16_4_value',
  Q16_5_VALUE: 'cepForestsQ16_5_value',
  Q16_6_VALUE: 'cepForestsQ16_6_value',
  Q16_7_VALUE: 'cepForestsQ16_7_value',
  Q16_8_VALUE: 'cepForestsQ16_8_value',
  Q16_9_VALUE: 'cepForestsQ16_9_value',

  // Q17
  Q17_VALUE: 'cepForestsQ17_value',
  Q17_1_VALUE: 'cepForestsQ17_1_value',
  Q17_2_VALUE: 'cepForestsQ17_2_value',
  Q17_3_VALUE: 'cepForestsQ17_3_value',
  Q17_4_VALUE: 'cepForestsQ17_4_value',
  Q17_5_VALUE: 'cepForestsQ17_5_value',

  // Q18
  Q18_VALUE: 'cepForestsQ18_value',
  Q18_1_VALUE: 'cepForestsQ18_1_value',
  Q18_2_VALUE: 'cepForestsQ18_2_value',
  Q18_3_VALUE: 'cepForestsQ18_3_value',
  Q18_4_VALUE: 'cepForestsQ18_4_value',
  Q18_5_VALUE: 'cepForestsQ18_5_value',
  Q18_6_VALUE: 'cepForestsQ18_6_value',

  // Q19
  Q19_VALUE: 'cepForestsQ19_value',
  Q19_1_VALUE: 'cepForestsQ19_1_value',
  Q19_2_VALUE: 'cepForestsQ19_2_value',
  Q19_3_VALUE: 'cepForestsQ19_3_value',
  Q19_4_VALUE: 'cepForestsQ19_4_value',
  Q19_5_VALUE: 'cepForestsQ19_5_value',
  Q19_6_VALUE: 'cepForestsQ19_6_value',
  Q19_7_VALUE: 'cepForestsQ19_7_value',
  Q19_8_VALUE: 'cepForestsQ19_8_value',
  Q19_9_VALUE: 'cepForestsQ19_9_value',

  // Q20
  Q20_VALUE: 'cepForestsQ20_value',
  Q20_1_VALUE: 'cepForestsQ20_1_value',
  Q20_2_VALUE: 'cepForestsQ20_2_value',
  Q20_3_VALUE: 'cepForestsQ20_3_value',
  Q20_4_VALUE: 'cepForestsQ20_4_value',
  Q20_5_VALUE: 'cepForestsQ20_5_value',
  Q20_6_VALUE: 'cepForestsQ20_6_value',
  Q20_7_VALUE: 'cepForestsQ20_7_value',
  Q20_8_VALUE: 'cepForestsQ20_8_value',
  Q20_9_VALUE: 'cepForestsQ20_9_value',
  Q20_10_VALUE: 'cepForestsQ20_10_value',
  Q20_11_VALUE: 'cepForestsQ20_11_value',
  Q20_12_VALUE: 'cepForestsQ20_12_value',
  Q20_13_VALUE: 'cepForestsQ20_13_value',

  // Q21
  Q21_VALUE: 'cepForestsQ21_value',
  Q21_1_VALUE: 'cepForestsQ21_1_value',
  Q21_2_VALUE: 'cepForestsQ21_2_value',
  Q21_3_VALUE: 'cepForestsQ21_3_value',
  Q21_4_VALUE: 'cepForestsQ21_4_value',

  // Q22
  Q22_VALUE: 'cepForestsQ22_value',
  Q22_1_VALUE: 'cepForestsQ22_1_value',
  Q22_2_VALUE: 'cepForestsQ22_2_value',
  Q22_3_VALUE: 'cepForestsQ22_3_value',
  Q22_4_VALUE: 'cepForestsQ22_4_value',
  Q22_5_VALUE: 'cepForestsQ22_5_value',
  Q22_6_VALUE: 'cepForestsQ22_6_value',
  Q22_7_VALUE: 'cepForestsQ22_7_value',
  Q22_8_VALUE: 'cepForestsQ22_8_value',
  Q22_9_VALUE: 'cepForestsQ22_9_value',
  Q22_10_VALUE: 'cepForestsQ22_10_value',

  // Q23
  Q23_VALUE: 'cepForestsQ23_value',
  Q23_1_VALUE: 'cepForestsQ23_1_value',
  Q23_2_VALUE: 'cepForestsQ23_2_value',

  // Q24
  Q24_VALUE: 'cepForestsQ24_value',
  Q24_1_VALUE: 'cepForestsQ24_1_value',
  Q24_2_VALUE: 'cepForestsQ24_2_value',
  Q24_3_VALUE: 'cepForestsQ24_3_value',
  Q24_4_VALUE: 'cepForestsQ24_4_value',
  Q24_5_VALUE: 'cepForestsQ24_5_value',
  Q24_6_VALUE: 'cepForestsQ24_6_value',

  // Q25
  Q25_VALUE: 'cepForestsQ25_value',
  Q25_1_VALUE: 'cepForestsQ25_1_value',
  Q25_2_VALUE: 'cepForestsQ25_2_value',
  Q25_3_VALUE: 'cepForestsQ25_3_value',
  Q25_4_VALUE: 'cepForestsQ25_4_value',
  Q25_5_VALUE: 'cepForestsQ25_5_value',
  Q25_6_VALUE: 'cepForestsQ25_6_value',
  Q25_7_VALUE: 'cepForestsQ25_7_value',

  // Q26
  Q26_VALUE: 'cepForestsQ26_value',
  Q26_1_VALUE: 'cepForestsQ26_1_value',
  Q26_2_VALUE: 'cepForestsQ26_2_value',
  Q26_3_VALUE: 'cepForestsQ26_3_value',
  Q26_4_VALUE: 'cepForestsQ26_4_value',
  Q26_5_VALUE: 'cepForestsQ26_5_value',
  Q26_6_VALUE: 'cepForestsQ26_6_value',
  Q26_7_VALUE: 'cepForestsQ26_7_value',
  Q26_8_VALUE: 'cepForestsQ26_8_value',

  // Q27
  Q27_VALUE: 'cepForestsQ27_value',
  Q27_1_VALUE: 'cepForestsQ27_1_value',
  Q27_2_VALUE: 'cepForestsQ27_2_value',
  Q27_3_VALUE: 'cepForestsQ27_3_value',
  Q27_4_VALUE: 'cepForestsQ27_4_value',

  // Q28
  Q28_VALUE: 'cepForestsQ28_value',
  Q28_1_VALUE: 'cepForestsQ28_1_value',
  Q28_2_VALUE: 'cepForestsQ28_2_value',
  Q28_3_VALUE: 'cepForestsQ28_3_value',
  Q28_4_VALUE: 'cepForestsQ28_4_value',
  Q28_5_VALUE: 'cepForestsQ28_5_value',
  Q28_6_VALUE: 'cepForestsQ28_6_value',
  Q28_7_VALUE: 'cepForestsQ28_7_value',
  Q28_8_VALUE: 'cepForestsQ28_8_value',
  Q28_9_VALUE: 'cepForestsQ28_9_value',

  // Q29
  Q29_VALUE: 'cepForestsQ29_value',
  Q29_1_VALUE: 'cepForestsQ29_1_value',
  Q29_2_VALUE: 'cepForestsQ29_2_value',
  Q29_3_VALUE: 'cepForestsQ29_3_value',
  Q29_4_VALUE: 'cepForestsQ29_4_value',
  Q29_5_VALUE: 'cepForestsQ29_5_value',

  // Q30
  Q30_VALUE: 'cepForestsQ30_value',
  Q30_1_VALUE: 'cepForestsQ30_1_value',
  Q30_2_VALUE: 'cepForestsQ30_2_value',
  Q30_3_VALUE: 'cepForestsQ30_3_value',

  // Q31
  Q31_VALUE: 'cepForestsQ31_value',
  Q31_1_VALUE: 'cepForestsQ31_1_value',
  Q31_2_VALUE: 'cepForestsQ31_2_value',

  // Q32
  Q32_VALUE: 'cepForestsQ32_value',
  Q32_1_VALUE: 'cepForestsQ32_1_value',
  Q32_2_VALUE: 'cepForestsQ32_2_value',
  Q32_3_VALUE: 'cepForestsQ32_3_value',
  Q32_4_VALUE: 'cepForestsQ32_4_value',
  Q32_5_VALUE: 'cepForestsQ32_5_value',
  Q32_6_VALUE: 'cepForestsQ32_6_value',
  Q32_7_VALUE: 'cepForestsQ32_7_value',
  Q32_8_VALUE: 'cepForestsQ32_8_value',
  Q32_9_VALUE: 'cepForestsQ32_9_value',
  Q32_10_VALUE: 'cepForestsQ32_10_value',
  Q32_11_VALUE: 'cepForestsQ32_11_value',
  Q32_12_VALUE: 'cepForestsQ32_12_value',
  Q32_13_VALUE: 'cepForestsQ32_13_value',
  Q32_14_VALUE: 'cepForestsQ32_14_value',
  Q32_15_VALUE: 'cepForestsQ32_15_value',
  Q32_16_VALUE: 'cepForestsQ32_16_value',
  Q32_17_VALUE: 'cepForestsQ32_17_value',
  Q32_18_VALUE: 'cepForestsQ32_18_value',
  Q32_19_VALUE: 'cepForestsQ32_19_value',
  Q32_20_VALUE: 'cepForestsQ32_20_value',

  // Q33
  Q33_VALUE: 'cepForestsQ33_value',
  Q33_1_VALUE: 'cepForestsQ33_1_value',
  Q33_2_VALUE: 'cepForestsQ33_2_value',
  Q33_3_VALUE: 'cepForestsQ33_3_value',
  Q33_4_VALUE: 'cepForestsQ33_4_value',

  // Q34
  Q34_VALUE: 'cepForestsQ34_value',

  // Q35
  Q35_VALUE: 'cepForestsQ35_value',
  Q35_1_VALUE: 'cepForestsQ35_1_value',
  Q35_2_VALUE: 'cepForestsQ35_2_value',
  Q35_3_VALUE: 'cepForestsQ35_3_value',
  Q35_4_VALUE: 'cepForestsQ35_4_value',
  Q35_5_VALUE: 'cepForestsQ35_5_value',

  // Q36
  Q36_VALUE: 'cepForestsQ36_value',

  // Q37
  Q37_VALUE: 'cepForestsQ37_value',
  Q37_1_VALUE: 'cepForestsQ37_1_value',
  Q37_2_VALUE: 'cepForestsQ37_2_value',
  Q37_3_VALUE: 'cepForestsQ37_3_value',
  Q37_4_VALUE: 'cepForestsQ37_4_value',
  Q37_5_VALUE: 'cepForestsQ37_5_value',
  Q37_6_VALUE: 'cepForestsQ37_6_value',
  Q37_7_VALUE: 'cepForestsQ37_7_value',
  Q37_8_VALUE: 'cepForestsQ37_8_value',
  Q37_9_VALUE: 'cepForestsQ37_9_value',
  Q37_10_VALUE: 'cepForestsQ37_10_value',
  Q37_11_VALUE: 'cepForestsQ37_11_value',
  Q37_12_VALUE: 'cepForestsQ37_12_value',

  Q37_13_VALUE: 'cepForestsQ37_13_value',
  Q37_14_VALUE: 'cepForestsQ37_14_value',
  Q37_15_VALUE: 'cepForestsQ37_15_value',
  Q37_16_VALUE: 'cepForestsQ37_16_value',
  Q37_17_VALUE: 'cepForestsQ37_17_value'
} as const;

export const CDP_WATER_SECURITY_KEYS = {
  // Q1
  Q1_VALUE: 'cepWaterSecurityQ1_value',

  // Q2
  Q2_VALUE: 'cepWaterSecurityQ2_value',
  Q2_1_VALUE: 'cepWaterSecurityQ2_1_value',
  Q2_2_VALUE: 'cepWaterSecurityQ2_2_value',
  Q2_3_VALUE: 'cepWaterSecurityQ2_3_value',
  Q2_4_VALUE: 'cepWaterSecurityQ2_4_value',
  Q2_5_VALUE: 'cepWaterSecurityQ2_5_value',
  Q2_6_VALUE: 'cepWaterSecurityQ2_6_value',
  Q2_7_VALUE: 'cepWaterSecurityQ2_7_value',
  Q2_8_VALUE: 'cepWaterSecurityQ2_8_value',

  // Q3
  Q3_VALUE: 'cepWaterSecurityQ3_value',
  Q3_1_VALUE: 'cepWaterSecurityQ3_1_value',
  Q3_2_VALUE: 'cepWaterSecurityQ3_2_value',
  Q3_3_VALUE: 'cepWaterSecurityQ3_3_value',
  Q3_4_VALUE: 'cepWaterSecurityQ3_4_value',
  Q3_5_VALUE: 'cepWaterSecurityQ3_5_value',

  // Q4
  Q4_VALUE: 'cepWaterSecurityQ4_value',
  Q4_1_VALUE: 'cepWaterSecurityQ4_1_value',
  Q4_2_VALUE: 'cepWaterSecurityQ4_2_value',
  Q4_3_VALUE: 'cepWaterSecurityQ4_3_value',

  // Q5
  Q5_VALUE: 'cepWaterSecurityQ5_value',
  Q5_1_VALUE: 'cepWaterSecurityQ5_1_value',
  Q5_2_VALUE: 'cepWaterSecurityQ5_2_value',
  Q5_3_VALUE: 'cepWaterSecurityQ5_3_value',
  Q5_4_VALUE: 'cepWaterSecurityQ5_4_value',
  Q5_5_VALUE: 'cepWaterSecurityQ5_5_value',
  Q5_6_VALUE: 'cepWaterSecurityQ5_6_value',

  // Q6
  Q6_VALUE: 'cepWaterSecurityQ6_value',
  Q6_1_VALUE: 'cepWaterSecurityQ6_1_value',
  Q6_2_VALUE: 'cepWaterSecurityQ6_2_value',
  Q6_3_VALUE: 'cepWaterSecurityQ6_3_value',
  Q6_4_VALUE: 'cepWaterSecurityQ6_4_value',
  Q6_5_VALUE: 'cepWaterSecurityQ6_5_value',
  Q6_6_VALUE: 'cepWaterSecurityQ6_6_value',
  Q6_7_VALUE: 'cepWaterSecurityQ6_7_value',

  // Q7
  Q7_VALUE: 'cepWaterSecurityQ7_value',
  Q7_1_VALUE: 'cepWaterSecurityQ7_1_value',
  Q7_2_VALUE: 'cepWaterSecurityQ7_2_value',
  Q7_3_VALUE: 'cepWaterSecurityQ7_3_value',
  Q7_4_VALUE: 'cepWaterSecurityQ7_4_value',
  Q7_5_VALUE: 'cepWaterSecurityQ7_5_value',
  Q7_6_VALUE: 'cepWaterSecurityQ7_6_value',
  Q7_7_VALUE: 'cepWaterSecurityQ7_7_value',
  Q7_8_VALUE: 'cepWaterSecurityQ7_8_value',
  Q7_9_VALUE: 'cepWaterSecurityQ7_9_value',

  // Q8
  Q8_VALUE: 'cepWaterSecurityQ8_value',
  Q8_1_VALUE: 'cepWaterSecurityQ8_1_value',
  Q8_2_VALUE: 'cepWaterSecurityQ8_2_value',
  Q8_3_VALUE: 'cepWaterSecurityQ8_3_value',
  Q8_4_VALUE: 'cepWaterSecurityQ8_4_value',

  // Q9
  Q9_VALUE: 'cepWaterSecurityQ9_value',
  Q9_1_VALUE: 'cepWaterSecurityQ9_1_value',
  Q9_2_VALUE: 'cepWaterSecurityQ9_2_value',
  Q9_3_VALUE: 'cepWaterSecurityQ9_3_value',
  Q9_4_VALUE: 'cepWaterSecurityQ9_4_value',

  // Q10
  Q10_VALUE: 'cepWaterSecurityQ10_value',
  Q10_1_VALUE: 'cepWaterSecurityQ10_1_value',
  Q10_2_VALUE: 'cepWaterSecurityQ10_2_value',
  Q10_3_VALUE: 'cepWaterSecurityQ10_3_value',
  Q10_4_VALUE: 'cepWaterSecurityQ10_4_value',
  Q10_5_VALUE: 'cepWaterSecurityQ10_5_value',
  Q10_6_VALUE: 'cepWaterSecurityQ10_6_value',

  // Q11
  Q11_VALUE: 'cepWaterSecurityQ11_value',
  Q11_1_VALUE: 'cepWaterSecurityQ11_1_value',
  Q11_2_VALUE: 'cepWaterSecurityQ11_2_value',
  Q11_3_VALUE: 'cepWaterSecurityQ11_3_value',
  Q11_4_VALUE: 'cepWaterSecurityQ11_4_value',
  Q11_5_VALUE: 'cepWaterSecurityQ11_5_value',
  Q11_6_VALUE: 'cepWaterSecurityQ11_6_value',

  // Q12
  Q12_VALUE: 'cepWaterSecurityQ12_value',
  Q12_1_VALUE: 'cepWaterSecurityQ12_1_value',
  Q12_2_VALUE: 'cepWaterSecurityQ12_2_value',
  Q12_3_VALUE: 'cepWaterSecurityQ12_3_value',
  Q12_4_VALUE: 'cepWaterSecurityQ12_4_value',
  Q12_5_VALUE: 'cepWaterSecurityQ12_5_value',
  Q12_6_VALUE: 'cepWaterSecurityQ12_6_value',
  Q12_7_VALUE: 'cepWaterSecurityQ12_7_value',

  // Q13
  Q13_VALUE: 'cepWaterSecurityQ13_value',
  Q13_1_VALUE: 'cepWaterSecurityQ13_1_value',
  Q13_2_VALUE: 'cepWaterSecurityQ13_2_value',
  Q13_3_VALUE: 'cepWaterSecurityQ13_3_value',
  Q13_4_VALUE: 'cepWaterSecurityQ13_4_value',

  // Q14
  Q14_VALUE: 'cepWaterSecurityQ14_value',
  Q14_1_VALUE: 'cepWaterSecurityQ14_1_value',
  Q14_2_VALUE: 'cepWaterSecurityQ14_2_value',
  Q14_3_VALUE: 'cepWaterSecurityQ14_3_value',
  Q14_4_VALUE: 'cepWaterSecurityQ14_4_value',
  Q14_5_VALUE: 'cepWaterSecurityQ14_5_value',

  // Q15
  Q15_VALUE: 'cepWaterSecurityQ15_value',
  Q15_1_VALUE: 'cepWaterSecurityQ15_1_value',
  Q15_2_VALUE: 'cepWaterSecurityQ15_2_value',
  Q15_3_VALUE: 'cepWaterSecurityQ15_3_value',
  Q15_4_VALUE: 'cepWaterSecurityQ15_4_value',
  Q15_5_VALUE: 'cepWaterSecurityQ15_5_value',
  Q15_6_VALUE: 'cepWaterSecurityQ15_6_value',
  Q15_7_VALUE: 'cepWaterSecurityQ15_7_value',
  Q15_8_VALUE: 'cepWaterSecurityQ15_8_value',
  Q15_9_VALUE: 'cepWaterSecurityQ15_9_value',
  Q15_10_VALUE: 'cepWaterSecurityQ15_10_value',
  Q15_11_VALUE: 'cepWaterSecurityQ15_11_value',
  Q15_12_VALUE: 'cepWaterSecurityQ15_12_value',
  Q15_13_VALUE: 'cepWaterSecurityQ15_13_value',
  Q15_14_VALUE: 'cepWaterSecurityQ15_14_value',
  Q15_15_VALUE: 'cepWaterSecurityQ15_15_value',
  Q15_16_VALUE: 'cepWaterSecurityQ15_16_value',
  Q15_17_VALUE: 'cepWaterSecurityQ15_17_value',
  Q15_18_VALUE: 'cepWaterSecurityQ15_18_value',
  Q15_19_VALUE: 'cepWaterSecurityQ15_19_value',
  Q15_20_VALUE: 'cepWaterSecurityQ15_20_value',
  Q15_21_VALUE: 'cepWaterSecurityQ15_21_value',
  Q15_22_VALUE: 'cepWaterSecurityQ15_22_value',
  Q15_23_VALUE: 'cepWaterSecurityQ15_23_value',
  Q15_24_VALUE: 'cepWaterSecurityQ15_24_value',
  Q15_25_VALUE: 'cepWaterSecurityQ15_25_value',
  Q15_26_VALUE: 'cepWaterSecurityQ15_26_value',
  Q15_27_VALUE: 'cepWaterSecurityQ15_27_value',
  Q15_28_VALUE: 'cepWaterSecurityQ15_28_value',
  Q15_29_VALUE: 'cepWaterSecurityQ15_29_value',

  // Q16
  Q16_VALUE: 'cepWaterSecurityQ16_value',
  Q16_1_VALUE: 'cepWaterSecurityQ16_1_value',
  Q16_2_VALUE: 'cepWaterSecurityQ16_2_value',
  Q16_3_VALUE: 'cepWaterSecurityQ16_3_value',
  Q16_4_VALUE: 'cepWaterSecurityQ16_4_value',

  // Q17
  Q17_VALUE: 'cepWaterSecurityQ17_value',

  // Q18
  Q18_VALUE: 'cepWaterSecurityQ18_value',
  Q18_1_VALUE: 'cepWaterSecurityQ18_1_value',
  Q18_2_VALUE: 'cepWaterSecurityQ18_2_value',
  Q18_3_VALUE: 'cepWaterSecurityQ18_3_value',
  Q18_4_VALUE: 'cepWaterSecurityQ18_4_value',
  Q18_5_VALUE: 'cepWaterSecurityQ18_5_value',

  // Q19
  Q19_VALUE: 'cepWaterSecurityQ19_value',
  Q19_1_VALUE: 'cepWaterSecurityQ19_1_value',
  Q19_2_VALUE: 'cepWaterSecurityQ19_2_value',
  Q19_3_VALUE: 'cepWaterSecurityQ19_3_value',

  // Q20
  Q20_VALUE: 'cepWaterSecurityQ20_value',

  // Q21
  Q21_VALUE: 'cepWaterSecurityQ21_value',
  Q21_1_VALUE: 'cepWaterSecurityQ21_1_value',
  Q21_2_VALUE: 'cepWaterSecurityQ21_2_value',
  Q21_3_VALUE: 'cepWaterSecurityQ21_3_value',
  Q21_4_VALUE: 'cepWaterSecurityQ21_4_value',
  Q21_5_VALUE: 'cepWaterSecurityQ21_5_value',
  Q21_6_VALUE: 'cepWaterSecurityQ21_6_value',
  Q21_7_VALUE: 'cepWaterSecurityQ21_7_value',

  // Q22
  Q22_VALUE: 'cepWaterSecurityQ22_value',

  // Q23
  Q23_VALUE: 'cepWaterSecurityQ23_value',
  Q23_1_VALUE: 'cepWaterSecurityQ23_1_value',
  Q23_2_VALUE: 'cepWaterSecurityQ23_2_value',
  Q23_3_VALUE: 'cepWaterSecurityQ23_3_value',
  Q23_4_VALUE: 'cepWaterSecurityQ23_4_value',
  Q23_5_VALUE: 'cepWaterSecurityQ23_5_value',

  // Q24
  Q24_VALUE: 'cepWaterSecurityQ24_value',
  Q24_1_VALUE: 'cepWaterSecurityQ24_1_value',
  Q24_2_VALUE: 'cepWaterSecurityQ24_2_value',
  Q24_3_VALUE: 'cepWaterSecurityQ24_3_value',
  Q24_4_VALUE: 'cepWaterSecurityQ24_4_value',
  Q24_5_VALUE: 'cepWaterSecurityQ24_5_value',
  Q24_6_VALUE: 'cepWaterSecurityQ24_6_value',
  Q24_7_VALUE: 'cepWaterSecurityQ24_7_value',

  // Q25
  Q25_VALUE: 'cepWaterSecurityQ25_value',
  Q25_1_VALUE: 'cepWaterSecurityQ25_1_value',
  Q25_2_VALUE: 'cepWaterSecurityQ25_2_value',
  Q25_3_VALUE: 'cepWaterSecurityQ25_3_value',
  Q25_4_VALUE: 'cepWaterSecurityQ25_4_value',
  Q25_5_VALUE: 'cepWaterSecurityQ25_5_value',
  Q25_6_VALUE: 'cepWaterSecurityQ25_6_value',
  Q25_7_VALUE: 'cepWaterSecurityQ25_7_value',

  // Q26
  Q26_VALUE: 'cepWaterSecurityQ26_value',

  // Q27
  Q27_VALUE: 'cepWaterSecurityQ27_value',
  Q27_1_VALUE: 'cepWaterSecurityQ27_1_value',
  Q27_2_VALUE: 'cepWaterSecurityQ27_2_value',
  Q27_3_VALUE: 'cepWaterSecurityQ27_3_value',
  Q27_4_VALUE: 'cepWaterSecurityQ27_4_value',
  Q27_5_VALUE: 'cepWaterSecurityQ27_5_value',

  // Q28
  Q28_VALUE: 'cepWaterSecurityQ28_value',

  // Q29
  Q29_VALUE: 'cepWaterSecurityQ29_value',
  Q29_1_VALUE: 'cepWaterSecurityQ29_1_value',
  Q29_2_VALUE: 'cepWaterSecurityQ29_2_value',
  Q29_3_VALUE: 'cepWaterSecurityQ29_3_value',
  Q29_4_VALUE: 'cepWaterSecurityQ29_4_value',
  Q29_5_VALUE: 'cepWaterSecurityQ29_5_value',
  Q29_6_VALUE: 'cepWaterSecurityQ29_6_value',

  // Q30
  Q30_VALUE: 'cepWaterSecurityQ30_value',
  Q30_1_VALUE: 'cepWaterSecurityQ30_1_value',
  Q30_2_VALUE: 'cepWaterSecurityQ30_2_value',
  Q30_3_VALUE: 'cepWaterSecurityQ30_3_value',
  Q30_4_VALUE: 'cepWaterSecurityQ30_4_value',
  Q30_5_VALUE: 'cepWaterSecurityQ30_5_value',

  // Q31
  Q31_VALUE: 'cepWaterSecurityQ31_value',
  Q31_1_VALUE: 'cepWaterSecurityQ31_1_value',
  Q31_2_VALUE: 'cepWaterSecurityQ31_2_value',

  // Q32
  Q32_VALUE: 'cepWaterSecurityQ32_value',
  Q32_1_VALUE: 'cepWaterSecurityQ32_1_value',
  Q32_2_VALUE: 'cepWaterSecurityQ32_2_value',
  Q32_3_VALUE: 'cepWaterSecurityQ32_3_value',

  // Q33
  Q33_VALUE: 'cepWaterSecurityQ33_value',
  Q33_1_VALUE: 'cepWaterSecurityQ33_1_value',
  Q33_2_VALUE: 'cepWaterSecurityQ33_2_value',
  Q33_3_VALUE: 'cepWaterSecurityQ33_3_value',
  Q33_4_VALUE: 'cepWaterSecurityQ33_4_value',

  // Q34
  Q34_VALUE: 'cepWaterSecurityQ34_value',

  // Q35
  Q35_VALUE: 'cepWaterSecurityQ35_value',
  Q35_1_VALUE: 'cepWaterSecurityQ35_1_value',
  Q35_2_VALUE: 'cepWaterSecurityQ35_2_value',
  Q35_3_VALUE: 'cepWaterSecurityQ35_3_value',

  // Q36
  Q36_VALUE: 'cepWaterSecurityQ36_value',
  Q36_1_VALUE: 'cepWaterSecurityQ36_1_value',
  Q36_2_VALUE: 'cepWaterSecurityQ36_2_value',
  Q36_3_VALUE: 'cepWaterSecurityQ36_3_value',
  Q36_4_VALUE: 'cepWaterSecurityQ36_4_value',
  Q36_5_VALUE: 'cepWaterSecurityQ36_5_value',
  Q36_6_VALUE: 'cepWaterSecurityQ36_6_value',
  Q36_7_VALUE: 'cepWaterSecurityQ36_7_value',
  Q36_8_VALUE: 'cepWaterSecurityQ36_8_value',
  Q36_9_VALUE: 'cepWaterSecurityQ36_9_value',
  Q36_10_VALUE: 'cepWaterSecurityQ36_10_value',
  Q36_11_VALUE: 'cepWaterSecurityQ36_11_value',
  Q36_12_VALUE: 'cepWaterSecurityQ36_12_value',
  Q36_13_VALUE: 'cepWaterSecurityQ36_13_value',
  Q36_14_VALUE: 'cepWaterSecurityQ36_14_value',
  Q36_15_VALUE: 'cepWaterSecurityQ36_15_value',
  Q36_16_VALUE: 'cepWaterSecurityQ36_16_value',

  // Q37
  Q37_VALUE: 'cepWaterSecurityQ37_value',
  Q37_1_VALUE: 'cepWaterSecurityQ37_1_value',
  Q37_2_VALUE: 'cepWaterSecurityQ37_2_value'
} as const;

export const CDP_PLASTICS_KEYS = {
  Q1_VALUE: 'cepPlasticsQ1_value',
  Q1_1_VALUE: 'cepPlasticsQ1_1_value',
  Q1_2_VALUE: 'cepPlasticsQ1_2_value',
  Q1_3_VALUE: 'cepPlasticsQ1_3_value',

  Q2_VALUE: 'cepPlasticsQ2_value',
  Q2_1_VALUE: 'cepPlasticsQ2_1_value',
  Q2_2_VALUE: 'cepPlasticsQ2_2_value',
  Q2_3_VALUE: 'cepPlasticsQ2_3_value',

  Q3_VALUE: 'cepPlasticsQ3_value',
  Q3_1_VALUE: 'cepPlasticsQ3_1_value',
  Q3_2_VALUE: 'cepPlasticsQ3_2_value',
  Q3_3_VALUE: 'cepPlasticsQ3_3_value',
  Q3_4_VALUE: 'cepPlasticsQ3_4_value',
  Q3_5_VALUE: 'cepPlasticsQ3_5_value',
  Q3_6_VALUE: 'cepPlasticsQ3_6_value',
  Q3_7_VALUE: 'cepPlasticsQ3_7_value',

  Q4_VALUE: 'cepPlasticsQ4_value',
  Q4_1_VALUE: 'cepPlasticsQ4_1_value',
  Q4_2_VALUE: 'cepPlasticsQ4_2_value',
  Q4_3_VALUE: 'cepPlasticsQ4_3_value',
  Q4_4_VALUE: 'cepPlasticsQ4_4_value',
  Q4_5_VALUE: 'cepPlasticsQ4_5_value',
  Q4_6_VALUE: 'cepPlasticsQ4_6_value',
  Q4_7_VALUE: 'cepPlasticsQ4_7_value',
  Q4_8_VALUE: 'cepPlasticsQ4_8_value',

  Q5_VALUE: 'cepPlasticsQ5_value',
  Q5_1_VALUE: 'cepPlasticsQ5_1_value',
  Q5_2_VALUE: 'cepPlasticsQ5_2_value',
  Q5_3_VALUE: 'cepPlasticsQ5_3_value',
  Q5_4_VALUE: 'cepPlasticsQ5_4_value',
  Q5_5_VALUE: 'cepPlasticsQ5_5_value',
  Q5_6_VALUE: 'cepPlasticsQ5_6_value',
  Q5_7_VALUE: 'cepPlasticsQ5_7_value',
  Q5_8_VALUE: 'cepPlasticsQ5_8_value',

  Q6_VALUE: 'cepPlasticsQ6_value',
  Q6_1_VALUE: 'cepPlasticsQ6_1_value',
  Q6_2_VALUE: 'cepPlasticsQ6_2_value',
  Q6_3_VALUE: 'cepPlasticsQ6_3_value',
  Q6_4_VALUE: 'cepPlasticsQ6_4_value',
  Q6_5_VALUE: 'cepPlasticsQ6_5_value',
  Q6_6_VALUE: 'cepPlasticsQ6_6_value',

  Q7_VALUE: 'cepPlasticsQ7_value',
  Q7_1_VALUE: 'cepPlasticsQ7_1_value',
  Q7_2_VALUE: 'cepPlasticsQ7_2_value',
  Q7_3_VALUE: 'cepPlasticsQ7_3_value',
  Q7_4_VALUE: 'cepPlasticsQ7_4_value',
  Q7_5_VALUE: 'cepPlasticsQ7_5_value',
  Q7_6_VALUE: 'cepPlasticsQ7_6_value',
  Q7_7_VALUE: 'cepPlasticsQ7_7_value',
  Q7_8_VALUE: 'cepPlasticsQ7_8_value',
  Q7_9_VALUE: 'cepPlasticsQ7_9_value',
  Q7_10_VALUE: 'cepPlasticsQ7_10_value',
  Q7_11_VALUE: 'cepPlasticsQ7_11_value',
  Q7_12_VALUE: 'cepPlasticsQ7_12_value'
} as const;

export const CDP_FINANCIAL_SERVICES_KEYS = {
  // Q1
  Q1_VALUE: 'cepFinancialServicesQ1_value',
  Q1_1_VALUE: 'cepFinancialServicesQ1_1_value',
  Q1_2_VALUE: 'cepFinancialServicesQ1_2_value',
  Q1_3_VALUE: 'cepFinancialServicesQ1_3_value',
  Q1_4_VALUE: 'cepFinancialServicesQ1_4_value',
  Q1_5_VALUE: 'cepFinancialServicesQ1_5_value',
  Q1_6_VALUE: 'cepFinancialServicesQ1_6_value',
  Q1_7_VALUE: 'cepFinancialServicesQ1_7_value',
  Q1_8_VALUE: 'cepFinancialServicesQ1_8_value',
  Q1_9_VALUE: 'cepFinancialServicesQ1_9_value',
  Q1_10_VALUE: 'cepFinancialServicesQ1_10_value',
  Q1_11_VALUE: 'cepFinancialServicesQ1_11_value',
  Q1_12_VALUE: 'cepFinancialServicesQ1_12_value',
  Q1_13_VALUE: 'cepFinancialServicesQ1_13_value',
  Q1_14_VALUE: 'cepFinancialServicesQ1_14_value',

  // Q2
  Q2_VALUE: 'cepFinancialServicesQ2_value',
  Q2_1_VALUE: 'cepFinancialServicesQ2_1_value',
  Q2_2_VALUE: 'cepFinancialServicesQ2_2_value',
  Q2_3_VALUE: 'cepFinancialServicesQ2_3_value',
  Q2_4_VALUE: 'cepFinancialServicesQ2_4_value',
  Q2_5_VALUE: 'cepFinancialServicesQ2_5_value',
  Q2_6_VALUE: 'cepFinancialServicesQ2_6_value',
  Q2_7_VALUE: 'cepFinancialServicesQ2_7_value',
  Q2_8_VALUE: 'cepFinancialServicesQ2_8_value',
  Q2_9_VALUE: 'cepFinancialServicesQ2_9_value',
  Q2_10_VALUE: 'cepFinancialServicesQ2_10_value',
  Q2_11_VALUE: 'cepFinancialServicesQ2_11_value',
  Q2_12_VALUE: 'cepFinancialServicesQ2_12_value',

  // Q3
  Q3_VALUE: 'cepFinancialServicesQ3_value',
  Q3_1_VALUE: 'cepFinancialServicesQ3_1_value',
  Q3_2_VALUE: 'cepFinancialServicesQ3_2_value',
  Q3_3_VALUE: 'cepFinancialServicesQ3_3_value',
  Q3_4_VALUE: 'cepFinancialServicesQ3_4_value',
  Q3_5_VALUE: 'cepFinancialServicesQ3_5_value',
  Q3_6_VALUE: 'cepFinancialServicesQ3_6_value',
  Q3_7_VALUE: 'cepFinancialServicesQ3_7_value',

  // Q4
  Q4_VALUE: 'cepFinancialServicesQ4_value',
  Q4_1_VALUE: 'cepFinancialServicesQ4_1_value',
  Q4_2_VALUE: 'cepFinancialServicesQ4_2_value',
  Q4_3_VALUE: 'cepFinancialServicesQ4_3_value',
  Q4_4_VALUE: 'cepFinancialServicesQ4_4_value',
  Q4_5_VALUE: 'cepFinancialServicesQ4_5_value',
  Q4_6_VALUE: 'cepFinancialServicesQ4_6_value',
  Q4_7_VALUE: 'cepFinancialServicesQ4_7_value',
  Q4_8_VALUE: 'cepFinancialServicesQ4_8_value',

  // Q5
  Q5_VALUE: 'cepFinancialServicesQ5_value',
  Q5_1_VALUE: 'cepFinancialServicesQ5_1_value',
  Q5_2_VALUE: 'cepFinancialServicesQ5_2_value',
  Q5_3_VALUE: 'cepFinancialServicesQ5_3_value',

  // Q6
  Q6_VALUE: 'cepFinancialServicesQ6_value',
  Q6_1_VALUE: 'cepFinancialServicesQ6_1_value',
  Q6_2_VALUE: 'cepFinancialServicesQ6_2_value',
  Q6_3_VALUE: 'cepFinancialServicesQ6_3_value',
  Q6_4_VALUE: 'cepFinancialServicesQ6_4_value',
  Q6_5_VALUE: 'cepFinancialServicesQ6_5_value',
  Q6_6_VALUE: 'cepFinancialServicesQ6_6_value',
  Q6_7_VALUE: 'cepFinancialServicesQ6_7_value',
  Q6_8_VALUE: 'cepFinancialServicesQ6_8_value',
  Q6_9_VALUE: 'cepFinancialServicesQ6_9_value',
  Q6_10_VALUE: 'cepFinancialServicesQ6_10_value',
  Q6_11_VALUE: 'cepFinancialServicesQ6_11_value',
  Q6_12_VALUE: 'cepFinancialServicesQ6_12_value',

  // Q7
  Q7_VALUE: 'cepFinancialServicesQ7_value',
  Q7_1_VALUE: 'cepFinancialServicesQ7_1_value',
  Q7_2_VALUE: 'cepFinancialServicesQ7_2_value',
  Q7_3_VALUE: 'cepFinancialServicesQ7_3_value',
  Q7_4_VALUE: 'cepFinancialServicesQ7_4_value',
  Q7_5_VALUE: 'cepFinancialServicesQ7_5_value',
  Q7_6_VALUE: 'cepFinancialServicesQ7_6_value',
  Q7_7_VALUE: 'cepFinancialServicesQ7_7_value',
  Q7_8_VALUE: 'cepFinancialServicesQ7_8_value',
  Q7_9_VALUE: 'cepFinancialServicesQ7_9_value',

  Q7_1_VALUE_PORTFOLIO1: 'cepFinancialServicesQ7_1_value_portfolio1',
  Q7_2_VALUE_PORTFOLIO2: 'cepFinancialServicesQ7_2_value_portfolio2',
  Q7_3_VALUE_PORTFOLIO3: 'cepFinancialServicesQ7_3_value_portfolio3',
  Q7_4_VALUE_PORTFOLIO4: 'cepFinancialServicesQ7_4_value_portfolio4',
  Q7_5_VALUE_PORTFOLIO5: 'cepFinancialServicesQ7_5_value_portfolio5',
  Q7_6_VALUE_PORTFOLIO6: 'cepFinancialServicesQ7_6_value_portfolio6',
  Q7_7_VALUE_PORTFOLIO7: 'cepFinancialServicesQ7_7_value_portfolio7',
  Q7_8_VALUE_PORTFOLIO8: 'cepFinancialServicesQ7_8_value_portfolio8',
  Q7_9_VALUE_PORTFOLIO9: 'cepFinancialServicesQ7_9_value_portfolio9',

  // Q8
  Q8_VALUE: 'cepFinancialServicesQ8_value',
  Q8_1_VALUE: 'cepFinancialServicesQ8_1_value',
  Q8_2_VALUE: 'cepFinancialServicesQ8_2_value',
  Q8_3_VALUE: 'cepFinancialServicesQ8_3_value',
  Q8_4_VALUE: 'cepFinancialServicesQ8_4_value',
  Q8_5_VALUE: 'cepFinancialServicesQ8_5_value',
  Q8_6_VALUE: 'cepFinancialServicesQ8_6_value',
  Q8_7_VALUE: 'cepFinancialServicesQ8_7_value',
  Q8_8_VALUE: 'cepFinancialServicesQ8_8_value',
  Q8_9_VALUE: 'cepFinancialServicesQ8_9_value',

  // Q9
  Q9_VALUE: 'cepFinancialServicesQ9_value',
  Q9_1_VALUE: 'cepFinancialServicesQ9_1_value',
  Q9_2_VALUE: 'cepFinancialServicesQ9_2_value',
  Q9_3_VALUE: 'cepFinancialServicesQ9_3_value',
  Q9_4_VALUE: 'cepFinancialServicesQ9_4_value',
  Q9_5_VALUE: 'cepFinancialServicesQ9_5_value',
  Q9_6_VALUE: 'cepFinancialServicesQ9_6_value',
  Q9_7_VALUE: 'cepFinancialServicesQ9_7_value',
  Q9_8_VALUE: 'cepFinancialServicesQ9_8_value',
  Q9_9_VALUE: 'cepFinancialServicesQ9_9_value',
  Q9_10_VALUE: 'cepFinancialServicesQ9_10_value',
  Q9_11_VALUE: 'cepFinancialServicesQ9_11_value',
  Q9_12_VALUE: 'cepFinancialServicesQ9_12_value',
  Q9_13_VALUE: 'cepFinancialServicesQ9_13_value',
  Q9_14_VALUE: 'cepFinancialServicesQ9_14_value',
  Q9_15_VALUE: 'cepFinancialServicesQ9_15_value',
  Q9_16_VALUE: 'cepFinancialServicesQ9_16_value',
  Q9_17_VALUE: 'cepFinancialServicesQ9_17_value',
  Q9_18_VALUE: 'cepFinancialServicesQ9_18_value',
  Q9_19_VALUE: 'cepFinancialServicesQ9_19_value',
  Q9_20_VALUE: 'cepFinancialServicesQ9_20_value',
  Q9_21_VALUE: 'cepFinancialServicesQ9_21_value',
  Q9_22_VALUE: 'cepFinancialServicesQ9_22_value',
  Q9_23_VALUE: 'cepFinancialServicesQ9_23_value',
  Q9_24_VALUE: 'cepFinancialServicesQ9_24_value',
  Q9_25_VALUE: 'cepFinancialServicesQ9_25_value',
  Q9_26_VALUE: 'cepFinancialServicesQ9_26_value',
  Q9_27_VALUE: 'cepFinancialServicesQ9_27_value',
  Q9_28_VALUE: 'cepFinancialServicesQ9_28_value',
  Q9_29_VALUE: 'cepFinancialServicesQ9_29_value',
  Q9_30_VALUE: 'cepFinancialServicesQ9_30_value',
  Q9_31_VALUE: 'cepFinancialServicesQ9_31_value',
  Q9_32_VALUE: 'cepFinancialServicesQ9_32_value',
  Q9_33_VALUE: 'cepFinancialServicesQ9_33_value',
  Q9_34_VALUE: 'cepFinancialServicesQ9_34_value',
  Q9_35_VALUE: 'cepFinancialServicesQ9_35_value',
  Q9_36_VALUE: 'cepFinancialServicesQ9_36_value',
  Q9_37_VALUE: 'cepFinancialServicesQ9_37_value',

  // Q10
  Q10_VALUE: 'cepFinancialServicesQ10_value',
  Q10_1_VALUE: 'cepFinancialServicesQ10_1_value',
  Q10_2_VALUE: 'cepFinancialServicesQ10_2_value',
  Q10_3_VALUE: 'cepFinancialServicesQ10_3_value',

  // Q11
  Q11_VALUE: 'cepFinancialServicesQ11_value',
  Q11_1_VALUE: 'cepFinancialServicesQ11_1_value',
  Q11_2_VALUE: 'cepFinancialServicesQ11_2_value',
  Q11_3_VALUE: 'cepFinancialServicesQ11_3_value',
  Q11_4_VALUE: 'cepFinancialServicesQ11_4_value',
  Q11_5_VALUE: 'cepFinancialServicesQ11_5_value',
  Q11_6_VALUE: 'cepFinancialServicesQ11_6_value',
  Q11_7_VALUE: 'cepFinancialServicesQ11_7_value',
  Q11_8_VALUE: 'cepFinancialServicesQ11_8_value',
  Q11_9_VALUE: 'cepFinancialServicesQ11_9_value',
  Q11_10_VALUE: 'cepFinancialServicesQ11_10_value',
  Q11_11_VALUE: 'cepFinancialServicesQ11_11_value',
  Q11_12_VALUE: 'cepFinancialServicesQ11_12_value',

  // Q12
  Q12_VALUE: 'cepFinancialServicesQ12_value',
  Q12_1_VALUE: 'cepFinancialServicesQ12_1_value',
  Q12_2_VALUE: 'cepFinancialServicesQ12_2_value',

  // Q13
  Q13_VALUE: 'cepFinancialServicesQ13_value',
  Q13_1_VALUE: 'cepFinancialServicesQ13_1_value',
  Q13_2_VALUE: 'cepFinancialServicesQ13_2_value',
  Q13_3_VALUE: 'cepFinancialServicesQ13_3_value',
  Q13_4_VALUE: 'cepFinancialServicesQ13_4_value',
  Q13_5_VALUE: 'cepFinancialServicesQ13_5_value',
  Q13_6_VALUE: 'cepFinancialServicesQ13_6_value',
  Q13_7_VALUE: 'cepFinancialServicesQ13_7_value',
  Q13_8_VALUE: 'cepFinancialServicesQ13_8_value',
  Q13_9_VALUE: 'cepFinancialServicesQ13_9_value',
  Q13_10_VALUE: 'cepFinancialServicesQ13_10_value',
  Q13_11_VALUE: 'cepFinancialServicesQ13_11_value',
  Q13_12_VALUE: 'cepFinancialServicesQ13_12_value',
  Q13_13_VALUE: 'cepFinancialServicesQ13_13_value',
  Q13_14_VALUE: 'cepFinancialServicesQ13_14_value',
  Q13_15_VALUE: 'cepFinancialServicesQ13_15_value',
  Q13_16_VALUE: 'cepFinancialServicesQ13_16_value'
} as const;

export const CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS = {
  Q1_VALUE: 'cepFurtherInformationAndSignOffQ1_value',
  Q1_1_VALUE: 'cepFurtherInformationAndSignOffQ1_1_value',
  Q1_2_VALUE: 'cepFurtherInformationAndSignOffQ1_2_value',
  Q1_3_VALUE: 'cepFurtherInformationAndSignOffQ1_3_value',

  Q2_VALUE: 'cepFurtherInformationAndSignOffQ2_value',
  Q2_1_VALUE: 'cepFurtherInformationAndSignOffQ2_1_value',
  Q2_2_VALUE: 'cepFurtherInformationAndSignOffQ2_2_value',
  Q2_3_VALUE: 'cepFurtherInformationAndSignOffQ2_3_value',
  Q2_4_VALUE: 'cepFurtherInformationAndSignOffQ2_4_value',
  Q2_5_VALUE: 'cepFurtherInformationAndSignOffQ2_5_value',

  Q3_VALUE: 'cepFurtherInformationAndSignOffQ3_value',
  Q3_1_VALUE: 'cepFurtherInformationAndSignOffQ3_1_value',
  Q3_2_VALUE: 'cepFurtherInformationAndSignOffQ3_2_value',

  Q4_VALUE: 'cepFurtherInformationAndSignOffQ4_value',
  Q4_1_VALUE: 'cepFurtherInformationAndSignOffQ4_1_value',
  Q4_2_VALUE: 'cepFurtherInformationAndSignOffQ4_2_value',

  Q5_VALUE: 'cepFurtherInformationAndSignOffQ5_value'
} as const;

export const CDP_BIODIVERSITY_KEYS = {
  Q1_VALUE: 'cepBiodiversityQ1_value',

  Q2_VALUE: 'cepBiodiversityQ2_value',
  Q2_1_VALUE: 'cepBiodiversityQ2_1_value',
  Q2_2_VALUE: 'cepBiodiversityQ2_2_value',
  Q2_3_VALUE: 'cepBiodiversityQ2_3_value',
  Q2_4_VALUE: 'cepBiodiversityQ2_4_value',

  Q3_VALUE: 'cepBiodiversityQ3_value',
  Q3_1_VALUE: 'cepBiodiversityQ3_1_value',
  Q3_2_VALUE: 'cepBiodiversityQ3_2_value',

  Q4_VALUE: 'cepBiodiversityQ4_value',
  Q4_1_VALUE: 'cepBiodiversityQ4_1_value',
  Q4_2_VALUE: 'cepBiodiversityQ4_2_value',

  Q5_VALUE: 'cepBiodiversityQ5_value',
  Q5_1_VALUE: 'cepBiodiversityQ5_1_value',
  Q5_2_VALUE: 'cepBiodiversityQ5_2_value',
  Q5_3_VALUE: 'cepBiodiversityQ5_3_value',

  Q6_VALUE: 'cepBiodiversityQ6_value',
  Q6_1_VALUE: 'cepBiodiversityQ6_1_value',
  Q6_2_VALUE: 'cepBiodiversityQ6_2_value',
  Q6_3_VALUE: 'cepBiodiversityQ6_3_value',
  Q6_4_VALUE: 'cepBiodiversityQ6_4_value',
  Q6_5_VALUE: 'cepBiodiversityQ6_5_value',
  Q6_6_VALUE: 'cepBiodiversityQ6_6_value',
  Q6_7_VALUE: 'cepBiodiversityQ6_7_value',
  Q6_8_VALUE: 'cepBiodiversityQ6_8_value',
  Q6_9_VALUE: 'cepBiodiversityQ6_9_value',
  Q6_10_VALUE: 'cepBiodiversityQ6_10_value',
  Q6_11_VALUE: 'cepBiodiversityQ6_11_value',
  Q6_12_VALUE: 'cepBiodiversityQ6_12_value',

  Q7_VALUE: 'cepBiodiversityQ7_value',
  Q7_1_VALUE: 'cepBiodiversityQ7_1_value',
  Q7_2_VALUE: 'cepBiodiversityQ7_2_value',

  Q8_VALUE: 'cepBiodiversityQ8_value',
  Q8_1_VALUE: 'cepBiodiversityQ8_1_value',
  Q8_2_VALUE: 'cepBiodiversityQ8_2_value',
  Q8_3_VALUE: 'cepBiodiversityQ8_3_value',
  Q8_4_VALUE: 'cepBiodiversityQ8_4_value',
  Q8_5_VALUE: 'cepBiodiversityQ8_5_value',
  Q8_6_VALUE: 'cepBiodiversityQ8_6_value',

  Q9_VALUE: 'cepBiodiversityQ9_value',

  Q10_VALUE: 'cepBiodiversityQ10_value',
  Q10_1_VALUE: 'cepBiodiversityQ10_1_value',
  Q10_2_VALUE: 'cepBiodiversityQ10_2_value',
  Q10_3_VALUE: 'cepBiodiversityQ10_3_value',
  Q10_4_VALUE: 'cepBiodiversityQ10_4_value',
  Q10_5_VALUE: 'cepBiodiversityQ10_5_value',

  Q11_VALUE: 'cepBiodiversityQ11_value',

  Q12_VALUE: 'cepBiodiversityQ12_value',
  Q12_1_VALUE: 'cepBiodiversityQ12_1_value',

  Q13_VALUE: 'cepBiodiversityQ13_value',
  Q13_1_VALUE: 'cepBiodiversityQ13_1_value',
  Q13_2_VALUE: 'cepBiodiversityQ13_2_value',
  Q13_3_VALUE: 'cepBiodiversityQ13_3_value',
  Q13_4_VALUE: 'cepBiodiversityQ13_4_value',
  Q13_5_VALUE: 'cepBiodiversityQ13_5_value',

  Q14_VALUE: 'cepBiodiversityQ14_value',
  Q14_1_VALUE: 'cepBiodiversityQ14_1_value',
  Q14_2_VALUE: 'cepBiodiversityQ14_2_value',

  Q15_VALUE: 'cepBiodiversityQ15_value',
  Q15_1_VALUE: 'cepBiodiversityQ15_1_value',
  Q15_2_VALUE: 'cepBiodiversityQ15_2_value',
  Q15_3_VALUE: 'cepBiodiversityQ15_3_value',
  Q15_4_VALUE: 'cepBiodiversityQ15_4_value',
  Q15_5_VALUE: 'cepBiodiversityQ15_5_value',
  Q15_6_VALUE: 'cepBiodiversityQ15_6_value',
  Q15_7_VALUE: 'cepBiodiversityQ15_7_value',

  Q16_VALUE: 'cepBiodiversityQ16_value',
  Q16_1_VALUE: 'cepBiodiversityQ16_1_value',
  Q16_2_VALUE: 'cepBiodiversityQ16_2_value',
  Q16_3_VALUE: 'cepBiodiversityQ16_3_value',
  Q16_4_VALUE: 'cepBiodiversityQ16_4_value',

  Q17_VALUE: 'cepBiodiversityQ17_value',

  Q18_VALUE: 'cepBiodiversityQ18_value',
  Q18_1_VALUE: 'cepBiodiversityQ18_1_value',
  Q18_2_VALUE: 'cepBiodiversityQ18_2_value',
  Q18_3_VALUE: 'cepBiodiversityQ18_3_value',
  Q18_4_VALUE: 'cepBiodiversityQ18_4_value',
  Q18_5_VALUE: 'cepBiodiversityQ18_5_value',
  Q18_6_VALUE: 'cepBiodiversityQ18_6_value',

  Q19_VALUE: 'cepBiodiversityQ19_value',

  Q20_VALUE: 'cepBiodiversityQ20_value',
  Q20_1_VALUE: 'cepBiodiversityQ20_1_value',
  Q20_2_VALUE: 'cepBiodiversityQ20_2_value',
  Q20_3_VALUE: 'cepBiodiversityQ20_3_value',

  Q21_VALUE: 'cepBiodiversityQ21_value',
  Q21_1_VALUE: 'cepBiodiversityQ21_1_value',
  Q21_2_VALUE: 'cepBiodiversityQ21_2_value',

  Q22_VALUE: 'cepBiodiversityQ22_value',
  Q22_1_VALUE: 'cepBiodiversityQ22_1_value',
  Q22_2_VALUE: 'cepBiodiversityQ22_2_value',
  Q22_3_VALUE: 'cepBiodiversityQ22_3_value',
  Q22_4_VALUE: 'cepBiodiversityQ22_4_value',
  Q22_5_VALUE: 'cepBiodiversityQ22_5_value',
  Q22_6_VALUE: 'cepBiodiversityQ22_6_value',
  Q22_7_VALUE: 'cepBiodiversityQ22_7_value',

  Q23_VALUE: 'cepBiodiversityQ23_value',
  Q23_1_VALUE: 'cepBiodiversityQ23_1_value',
  Q23_2_VALUE: 'cepBiodiversityQ23_2_value',

  Q24_VALUE: 'cepBiodiversityQ24_value',
  Q24_1_VALUE: 'cepBiodiversityQ24_1_value',
  Q24_2_VALUE: 'cepBiodiversityQ24_2_value',
  Q24_3_VALUE: 'cepBiodiversityQ24_3_value',
  Q24_4_VALUE: 'cepBiodiversityQ24_4_value',
  Q24_5_VALUE: 'cepBiodiversityQ24_5_value',
  Q24_6_VALUE: 'cepBiodiversityQ24_6_value',

  Q25_VALUE: 'cepBiodiversityQ25_value',
  Q25_1_VALUE: 'cepBiodiversityQ25_1_value',
  Q25_2_VALUE: 'cepBiodiversityQ25_2_value',

  Q26_VALUE: 'cepBiodiversityQ26_value',
  Q26_1_VALUE: 'cepBiodiversityQ26_1_value',
  Q26_2_VALUE: 'cepBiodiversityQ26_2_value',
  Q26_3_VALUE: 'cepBiodiversityQ26_3_value',
  Q26_4_VALUE: 'cepBiodiversityQ26_4_value',
  Q26_5_VALUE: 'cepBiodiversityQ26_5_value',
  Q26_6_VALUE: 'cepBiodiversityQ26_6_value',
  Q26_7_VALUE: 'cepBiodiversityQ26_7_value',
  Q26_8_VALUE: 'cepBiodiversityQ26_8_value',
  Q26_9_VALUE: 'cepBiodiversityQ26_9_value',
  Q26_10_VALUE: 'cepBiodiversityQ26_10_value',

  Q27_VALUE: 'cepBiodiversityQ27_value',
  Q27_1_VALUE: 'cepBiodiversityQ27_1_value',
  Q27_2_VALUE: 'cepBiodiversityQ27_2_value',

  Q28_VALUE: 'cepBiodiversityQ28_value',
  Q28_1_VALUE: 'cepBiodiversityQ28_1_value',
  Q28_2_VALUE: 'cepBiodiversityQ28_2_value',
  Q28_3_VALUE: 'cepBiodiversityQ28_3_value',
  Q28_4_VALUE: 'cepBiodiversityQ28_4_value',
  Q28_5_VALUE: 'cepBiodiversityQ28_5_value',

  Q29_VALUE: 'cepBiodiversityQ29_value',
  Q29_1_VALUE: 'cepBiodiversityQ29_1_value',
  Q29_2_VALUE: 'cepBiodiversityQ29_2_value',

  Q30_VALUE: 'cepBiodiversityQ30_value',
  Q30_1_VALUE: 'cepBiodiversityQ30_1_value',
  Q30_2_VALUE: 'cepBiodiversityQ30_2_value',
  Q30_3_VALUE: 'cepBiodiversityQ30_3_value',
  Q30_4_VALUE: 'cepBiodiversityQ30_4_value',

  Q31_VALUE: 'cepBiodiversityQ31_value',
  Q31_1_VALUE: 'cepBiodiversityQ31_1_value',
  Q31_2_VALUE: 'cepBiodiversityQ31_2_value',

  Q32_VALUE: 'cepBiodiversityQ32_value',
  Q32_1_VALUE: 'cepBiodiversityQ32_1_value',
  Q32_2_VALUE: 'cepBiodiversityQ32_2_value',
  Q32_3_VALUE: 'cepBiodiversityQ32_3_value',
  Q32_4_VALUE: 'cepBiodiversityQ32_4_value',
  Q32_5_VALUE: 'cepBiodiversityQ32_5_value',
  Q32_6_VALUE: 'cepBiodiversityQ32_6_value',

  Q33_VALUE: 'cepBiodiversityQ33_value',

  Q34_VALUE: 'cepBiodiversityQ34_value',
  Q34_1_VALUE: 'cepBiodiversityQ34_1_value',
  Q34_2_VALUE: 'cepBiodiversityQ34_2_value',
  Q34_3_VALUE: 'cepBiodiversityQ34_3_value',

  Q35_VALUE: 'cepBiodiversityQ35_value',

  Q36_VALUE: 'cepBiodiversityQ36_value',
  Q36_1_VALUE: 'cepBiodiversityQ36_1_value',
  Q36_2_VALUE: 'cepBiodiversityQ36_2_value',
  Q36_3_VALUE: 'cepBiodiversityQ36_3_value'
} as const;
